function isScrollableTouchTarget(target) {
  if (!target || typeof target.closest !== 'function') {
    return false;
  }

  return target.closest('[data-scrollable]') !== null;
}

var bodyScrollLockOptions = {
  // `html { scrollbar-gutter: stable }` (base.css) already reserves the scrollbar
  // space, so letting body-scroll-lock add its own padding-right would double the
  // compensation and shift the layout left when a drawer (e.g. the cart) opens.
  reserveScrollBarGap: false,
  allowTouchMove: isScrollableTouchTarget,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(true, true);

//use this for all popups
class Popup {
  constructor() {
    // Use a delegate for event handling on document.body.
    this.delegateBody = new Delegate(document.body);
    // Maintain a stack of active popups.
    this.activePopups = [];
    this.onPopupOpen = null;
    this.onPopupClose = null;
    this.bindEvents();
  }

  bindEvents() {
    // Bind a listener for clicks on toggle buttons.
    this.delegateBody.on(
      'click',
      '[data-action="toggle-popup"]',
      this.handleOpenOptions.bind(this)
    );

    // Listen for the custom "drawer:close-other" event to close all open popups.
    this.delegateBody.on(
      'drawer:close-other',
      this.handleDrawerCloseOther.bind(this)
    );

    this.delegateBody.on(
      'edit-img:open-popup',
      this.handleOpenOptions.bind(this)
    );

    // Bind keydown directly on the delegate element so it fires only once.
    this.delegateBody.on('keydown', this.handleEscape.bind(this));
  }

  // This method is called when a toggle button is clicked.
  handleOpenOptions(event) {
    event.stopPropagation();
    event.preventDefault();

    dynamicVars.syncHeight();
    const toggleButton = event.target.closest('[data-action="toggle-popup"]');
    if (toggleButton) {
      this.togglePopup(toggleButton);
      return;
    }

    // If a click occurs on the overlay of the top-most popup, close that popup.
    if (this.activePopups.length) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      const overlay = this.getOverlayElement(topPopup);
      if (overlay && overlay.contains(event.target)) {
        this.closePopup(topPopup);
      }
    }
  }

  // Handle keydown events.
  // Only close the top-most popup when Esc is pressed.
  handleEscape(event) {
    if (event.key === 'Escape' && this.activePopups.length) {
      event.preventDefault();
      event.stopPropagation();
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if (topPopup.querySelector('[data-action="toggle-popup"]')) {
        topPopup.querySelector('[data-action="toggle-popup"]').click();
      } else {
        this.closePopup(topPopup);
      }

    }
  }

  // Toggle the popup associated with the given button.
  togglePopup(button) {
    const popupId = button.getAttribute('aria-controls');
    if (!popupId) return;

    const popupElement = document.getElementById(popupId);
    if (!popupElement) return;

    // Determine if this popup should be treated as a child popup.
    const isChild = button.getAttribute('data-child-popup') === 'true';

    // If the popup is already open, close it; otherwise, open it.
    if (popupElement.getAttribute('aria-hidden') === 'false') {
      this.closePopup(popupElement);
    } else {
      this.openPopup(popupElement, isChild);
    }
  }

  // Open the popup element.
  // If it's not a child popup, close all currently open popups.
  openPopup(popupElement, isChild = false) {

    // Close drawers and search when a popup opens
    if (window.Drawer && Drawer.active) Drawer.active.closeDrawer();
    const search = document.querySelector('#quickSearch');
    if (search?.getAttribute('aria-expanded') === 'true') {
      search.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));
    }

    // Mark the popup element as a child (or not) for later checks.
    popupElement._isChild = isChild;

    // If this is a parent popup, close any other open popups.
    if (!isChild) {
      while (this.activePopups.length) {
        this._closePopup(this.activePopups.pop());
      }
    }

    // Show the popup element and start animation
    // Ensure display is properly reset from previous close
    popupElement.style.display = 'flex';

    // Force reflow to ensure display is applied
    popupElement.offsetHeight;

    // Reset any previous close animation styles and flags
    popupElement.style.transform = '';
    popupElement.style.opacity = '';
    popupElement.style.visibility = '';
    popupElement.style.pointerEvents = '';
    popupElement._isClosing = false;
    popupElement._isOpening = true;

    // Set attributes for open state
    popupElement.setAttribute('aria-hidden', 'false');
    popupElement.removeAttribute('inert');

    // Apply open animation styles based on device type
    requestAnimationFrame(() => {
      // Detect if mobile (max-width: 1025px)
      const isMobile = window.matchMedia('(max-width: 1025px)').matches;

      if (popupElement.classList.contains('Popup--from-right')) {
        if (isMobile) {
          popupElement.style.transform = 'translateY(0)';
        } else {
          popupElement.style.transform = 'translateX(0)';
        }
      }

      popupElement.style.opacity = '1';
      popupElement.style.visibility = 'visible';
      popupElement.style.pointerEvents = 'all';

      popupElement.setAttribute('aria-expanded', 'true');
      this.updateToggleAria(popupElement, true);

      // Listen for transitionstart to mark opening as complete
      const transitionStartHandler = (event) => {
        if (event.target === popupElement &&
          (event.propertyName === 'transform' || event.propertyName === 'opacity')) {
       
        }
      };

      const transitionEndHandler = (event) => {
        if (event.target === popupElement &&
          (event.propertyName === 'transform' || event.propertyName === 'opacity')) {
          popupElement._isOpening = false;
          popupElement.removeEventListener('transitionstart', transitionStartHandler);
          popupElement.removeEventListener('transitionend', transitionEndHandler);
          
        }
      };

      popupElement.addEventListener('transitionstart', transitionStartHandler);
      popupElement.addEventListener('transitionend', transitionEndHandler);

      if (typeof this.onPopupOpen === 'function') {
        this.onPopupOpen(popupElement);
      }
    });

    // Store the scrollable element reference on the popup for later use.
    const focus = popupElement.querySelector('[data-scrollable]');
    if (focus) {
      popupElement._scrollableElement = focus;
    }

    trapFocus(popupElement);
    // If the popup specifies an overlay, find it, display it, and attach a click listener.
    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.add('is-visible');
      const handleOverlayClick = (e) => {
        e.preventDefault();
        this.closePopup(popupElement);
      };
      // Store the handler so it can be removed later.
      popupElement._overlayClickHandler = handleOverlayClick;
      overlay.addEventListener('click', handleOverlayClick);
    }

    document.body.dispatchEvent(new CustomEvent('popup:close-drawer', { bubbles: true }));

    // Re-apply popup scroll lock after drawer-close handlers,
    // because some drawer flows call clearAllBodyScrollLocks().
    if (popupElement._scrollableElement) {
      bodyScrollLock.disableBodyScroll(popupElement._scrollableElement, bodyScrollLockOptions);
    }
    document.body.classList.add("scrollLock");

    if (popupElement.id === 'notify-me-popup') {
      popupElement._isOpening = false;
      popupElement.setAttribute('aria-visible', 'true');
    }

    // Push this popup onto the active stack.
    this.activePopups.push(popupElement);
  }

  // Close the popup element.
  closePopup(popupElement) {
    if (popupElement.id === 'notify-me-popup') {
      const notifyHost = document.querySelector('notify-me-popup');
      if (notifyHost && typeof notifyHost.closeNotifyPopup === 'function') {
        notifyHost.closeNotifyPopup();
      }
      return;
    }

    const index = this.activePopups.indexOf(popupElement);
    if (index !== -1) {
      // Save the scrollable element from the popup being closed.
      const closedScrollEl = popupElement._scrollableElement;
      if (!this._closePopup(popupElement)) {
        return;
      }
      this.activePopups.splice(index, 1);

      // If there is a new top popup, check for its scrollable element.
      if (this.activePopups.length > 0) {
        const topPopup = this.activePopups[this.activePopups.length - 1];
        if (topPopup._scrollableElement) {
          // Reapply the scroll lock to the new top popup's scrollable element.
          bodyScrollLock.disableBodyScroll(topPopup._scrollableElement, bodyScrollLockOptions);
        }
      } else {
        // No active popups remain; remove the scroll lock from the closed element.
        if (closedScrollEl) {
          bodyScrollLock.enableBodyScroll(closedScrollEl);
        }
        document.body.classList.remove("scrollLock");
      }
    }
  }


  // Internal method to remove open styles and attributes from the popup,
  // then wait for the transition to finish before setting display: none.
  _closePopup(popupElement) {
    // Don't close if popup is still opening
    if (popupElement._isOpening) {
      return false;
    }

    popupElement.setAttribute('aria-expanded', 'false');
    this.updateToggleAria(popupElement, false);

    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.remove('is-visible');
      if (popupElement._overlayClickHandler) {
        overlay.removeEventListener('click', popupElement._overlayClickHandler);
        delete popupElement._overlayClickHandler;
      }
    }

    removeTrapFocus(popupElement);

    // Mark popup as closing
    popupElement._isClosing = true;

    // Detect if mobile (max-width: 1025px)
    const isMobile = window.matchMedia('(max-width: 1025px)').matches;

    // Apply close animation styles based on device type
    if (popupElement.classList.contains('Popup--from-right')) {
      if (isMobile) {
        popupElement.style.transform = 'translateY(100%)';
      } else {
        popupElement.style.transform = 'translateX(100%)';
      }
    }

    popupElement.style.opacity = '0';
    popupElement.style.visibility = 'hidden';
    popupElement.style.pointerEvents = 'none';

    const finishClose = () => {
      popupElement.setAttribute('aria-hidden', 'true');
      popupElement.setAttribute('inert', '');
      // Reset inline styles to let CSS take over BEFORE setting display: none
      popupElement.style.transform = '';
      popupElement.style.opacity = '';
      popupElement.style.visibility = '';
      popupElement.style.pointerEvents = '';
      // Set display: none after animation for performance
      popupElement.style.display = 'none';
      // Clear closing flag
      popupElement._isClosing = false;
      // Trigger the close callback after the animation ends.
      if (typeof this.onPopupClose === 'function') {
        this.onPopupClose(popupElement);
      }
    };

    // Listen for transitionstart event
    const transitionStartHandler = (event) => {
      if (event.target === popupElement &&
        (event.propertyName === 'transform' || event.propertyName === 'opacity')) {
        
      }
    };

    // Listen for transitionend event
    const transitionEndHandler = (event) => {
      // Only respond to transform and opacity transitions on this element during closing
      if (event.target === popupElement && popupElement._isClosing &&
        (event.propertyName === 'transform' || event.propertyName === 'opacity')) {
        popupElement.removeEventListener('transitionstart', transitionStartHandler);
        popupElement.removeEventListener('transitionend', transitionEndHandler);
        console.log('Closing animation completed:', event.propertyName);
        finishClose();
      }
    };

    // Fallback timeout in case transitionend doesn't fire (keep as safety net)
    const fallbackTimeout = setTimeout(() => {
      popupElement.removeEventListener('transitionstart', transitionStartHandler);
      popupElement.removeEventListener('transitionend', transitionEndHandler);
      console.log('Closing animation fallback triggered');
      finishClose();
    }, 500); // 500ms fallback timeout

    // Clear fallback if transitionend fires
    const wrappedTransitionEndHandler = (event) => {
      clearTimeout(fallbackTimeout);
      transitionEndHandler(event);
    };

    popupElement.addEventListener('transitionstart', transitionStartHandler);
    popupElement.addEventListener('transitionend', wrappedTransitionEndHandler);
    return true;
  }

  updateToggleAria(popupElement, isExpanded) {
    const popupId = popupElement.id;
    if (!popupId) return;
    const attrValue = isExpanded ? 'true' : 'false';
    document.querySelectorAll(`[aria-controls="${popupId}"]`).forEach((toggle) => {
      toggle.setAttribute('aria-expanded', attrValue);
    });
  }

  // Method to handle the custom event "drawer:close-other".
  // It closes all currently open popups.
  handleDrawerCloseOther(event) {
    event.preventDefault();
    this.closeAllPopups();
  }

  // Method to close all open popups.
  closeAllPopups() {
    while (this.activePopups.length) {
      const popup = this.activePopups.pop();
      this._closePopup(popup);
    }
  }

  // Retrieve the overlay element based on the popup's data-overlay attribute.
  getOverlayElement(popupElement) {
    const overlayClass = popupElement.getAttribute('data-overlay');
    if (overlayClass) {
      return document.querySelector(`.${overlayClass}`);
    }
    return null;
  }
}

window.globalPopup = new Popup();


class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".ProductSliderCell--Zoom",
      (e) => {
        console.log("🔍 Zoom clicked — launching PhotoSwipe");
        this.initPhotoSwipeFromImageClick(e, e.target.closest(".ProductSliderCell--Zoom"));
      }
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index_currentSlide].querySelector('.ProductSlider--Element').getAttribute(
        'data-image-position'
      )
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }



    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    // if (responsive.matchesBreakpoint('pocket')) {
    // return;
    // }

    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (item.classList.contains('ProductSliderCell--Zoom') && item.querySelector('img')) {
        images.push(item.querySelector('img'));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(target.querySelector('.ProductSlider--Element').getAttribute('data-image-position'));

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(this.createPhotoSwipeItemsFromImages(images), imagePosition);
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = responsive.matchesBreakpoint("phone")
          ? 1200
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        // initialZoomLevel: 0.65,
        src: image.dataset.originalSrc
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "fit",
        counterEl: true,
        getVerticalMarginFn: () => ({ top: 80, bottom: 80 }),
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    window.pswp = this.photoSwipeInstance;


    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen('close', this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }

    const originalClose = this.photoSwipeInstance.close.bind(this.photoSwipeInstance);

    this.photoSwipeInstance.close = () => {
      const pswp = document.querySelector('.pswp');
      if (!pswp) {
        originalClose();
        return;
      }
      if (pswp.classList.contains('pswp--closing')) {
        return;
      }

      pswp.classList.add('pswp--closing');

      setTimeout(() => {
        originalClose();
      }, 450);
    };




    // grab the pswp container
    const counterEl = photoswipeContainer.querySelector(".pswp__counter");

    // if you don't have one in your DOM, create and append it
    if (!counterEl) {
      const newCounter = document.createElement("div");
      newCounter.className = "pswp__counter";
      photoswipeContainer.querySelector(".pswp__ui").appendChild(newCounter);
    }

    // define updater
    const updateCounter = () => {
      const curr = this.photoSwipeInstance.getCurrentIndex() + 1;
      const total = items.length;
      photoswipeContainer.querySelector(".pswp__counter").textContent = `${curr} / ${total}`;
    };

    // update on init and slide change
    this.photoSwipeInstance.listen("afterChange", updateCounter);
    this.photoSwipeInstance.listen("initialZoomInEnd", updateCounter);

    this.photoSwipeInstance.listen('beforeChange', function () {
      const currSlide = this.currItem && this.currItem.container;
      if (!currSlide) return;   // <— prevents the crash

      currSlide.style.transition = 'opacity 0.4s ease';
      currSlide.style.opacity = 0;

      requestAnimationFrame(() => {
        currSlide.style.opacity = 1;
      });
    });



    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    const prevBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--prev");
    const nextBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--next");

    // Prev button
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      prevBtn.setAttribute("disabled", "disabled");
      prevBtn.style.display = "none";   // hide when disabled
    } else {
      prevBtn.removeAttribute("disabled");
      prevBtn.style.display = "flex";   // show when enabled
    }

    // Next button
    if (this.photoSwipeInstance.getCurrentIndex() + 1 === this.photoSwipeInstance.options.getNumItemsFn()) {
      nextBtn.setAttribute("disabled", "disabled");
      nextBtn.style.display = "none";   // hide when disabled
    } else {
      nextBtn.removeAttribute("disabled");
      nextBtn.style.display = "flex";   // show when enabled
    }
  }


  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

let globalDropdownLock = false;
class RevolutionSelectbox {
  // -------------------------------------------------------------------
  // Static registry + helpers
  // -------------------------------------------------------------------
  static instances = new Set();

  /** Close every instance, regardless of open/closed state. */
  static closeAll() {
    for (let inst of RevolutionSelectbox.instances) {
      inst.closeDropdown(inst.mainButton);
    }
  }

  /**
   * Close all instances except the one passed in.
   * Useful before opening a specific instance.
   */
  static closeAllExcept(current) {
    for (let inst of RevolutionSelectbox.instances) {
      if (inst !== current) {
        inst.closeDropdown(inst.mainButton);
      }
    }
  }

  // -------------------------------------------------------------------
  // Constructor & lifecycle
  // -------------------------------------------------------------------
  constructor(element, popover = false, additionalOverlay = false) {
    this.wrapper = element;  // the root DOM node
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.wrapper);
    this.delegateBody = new Delegate(document.body);
    this.isAnimating = false;
    this.isOpen = false;

    // global close events
    this.delegateBody.on('drawer:close-other', this.closeDropdown.bind(this));
    this.delegateBody.on('menu:open', this.closeDropdown.bind(this));
    window.addEventListener('click', this.onClickOutside.bind(this));

    this.mainButton = this.wrapper.querySelector('.RevolutionSelectbox--Button');
    this.contentWrapper = this.wrapper.querySelector('.RevolutionSelectbox--Content');

    if (this.popover) {
      this.contentWrapper.classList.replace(
        'RevolutionSelectbox--animation',
        'PopoverContent'
      );
      this.pageOverlayElement = document.querySelector(
        this.changeOverlay ? '.localizationOverlay' : '.pageOverlay'
      );
    }

    this.bindEvents();

    if (!this.wrapper.classList.contains('dropdownSelector')) {
      this.initSelectbox();
    } else {
      this.wrapper.style.display = 'block';
    }

    // register instance
    RevolutionSelectbox.instances.add(this);
  }

  /** Call when removing the widget from DOM to avoid memory leaks */
  destroy() {
    RevolutionSelectbox.instances.delete(this);
    // unbind any other listeners here…
  }

  // -------------------------------------------------------------------
  // Event binding & init
  // -------------------------------------------------------------------
  bindEvents() {
    this.domDelegate.on(
      'click',
      '[data-action=toggle-selectbox]',
      this.toggleDropdown.bind(this)
    );
    this.domDelegate.on(
      'click',
      '[data-action=selectbox-change]',
      this.selectboxChange.bind(this)
    );
    this.domDelegate.on(
      'click',
      '[data-action=selectbox-submit]',
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      'keypress',
      '[data-action=selectbox-submit]',
      this.selectboxSubmit.bind(this)
    );
  }

  initSelectbox() {
    const selectedItem = this.wrapper.querySelector('[selected]');
    const titleElem = this.wrapper.querySelector('.RevolutionSelectbox--Title');

    const titleCountryElem = titleElem.querySelector(".RevolutionSelectbox--Title--country");
    const titleCurrencyElem = titleElem.querySelector(".RevolutionSelectbox--Title--currency");

    if (selectedItem && titleCountryElem && titleCurrencyElem) {
      titleCountryElem.textContent = selectedItem.getAttribute('data-name');
      titleCurrencyElem.textContent = `(${selectedItem.getAttribute('data-currency')})`;
    }
    this.wrapper.style.display = 'block';
  }

  // -------------------------------------------------------------------
  // Dropdown open/close
  // -------------------------------------------------------------------
  toggleDropdown(event) {
    event.preventDefault();

    if (this.isAnimating) return;
    this.isOpen
      ? this.closeDropdown(event.currentTarget)
      : this.openDropdown(event.currentTarget);
  }

  async openDropdown() {
    if (this.isAnimating || this.isOpen || globalDropdownLock) return;

    // Wait for other dropdowns to fully close first
    RevolutionSelectbox.closeAllExcept(this);

    this.isAnimating = true;
    globalDropdownLock = true;

    const button = this.wrapper.querySelector('.RevolutionSelectbox--Button');
    const content = this.wrapper.querySelector('.RevolutionSelectbox--Content');
    if (!content) return;

    button.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');

    content.classList.add('rs-animating');
    content.style.display = 'block';
    content.style.height = '0px';
    void content.offsetHeight;

    let targetHeight = Math.min(content.scrollHeight, 300);
    content.style.height = targetHeight + 'px';
    content.classList.add('rs-open');

    return new Promise(resolve => {
      const cleanup = () => {
        content.style.height = '';
        content.classList.remove('rs-animating');
        content.removeEventListener('transitionend', onEnd);
        this.isAnimating = false;
        this.isOpen = true;
        globalDropdownLock = false;

        const scrollable = this.wrapper.querySelector('[data-scrollable]');
        if (scrollable) {
          // Ensure iOS scrolling works properly
          scrollable.style.webkitOverflowScrolling = 'touch';
          scrollable.style.touchAction = 'pan-y';
          scrollable.style.overflowY = 'auto';

          // Use bodyScrollLock with the fixed global options
          bodyScrollLock.disableBodyScroll(scrollable, bodyScrollLockOptions);
        }

        resolve();
      };

      const onEnd = e => {
        if (e.propertyName === 'height') cleanup();
      };

      content.addEventListener('transitionend', onEnd);
      setTimeout(cleanup, 350);
    });
  }

  closeDropdown() {
    if (!this.isOpen || this.isAnimating) return Promise.resolve();
    this.isAnimating = true;
    globalDropdownLock = true; // lock globally

    const button = this.wrapper.querySelector('.RevolutionSelectbox--Button');
    const content = this.wrapper.querySelector('.RevolutionSelectbox--Content');
    if (!content) return Promise.resolve();

    button.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');

    content.classList.add('rs-animating');
    const startHeight = content.scrollHeight;
    content.style.height = startHeight + 'px';
    void content.offsetHeight;
    content.style.height = '0px';
    content.classList.remove('rs-open');

    return new Promise(resolve => {
      const cleanup = () => {
        content.style.display = 'none';
        content.style.height = '';
        content.classList.remove('rs-animating');
        content.removeEventListener('transitionend', onEnd);
        this.isAnimating = false;
        this.isOpen = false;
        globalDropdownLock = false; // unlock globally
        resolve();
      };

      const onEnd = e => {
        if (e.propertyName === 'height') cleanup();
      };

      content.addEventListener('transitionend', onEnd);
      setTimeout(cleanup, 350); // fallback
    });
  }


  // -------------------------------------------------------------------
  // Selection logic
  // -------------------------------------------------------------------
  selectboxChange(event) {
    const item = event.target.closest(".RevolutionSelectbox--Item");
    const value = event.target.getAttribute('data-value');
    const selectboxID = event.target.getAttribute('data-selectboxid');
    const innerHTML = event.target.innerHTML;
    const selEl = this.wrapper.querySelector('#' + selectboxID);
    const countryText = item.dataset.name;
    const currencyText = item.dataset.currency;

    this.mainButton.querySelector('.RevolutionSelectbox--Title').innerHTML = innerHTML;
    this.mainButton.querySelector('.revolution-selectbox__flag')?.remove();

    const prev = this.wrapper.querySelector('.RevolutionSelectbox--Item[selected]');
    prev?.removeAttribute('selected');
    event.target.setAttribute('selected', 'selected');

    if (selEl.nodeName === 'SELECT') {
      selEl.value = value;
      selEl.dispatchEvent(new Event('change'));
    } else {
      selEl.value = value;
    }

    // update button text
    const wrapper = this.mainButton.querySelector(".country-flag--wrapper");
    const title = this.mainButton.querySelector(".RevolutionSelectbox--Title");

    const titleCountryElem = title.querySelector(".RevolutionSelectbox--Title--country");
    const titleCurrencyElem = title.querySelector(".RevolutionSelectbox--Title--currency");

    if (titleCountryElem && titleCurrencyElem) {
      titleCountryElem.textContent = countryText;
      titleCurrencyElem.textContent = `(${currencyText})`;
    }

    // swap flag
    if (wrapper) wrapper.querySelector(".revolution-selectbox__flag")?.remove();
    const flag = item.querySelector(".revolution-selectbox__flag");
    if (flag) wrapper.insertBefore(flag.cloneNode(true), title);

    if (selectboxID === 'country-selector__country-code') {
      this.wrapper.dispatchEvent(
        new CustomEvent('change:countrySelector', {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.value,
            languages: event.target.dataset.languages,
          },
        })
      );
    }

    this.closeDropdown(this.mainButton);
  }

  selectboxSubmit(event) {
    if (event.key && event.key !== 'Enter') return;
    const item = event.target.closest('[data-value]');
    const value = item.getAttribute('data-value');
    const dataName = item.getAttribute('data-name');

    this.selectbox.value = value;
    this.closeDropdown(this.mainButton);
    this.mainButton.querySelector('.RevolutionSelectbox--Title').innerHTML = dataName;
    this.selectbox.parentElement.submit();
  }

  onClickOutside(event) {
    if (
      !this.wrapper.contains(event.target) ||
      event.target.classList.contains('FiltersDesktopWrapper')
    ) {
      this.closeDropdown(this.mainButton);
    }
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  attachColorLineItemProperty(formElement, serialized) {
    const colorLabel = formElement?.closest("[data-color-label]")?.dataset?.colorLabel;
    if (!colorLabel) return;

    if (!serialized.properties || typeof serialized.properties !== "object") {
      serialized.properties = {};
    }

    if (!serialized.properties.Color) {
      serialized.properties.Color = colorLabel;
    }
  }

  async addToCart(event) {
    event.preventDefault();

    const addToCartButton = event.target;
    const formElement = addToCartButton.closest("form");
    if (!formElement) return;

    // Priprema forme
    formElement.querySelector('[name="id"]')?.removeAttribute("disabled");
    const formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    this.attachColorLineItemProperty(formElement, serialized);

    // Vizualni loader
    this.pageLoader.style.width = "100%";
    addToCartButton.setAttribute("disabled", "disabled");

    try {
      const response = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(serialized),
      });

      const data = await response.json();

      if (response.ok) {
        if (window.theme.cartMode === "page") {
          location.href = window.routes.cart_page_url;
          return;
        }

        if (window.theme.cartMode === "drawer") {
          setTimeout(() => {
            document.dispatchEvent(
              new CustomEvent("product:added", {
                bubbles: true,
                detail: {
                  variant: serialized.id,
                  quantity: serialized.quantity,
                  ...data,
                },
              })
            );
          }, 150);
        }

        if (window.location.pathname.includes("/cart")) {
          location.reload();
        }

        addToCartButton.removeAttribute("disabled");
        this.resetPageLoader();

      } else {
        // ⚠️ Shopify error response
        this.handleError(data, addToCartButton);
      }
    } catch (error) {
      console.error("Add to cart failed:", error);
      addToCartButton.removeAttribute("disabled");
      this.resetPageLoader();
    }
  }

  handleError(content, addToCartButton) {
    const errorContainer = this.element.querySelector(".ProductForm--Error");
    this.resetPageLoader();

    if (errorContainer) {
      errorContainer.classList.add("visible");
      setTimeout(() => errorContainer.classList.remove("visible"), 2500);
    } else {
      // Remove any existing error messages first
      const existingErrors = document.querySelectorAll(".ProductForm--ErrorMessage");
      existingErrors.forEach(err => err.remove());
      
      const errorMessage = content?.description || content?.message || "Error adding to cart";
      
      // Show error in both main ATC and sticky ATC forms
      const allForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
      allForms.forEach(form => {
        const msg = document.createElement("div");
        msg.className = "u-p4 ProductForm--ErrorMessage";
        msg.style.cssText = "display: block; padding: 0.5rem 1rem 0 1rem; text-align: center;";
        msg.innerHTML = errorMessage;
        form.appendChild(msg);
      });
      
      setTimeout(() => {
        const allErrors = document.querySelectorAll(".ProductForm--ErrorMessage");
        allErrors.forEach(err => err.remove());
      }, 3500);
    }

    addToCartButton.removeAttribute("disabled");
  }

  resetPageLoader() {
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = "0px";
    this.pageLoader.style.width = "0%";
    setTimeout(() => {
      this.pageLoader.style.left = "0px";
      this.pageLoader.style.right = "unset";
    }, 550);
  }
}


/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code?.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  updateAllDropdowns() {
    this.allDropdowns = document.querySelectorAll(".Dropdown");
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    // Only close other dropdowns if this one does NOT allow multiple open
    if (!elem.classList.contains("allow-multiple")) {
      this.allDropdowns.forEach((dropdown) => {
        if (
          dropdown !== target.closest(".Dropdown") &&
          dropdown.querySelector("[aria-expanded='true']") &&
          !dropdown.contains(target)
        ) {
          this.closeDropdown(dropdown, true);
        }
      });
    }


    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);
    DropdownContent.style.display = '';

    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll(".Dropdown").forEach((dropdown) => {
      if (
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    const transitionEndHandler = (event) => {
      if (!event || event.propertyName === "height") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this.lock = false;

        DropdownContent.style.display = "none";

        DropdownContent.querySelectorAll('.Dropdown--Button').forEach((btn) => {
          btn.setAttribute("aria-expanded", "false");
        });

        DropdownContent.querySelectorAll('.Dropdown--Content').forEach((content) => {
          content.setAttribute("aria-hidden", "true");
          content.style.height = 0;
        });

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    setTimeout(() => transitionEndHandler(), 500);

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("close:filters", { bubbles: true })
          );
        }
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("open:filters", { bubbles: true })
          );
        }
      }
    }
  }
}

const allDropdowns = new Dropdown();


class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    // Smooth transition defaults
    if (!this.initialConfig.speed) {
      this.initialConfig.speed = 600;
    }
    if (!this.initialConfig.cssMode) {
      this.initialConfig.touchRatio = this.initialConfig.touchRatio || 1;
      this.initialConfig.resistance = this.initialConfig.resistance !== undefined ? this.initialConfig.resistance : true;
      this.initialConfig.resistanceRatio = this.initialConfig.resistanceRatio || 0.85;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );

    });


  }
}

class Drawer {
  static active = null;
  static allDrawers = new Set();

  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    Drawer.allDrawers.add(this);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;
    this.isAnimating = false;
    
    // Store instance on element for easy access
    this.element.drawerInstance = this;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    this._resizeListener = responsive.addResizeListener(this, this.calculateMaxHeightListener);

    this.delegateBody.on('popup:close-drawer', () => {
      if (this.isOpen) {
        this.closeDrawer();
      }
    });

  }

  updateToggleButtons(isExpanded) {
    const toggles = document.querySelectorAll(`[data-toggle-id="${this.element.id}"]`);
    toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    });
  }

  destroy() {
    this.delegateBody.off(
      "click",
      `[data-action="open-drawer"][data-toggle-id="${this.element.id}"]`,
      this._openListener
    );
    this.delegateBody.off(
      "click",
      `[data-action="close-drawer"][data-toggle-id="${this.element.id}"]`,
      this._closeListener
    );
    this.delegateBody.off(
      "click",
      `[data-action="toggle-drawer"][data-toggle-id="${this.element.id}"]`,
      this._toggleListener
    );
    this.delegateBody.off('popup:close-drawer', this._popupCloseListener);
if (this._resizeListener && typeof this._resizeListener.removeResizeListener === 'function') {
      this._resizeListener.removeResizeListener();
      this._resizeListener = null;
    }    Drawer.allDrawers.delete(this);
    if (this.element.drawerInstance) delete this.element.drawerInstance;
  }

  maxHeight() {
    // Get the top bar (header) height
    const topBar = document.getElementById("header");
    const topBarHeight = topBar ? topBar.offsetHeight : 0;
    
    // Get the announcement bar height from CSS variable
    const announcementHeight = parseInt(
      getComputedStyle(document.documentElement)
        .getPropertyValue('--announcement-dynamic-height')
        .replace('px', '')
    ) || 0;
    
    // Calculate available height below the top bar and announcement bar
    const availableHeight = window.innerHeight - topBarHeight - announcementHeight;

    // Some drawers should not get a JS-enforced height (e.g. collection filters)
    if (this.element.hasAttribute('data-no-height')) {
      this.element.style.height = '';
    } else if (this.element.getAttribute("data-id") != "mobile-menu") {
      this.element.style.height = availableHeight + "px";
    }
    
    if (
      this.element.getAttribute("id") == "cart" ||
      this.element.getAttribute("id") == "sidebarFavorites"
    ) {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var headerEl = this.element.querySelector(".CartHeader");
      if (headerEl) {
        var header = headerEl.offsetHeight;
      }

      var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

      if (itemWrapper !== null) {
        itemWrapper.style.height =
          availableHeight - footerHeight - header + "px";
      }
    }
  }

  toggleDrawer() {
    event.preventDefault();
    
    // Prevent toggle if animation is in progress
    if (this.isAnimating) {
      return;
    }
    
    this.isOpen ? this.closeDrawer({ target: '#toggle-mobile-menu-btn' }) : this.openDrawer();
  }

  openDrawer() {
    // Close other UI that should never overlap with drawers (e.g. CompareDrawer)
    if (document.body) {
      document.body.dispatchEvent(
        new CustomEvent('drawer:close-other', { bubbles: true })
      );
    }

    // Close popups and search when a drawer opens
    if (window.globalPopup) window.globalPopup.closeAllPopups?.();
    const search = document.querySelector('#quickSearch');
    if (search?.getAttribute('aria-expanded') === 'true') {
      search.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));
    }


    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    if (this.element.getAttribute("id") == "cart-drawer") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );

    } else if (this.element.getAttribute('data-id') == 'mobile-menu') {
      this.element.dispatchEvent(
        new CustomEvent("mobile-menu:open", { bubbles: true })
      );
    } else if (this.element.getAttribute('id') == 'accountDrawer') {
      this.element.dispatchEvent(
        new CustomEvent("account-drawer:open", { bubbles: true })
      );
    }

    // Close any currently active drawer (including mobile menu)
    if (Drawer.active && Drawer.active !== this) {
      if (this.element.id == 'accountDrawer')
        Drawer.active.closeDrawer({ dataToggleid: 'accountDrawer' });
      else Drawer.active.closeDrawer({ target: '#toggle-mobile-menu-btn' });
    }
    Drawer.active = this;


    if (this.isOpen) {
      return;
    }

    this.isAnimating = true;
    this.maxHeight();
    if (this.element.getAttribute("id") == "Drawer") {
      this.element.parentElement.style.display = "block";
    }
    this.element.setAttribute("aria-hidden", "false");
    this.element.style.display = "block";
    requestAnimationFrame(() => {
      this.element.setAttribute("aria-expanded", "true");
    });
    this.updateToggleButtons(true);
    if (this.element.getAttribute('data-id') != 'mobile-menu') {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this._closeListener);
    }
    var focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
      this.isAnimating = false;
    }, 400);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen || (responsive.currentBreakpoint != 'desktop' && this.element.getAttribute('data-id') == 'mobile-menu' && !event)) {
      return;
    }
    if (event?.preventDefault) {
      event.preventDefault();
    }

    this.isAnimating = true;
    
    if (this.element.getAttribute("id") == "Drawer") {
    }
    document.body.classList.remove("scrollLock");

    bodyScrollLock.clearAllBodyScrollLocks();
    if (this.element.getAttribute("id") == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {
        this.element
          .querySelector(".CartDrawer--Expendable")
          .setAttribute("aria-expanded", false);
        setTimeout(() => {
          this.element.querySelector(".CustomCart__Recommendations").innerHTML =
            "";
        }, 800);
      }
    } else if (this.element.getAttribute('data-id') == 'mobile-menu') {
      this.element.dispatchEvent(
        new CustomEvent("mobile-menu:close", { bubbles: true })
      );
    }
    this.element.setAttribute("aria-expanded", "false");
    this.updateToggleButtons(false);
    const transitionEnded = (event) => {
      if (event.propertyName === "transform") {
        this.element.style.display = "none";
        if (this.element.parentElement.tagName.toLowerCase() == "main-menu-dropdown") {
          this.element.parentElement.style.display = "none";
          this.element.setAttribute("aria-hidden", "true");
        }
        this.element.removeEventListener("transitionend", transitionEnded);
        this.isAnimating = false;
      }
    };

    setTimeout(() => {
      transitionEnded({ propertyName: "transform" });
    }, 500)

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();
    if (Drawer.active === this) {
      Drawer.active = null;
    }

  }

  static closeAllDrawers() {
    Drawer.allDrawers.forEach(drawer => {
      if (drawer.isOpen) drawer.closeDrawer();
    });
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate = node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  elementScaleOut(elements) {
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;
    elements.forEach((element, index) => {
      if (element.hasAttribute("data-loaded")) {
        return;
      }
      element.setAttribute("data-loaded", true);
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];
      setTimeout(() => {
        element.animate(keyframes, {
          duration: animationDuration,
          fill: "forwards",
        });
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration * 2,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  // Simple fade-in animation without scaling
  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.hasAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { opacity: "0" },
          { opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const elements = [];
        results.forEach((result) => {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            elements.push(result.target);
            this.intersectionObserver[index].unobserve(result.target);
          }
        });
        if (elements.length === 0) {
          return;
        }
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut',
          elementFadeIn: 'elementFadeIn'
        };
        const method = animations[options.type];
        if (method) {
          this[method](elements);
        }
      },
      { threshold: 0.15 }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }
    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options['noVariants'] == "true") {
      this.toggleAddButton();
    }
  }


  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
      addButtonInner = addButton.querySelector(".SelfAlign"),
      quantityEl = document.querySelector('.QuantitySelector__ProductQuantity');
    if (quantityEl) {
      quantity = quantityEl.value();
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) { quantity = 1; }


    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='u-p3 ml-s'>" +
        Shopify.formatMoney(
          this.options['price'] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.innerHTML =
      buySvg + window.variantStrings.addToCart + priceElement;

  }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-pb6 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;


    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }



    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;


    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);


    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }


    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);


var stateWasEmpty = true;
class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.focusElement = false;
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
        this.onClose();
      },
      onOpen: () => {
        this.isOpen = true;

        if (this.alreadyEntered == false) {
          this.onOpen();
        }
        this.alreadyEntered = true;
      },
    });

    this.loader = this.element.querySelector(".itemLoader");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.emptyCartCollection = this.element.querySelector('.cart-drawer__recommendations');
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this._recommendationsCacheKey = null;
    this._recommendationsAbortController = null;
    this._recLoadTimer = null;
    this.breakpoint = responsive.getCurrentBreakpoint();

    this.alreadyEntered = false;
    new AddToCart(this.element);

    this.bindEvents();
    const closeBtn = this.element.querySelector('.cart-drawer .Drawer--Close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        closeBtn.classList.add('is-active');
        setTimeout(() => closeBtn.classList.remove('is-active'), 400);
      });
    }
  }

  bindEvents() {
    if (this._listenersBound) return; // ✅ sprječava duplo bindanje unutar instance
    this._listenersBound = true;

    // 🔗 Glavni eventi
    this.onProductAddedListener = this.onProductAdded.bind(this);
    document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
    document.addEventListener("product:added", this.onProductAddedListener);

    // 🧩 Kvantiteta i uklanjanje itema
    this.delegateElement.on(
      "click",
      '[data-action="update-item-quantity"], [data-action="remove-item"]',
      this.updateItemQuantity.bind(this)
    );
    this.delegateElement.on(
      "change",
      '[data-action="update-change-quantity"]',
      this.updateItemQuantity.bind(this)
    );
    this.delegateElement.on(
      "quantity:changed",
      ".cart-item__quantity",
      this.updateItemQuantity.bind(this)
    );

    // 🔄 Zamjena itema
    this.delegateBody.on(
      "click",
      '[data-action="replace-cart-item"]',
      this.handleReplaceCartItem.bind(this)
    );

  }


  onOpen() {
    if (this.element.getAttribute("aria-expanded") == "false") {
      setTimeout(() => {
        if (this.element.hasAttribute('data-open-drawer')) {
          bodyScrollLock.clearAllBodyScrollLocks();
          this.focusElement = this.element.querySelector("[data-scrollable]");
          bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
        }

      }, 500);

      if (this.options["showRecommendations"]) {
        const recContainer = this.element.querySelector(".cart-drawer__recommendations");
        if (!this.recommendationsContainerHasContent(recContainer)) {
          this.scheduleLoadRecommendations();
        }
      }
    }
    const header = this.element.querySelector(".cart-drawer__header");
    const headerHeight = header.offsetHeight;

    document.documentElement.style.setProperty(
      "--cart-drawer__header-height",
      headerHeight + "px"
    );

    if (this.element.querySelector(".cart-drawer__footer")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__footer-height",
        this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
      );
    }

    if (this.element.querySelector(".cart-drawer__shipping")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__shipping-height",
        this.element.querySelector(".cart-drawer__shipping").offsetHeight + "px"
      );
    }
  }

  onClose() {
    if (this.breakpoint == 'desktop' && this.recommendationContainer) {
      this.recommendationContainer.setAttribute("aria-expanded", "false");
      this.recommendationContainer = null;
    }
  }

  handleTransitionEnd(target) {
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    this.recommendationContainer.removeEventListener(
      "transitionend",
      this.transitionEndHandler
    );
  }

  async handleReplaceCartItem(e) {
    e.preventDefault();

    // Step 1: Get the current line item ID from localStorage
    const currentLineId = localStorage.getItem("current-line-item");
    if (!currentLineId) {
      console.error('No line item ID found for replacement');
      return;
    }

    // Step 2: Get the quick-add form
    const form = document.querySelector('.quick-add-product form');
    if (!form) {
      console.error('Quick-add form not found');
      return;
    }

    // Step 3: Extract form data
    const formData = new FormData(form);
    const newVariantId = formData.get('id');
    const newQuantity = parseInt(formData.get('quantity') || 1, 10);

    // Step 4: Collect custom properties
    const newProperties = {};
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('properties[')) {
        const propName = key.match(/properties\[(.*?)\]/)?.[1];
        if (propName) {
          newProperties[propName] = value;
        }
      }
    }

    // Step 5: Call the existing replaceCartItem method
    await this.replaceCartItem(e, currentLineId, newVariantId, newQuantity, newProperties);

    if (window.theme.cartMode === 'page') {
      location.href = window.routes.cart_page_url;
    }
  }

  async replaceCartItem(e, currentLineId, newVariantId, newQuantity = 1, newProperties = {}) {
    e.preventDefault();
    try {
      const addToCartButton = e.target;
      addToCartButton.setAttribute("disabled", "disabled");
      // Show loader for the current item if visible
      const cartItem = document.querySelector(`[data-line-id="${currentLineId}"]`)?.closest('.cart-item');
      if (cartItem) {
        const itemLoader = cartItem.querySelector('.itemLoader');
        if (itemLoader) itemLoader.classList.add('is-visible');
      }

      // Step 1: Remove the current item
      const removeResponse = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id: currentLineId, quantity: 0 })
      });

      if (!removeResponse.ok) throw new Error('Failed to remove current item');

      // Step 2: Add the new item
      const addResponse = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: newVariantId, quantity: newQuantity, properties: newProperties }]
        })
      });

      if (!addResponse.ok) throw new Error('Failed to add new item');
      const addData = await addResponse.json();

      // Step 3: Refresh the cart drawer
      await this.renderCart(false, false);

      // Step 4: Cleanup
      localStorage.removeItem("current-line-item");
      this.currentLineId = null;

      // Step 5: Fire success event
      this.element.dispatchEvent(new CustomEvent('cart:item-replaced', {
        bubbles: true,
        detail: { oldLineId: currentLineId, newVariantId, newQuantity, newProperties, cartData: addData }
      }));

      return addData;
    } catch (error) {
      console.error('Error replacing cart item:', error);
      throw error;
    } finally {
      const cartItem = document.querySelector(`[data-line-id="${currentLineId}"]`)?.closest('.cart-item');
      const itemLoader = cartItem.querySelector('.itemLoader');
      if (itemLoader) itemLoader.classList.remove('is-visible');
    }
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();

    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem?.querySelector(".itemLoader");
    if (itemLoader) itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const lineId = target.getAttribute("data-line-id");
    const payload = { id: lineId, quantity };

    try {
      // 🧩 Debounce quick clicks (wait 150ms before sending)
      if (this._quantityTimeout) clearTimeout(this._quantityTimeout);
      await new Promise((resolve) => {
        this._quantityTimeout = setTimeout(resolve, 150);
      });

      const response = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(payload),
      });

      // ⚙️ Handle harmless errors gracefully
      if (!response.ok) {
        console.warn(`⚠️ Shopify cart change failed (${response.status}). Probably too fast or item gone.`);
        if (itemLoader) itemLoader.classList.remove("is-visible");
        // Re-render cart to sync
        await this.renderCart(false, false);
        return;
      }

      const data = await response.json();

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
      } else if (quantity == 0) {
        const nextItem = cartItem.nextElementSibling;
        cartItem.classList.add("removing");
        setTimeout(() => {
          cartItem.remove();
          if (nextItem) {
            nextItem.classList.add("repo--top");
            setTimeout(() => nextItem.classList.remove("repo--top"), 350);
          }
        }, 350);
        if (data.item_count > 0 && this.options.showRecommendations) {
          this.options["productId"] = data.items[0].product_id;
          this.renderCart(false, false, false, null, true);
          return;
        }
      } else {
        this.renderCart(target.getAttribute("data-id"), true);
      }
    } catch (error) {
      console.error("Failed to update item quantity:", error);
    } finally {
      if (itemLoader) itemLoader.classList.remove("is-visible");
    }
  }




  onProductAdded(event) {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }

    this.renderCart(false, false, true, details).then(() => {
      if (this.element.hasAttribute('data-open-drawer')) {
        if (this.isOpen == false) {

          this.isOpen = true;
          this.onOpen();
          this.alreadyEntered = true;
          this.drawer.openDrawer();
        }
      }
    });
    const headerCount = document.querySelector('.header__cart-count');
    if (headerCount) headerCount.textContent = window.theme.cartCount;
  }

  renderCart(lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    this.pageLoader.style.width = 90 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );

      });
    });
  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {

    // Prepare the page loader animation
    this.pageLoader.style.width = "100%";
    setTimeout(() => {
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);


    }, 100)


    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract options and update cart count
    const newOptions = JSON.parse(
      tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );
    this.options = newOptions;

    // In your replaceContent method, update this section:

    if (tempElement.querySelector("[data-ids]")) {
      this.cartIds = tempElement
        .querySelector("[data-ids]")
        .dataset.ids.split(",")
        .filter((item) => item !== "");
      if (updateCount) {
        this.cartIds = this.cartIds.filter((item) => item !== this.removeId);
        this.removeid = null;
      }
    } else {
      // Fixed: Initialize as empty array when no items in cart
      this.cartIds = [];
    }

    const itemCount = parseInt(newOptions.itemCount || 0);
    window.theme.cartCount = itemCount;

    const headerCount = document.querySelector('.header__cart-count');
    if (headerCount) headerCount.textContent = itemCount;


    // Update cart drawer title count
    const drawerTitle = this.element.querySelector('.cart-drawer__title');
    if (drawerTitle) {
      const match = drawerTitle.textContent.match(/^([^\(]+)/); // keep title text before "("
      const titleText = match ? match[1].trim() : 'Items';
      drawerTitle.innerHTML = `${titleText} (${itemCount})`;
    }


    if (updateCount) {
      this.updateCartFooter(tempElement);
      if (this.options.showRecommendations) {
        this.scheduleLoadRecommendations({ force: true });
      }
      return;
    }
    if (lineNumber && tempElement.querySelector(`#${lineNumber}`)) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && stateWasEmpty == false && lineNumber) {
      this.addContent(tempElement, productAddEvent);
    } else {
      this.replaceCartContent(tempElement);
    }


    this.updateCartFooter(tempElement);


    this.element.dispatchEvent(
      new CustomEvent("cart:render", { bubbles: true })
    );


    if (itemCount == 0) {
      stateWasEmpty = true;
    } else {
      stateWasEmpty = false;
    }

    if (this.options.showRecommendations && !quantityChange) {
      const recContainer = this.element.querySelector(".cart-drawer__recommendations");
      const recCacheKey = this.getRecommendationsCacheKey();
      if (
        recCacheKey !== this._recommendationsCacheKey ||
        !this.recommendationsContainerHasContent(recContainer)
      ) {
        this.scheduleLoadRecommendations({ force: true });
      }
    }

    // Additional actions after a brief delay
    setTimeout(() => {
      if (this.element.hasAttribute('data-open-drawer')) {
        bodyScrollLock.clearAllBodyScrollLocks();
        this.focusElement = this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
      }



    }, 200);
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info `
    );
    const oldCartItemInfo = cartItemParent.querySelector(`#${lineNumber} .cart-item__info`);



    if (!cartItemParent) {
      this.element
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.querySelector('.cart-item__inner').replaceChild(
        newCartItemInfo,
        oldCartItemInfo
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__wrapper").scrollTop = 0;

    }
    const itemToAdd = tempElement.querySelector(
      `#cart-item__${productAddEvent.variant}`
    );
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#cart-item__${productAddEvent.variant}`)) {
      this.updateCartItem(`cart-item__${productAddEvent.variant}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      this.loader.classList.remove("is-visible");
      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");


        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
        }, 350);
      }, 350);
    }
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }

  updateCartFooter(tempElement) {
    const itemCount = this.options.itemCount;
    if (itemCount > 0) {

      const footerParent = document.querySelector(".cart-drawer__footer");

      const newFooterTotals = tempElement.querySelector(
        ".cart_drawer__footer-totals"
      );
      const oldFooterTotals = document.querySelector(".cart_drawer__footer-totals");

      if (!footerParent || !newFooterTotals) return;
      if (oldFooterTotals) {

        footerParent.replaceChild(
          newFooterTotals,
          oldFooterTotals
        );
      } else {
        footerParent.prepend(newFooterTotals);
      }

      const newShippingBar = tempElement.querySelector(
        ".cart-drawer__shipping-progress-bar"
      );
      if (newShippingBar) {
        const currentShippingBar = document.querySelector(
          ".cart-drawer__shipping-progress-bar"
        );
        if (currentShippingBar) {
          let percent = newShippingBar.dataset.percent;
          if (percent > 100) {
            percent = 100;
          }
          currentShippingBar.dataset.percent = percent;
          currentShippingBar.style.width = `${percent}%`;
          if (percent == 100) {
            currentShippingBar.classList.add("done");
            currentShippingBar.classList.remove("active");
          } else {
            currentShippingBar.classList.remove("done");
            currentShippingBar.classList.add("active");
          }
          this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
            tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
        } else {
          const headerParent = this.element.querySelector(
            ".cart-drawer__header"
          );
          headerParent.appendChild(
            tempElement.querySelector(".cart-drawer__shipping")
          );
        }
      }

    } else {
      this.clearCartFooter(tempElement);
      stateWasEmpty = true;
    }

    if (this.element.querySelector(".cart-drawer__footer")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__footer-height",
        this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
      );
    }

    if (this.element.querySelector(".cart-drawer__shipping")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__shipping-height",
        this.element.querySelector(".cart-drawer__shipping").offsetHeight + "px"
      );
    }

    // 🧩 Update total price dynamically
    const newTotal = tempElement.querySelector('.cd__subtotal-final');
    const oldTotal = this.element.querySelector('.cd__subtotal-final');
    if (newTotal && oldTotal) {
      oldTotal.innerHTML = newTotal.innerHTML;
    }

  }

  clearCartFooter(tempElement) {

    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    if (document.querySelector(".cart-drawer__footer")) {
      document
        .querySelector(".cart-drawer__footer")
        .classList.add("removing");
    }

    const wrapperParent = this.element.querySelector(".cart-drawer__wrapper");
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
        ".cart-drawer__wrapper"
      ).innerHTML;
    }
  }

  replaceCartContent(tempElement) {

    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).scrollTop;

    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__wrapper"),
      this.element.querySelector(".cart-drawer__wrapper")
    );
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__wrapper").scrollTop =
      currentScrollPosition;

    setTimeout(() => {
      const header = this.element.querySelector(".cart-drawer__header");
      const headerHeight = header.offsetHeight;

      document.documentElement.style.setProperty(
        "--cart-drawer__header-height",
        headerHeight + "px"
      );
      if (cartWrapperParent.querySelector(".cart-drawer__footer")) {
        document.documentElement.style.setProperty(
          "--cart-drawer__footer-height",
          cartWrapperParent.querySelector(".cart-drawer__footer").offsetHeight + "px"
        );
      }

      if (cartWrapperParent.querySelector(".cart-drawer__shipping")) {
        document.documentElement.style.setProperty(
          "--cart-drawer__shipping-height",
          cartWrapperParent.querySelector(".cart-drawer__shipping").offsetHeight + "px"
        );
      }

    }, 100);
  }

  getRecommendationsCacheKey() {
    const container = this.element.querySelector(".cart-drawer__recommendations");
    const productId = this.options["productId"];
    const hasItems = (this.options["itemCount"] || 0) > 0;
    const collection = container?.dataset.collection || "";
    const intent = (this.options.intent || "complementary").toLowerCase();
    const limit = this.element.getAttribute("product-limit") || 4;
    const cartIds = Array.isArray(this.cartIds) ? this.cartIds.join(",") : "";
    return `${hasItems ? "cart" : "empty"}:${productId || collection}:${intent}:${limit}:${cartIds}`;
  }

  recommendationsContainerHasContent(container) {
    return Boolean(
      container?.querySelector(".cart-drawer__recommendations-wrapper .swiper-slide")
    );
  }

  scheduleLoadRecommendations({ force = false } = {}) {
    clearTimeout(this._recLoadTimer);
    this._recLoadTimer = setTimeout(() => {
      this._recLoadTimer = null;
      this.loadRecommendations({ force });
    }, 80);
  }

  async loadRecommendations({ force = false } = {}) {
    const container = this.element.querySelector(".cart-drawer__recommendations");
    if (!container) {
      return;
    }

    const baseUrl = window.routes.localeRootUrl;
    const productId = this.options["productId"];
    const hasItems = this.options["itemCount"] > 0;
    const enabled = container.dataset.enabled === "true";
    const collection = container.dataset.collection;
    const limit = this.element.getAttribute("product-limit") || 4;
    const intent = (this.options.intent || "complementary").toLowerCase();
    const cacheKey = this.getRecommendationsCacheKey();
    let url = null;

    if (
      !force &&
      cacheKey === this._recommendationsCacheKey &&
      this.recommendationsContainerHasContent(container)
    ) {
      return;
    }

    // 🛒 CART EMPTY
    if (!hasItems) {
      if (enabled && collection && collection !== "blank") {
        url = `${baseUrl}?section_id=helper-recommendations&collection=${collection}`;
      } else {
        container.innerHTML = "";
        container.style.display = "none";
        this._recommendationsCacheKey = cacheKey;
        this.recommendationLoading = false;
        return;
      }
    }
    // 📦 CART HAS ITEMS
    else if (productId) {
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=${limit}&intent=${intent}`;
    } else {
      this.recommendationLoading = false;
      return;
    }

    if (this._recommendationsAbortController) {
      this._recommendationsAbortController.abort();
    }
    this._recommendationsAbortController = new AbortController();
    const { signal } = this._recommendationsAbortController;

    this.recommendationLoading = true;

    try {
      const response = await fetch(url, { signal });
      const html = await response.text();

      if (signal.aborted) {
        return;
      }

      const temp = document.createElement("div");
      temp.innerHTML = html;

      const upsell = temp.querySelector(".cart-drawer__upsell");
      const slides = upsell ? upsell.querySelectorAll(".swiper-slide").length : 0;

      if ((intent === "complementary" || intent === "related") && slides === 0) {
        container.innerHTML = "";
        container.style.display = "none";
        this._recommendationsCacheKey = cacheKey;
        return;
      }

      if (upsell && slides > 0) {
        const nextHtml = upsell.innerHTML;

        if (container.innerHTML !== nextHtml) {
          container.style.display = "";
          container.innerHTML = nextHtml;
          new AddToCart(this.element);
          new RevolutionAnimation(container);

          container.querySelectorAll("swiper-init").forEach((swiperEl) => {
            if (typeof swiperEl.connectedCallback === "function") {
              swiperEl.connectedCallback();
            }
          });
        }

        this._recommendationsCacheKey = cacheKey;
      } else {
        container.innerHTML = "";
        container.style.display = "none";
        this._recommendationsCacheKey = cacheKey;
      }
    } catch (err) {
      if (err?.name === "AbortError") {
        return;
      }
      console.error("Failed to load cart recommendations:", err);
    } finally {
      if (!signal.aborted) {
        this.recommendationLoading = false;
      }
      if (this._recommendationsAbortController?.signal === signal) {
        this._recommendationsAbortController = null;
      }
    }
  }



  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }

}
customElements.define("cart-drawer", CartDrawer);



class MainCart extends HTMLElement {
  connectedCallback() {
    const container = this.querySelector(".cart-drawer__recommendations");
    if (!container) return;

    const productId = this.dataset.productId;
    const collection = container.dataset.collection;
    const limit = this.dataset.limit || 4;
    const intent = (this.dataset.intent || "complementary").toLowerCase();
    const baseUrl = window.routes?.localeRootUrl || "";

    let url = "";

    if (!productId) {
      url = `${baseUrl}?section_id=helper-recommendations-main-cart&collection=${collection}`;
    } else {
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations-main-cart&product_id=${productId}&limit=${limit}&intent=${intent}`;
    }

    console.log("➡️ Loading main cart recommendations:", url);

    fetch(url)
      .then(r => r.text())
      .then(html => {
        const temp = document.createElement("div");
        temp.innerHTML = html;
        const upsell = temp.querySelector(".cart-drawer__upsell");

        if (upsell) {
          container.innerHTML = upsell.outerHTML;
          new AddToCart(this);
          new RevolutionAnimation(container);

          // ✅ Run Swiper AFTER DOM updates
          // ✅ Force re-upgrade all <swiper-init> elements inside the container
          setTimeout(() => {
            const swipers = container.querySelectorAll("swiper-init");
            swipers.forEach(swiperEl => {
              if (typeof swiperEl.connectedCallback === "function") {
                swiperEl.connectedCallback();
              }
            });

            if (window.SwiperInit) {
              console.log("🔁 Forcing Swiper reinitialization...");
              window.SwiperInit(container);
            }
          }, 500);


          console.log("✅ Recommendations rendered on main cart page");

        } else {
          console.warn("⚠️ No recommendations found for main cart");
          container.style.display = "none";
        }
      })
      .catch(err => console.error("🚨 Main cart recommendations failed:", err));
  }
}

customElements.define("main-cart", MainCart);



class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }
}
customElements.define("slider-text", SliderTextSection);


// Auto-initialize existing elements with animate-on-scroll attribute
class ScrollAnimationController {
  constructor() {
    this.elements = new Map();
    this.init();
  }

  init() {
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeElements());
    } else {
      this.initializeElements();
    }

    // Also initialize any dynamically added elements
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            if (node.hasAttribute && node.hasAttribute('animate-on-scroll')) {
              this.initializeElement(node);
            }
            // Check child elements too
            const childElements = node.querySelectorAll ? node.querySelectorAll('[animate-on-scroll]') : [];
            childElements.forEach(el => this.initializeElement(el));
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initializeElements() {
    const elements = document.querySelectorAll('[animate-on-scroll]');
    elements.forEach(el => this.initializeElement(el));
  }

  initializeElement(el) {
    if (this.elements.has(el) || el.hasAttribute('disabled')) return;

    const controller = new ElementScrollAnimation(el);
    this.elements.set(el, controller);
  }
}

class ElementScrollAnimation {
  constructor(element) {
    this.element = element;
    this._raf = null;
    this._inView = false;
    this._listenersBound = false;

    this._queue = this._queue.bind(this);
    this._update = this._update.bind(this);
    this._onIO = this._onIO.bind(this);
    this._requery = this._requery.bind(this);

    this.init();
  }

  init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Animation parameters - customizable via attributes
    this.startScale = parseFloat(this.element.getAttribute('start-scale')) || 1.2;
    this.endScale = parseFloat(this.element.getAttribute('end-scale')) || 1.0;
    this.speed = parseFloat(this.element.getAttribute('speed')) || 3;

    // Target all images within this element
    this.selector = 'img';
    this._requery();

    this._io = new IntersectionObserver(this._onIO, {
      threshold: [0, 1],
      root: null,
      rootMargin: '25% 0px'
    });
    this._io.observe(this.element);

    this._queue();
  }

  destroy() {
    if (this._io) this._io.disconnect();
    if (this.delegateWindow) this.delegateWindow.destroy();
    if (this._raf) cancelAnimationFrame(this._raf);
  }

  _requery() {
    this.targets = Array.from(this.element.querySelectorAll(this.selector));
    this.targets.forEach(el => {
      el.style.transformOrigin = 'center center';
      el.style.willChange = 'transform';
    });
  }

  _onIO([entry]) {
    this._inView = entry.isIntersecting || entry.intersectionRatio > 0;

    // bind once, the first time we come into view
    if (this._inView && !this._listenersBound) {
      this.delegateWindow = new Delegate(window);
      this.delegateWindow.on('scroll', this._queue);
      this.delegateWindow.on('resize', this._queue);
      this._listenersBound = true;
    }

    if (this._inView) this._queue();
  }

  _queue() {
    if (this._raf) return;
    this._raf = requestAnimationFrame(this._update);
  }

  _update() {
    this._raf = null;
    if (!this._inView || !this.element.isConnected || !this.targets?.length) return;

    const vh = window.innerHeight || document.documentElement.clientHeight;
    const startLine = 0.85 * vh;
    const endLine = 0;

    for (const el of this.targets) {
      const r = el.getBoundingClientRect();
      const h = r.height || 1;

      const denom = (startLine - endLine) + h;
      let t = (startLine - r.top) / denom;
      if (t < 0) t = 0; else if (t > 1) t = 1;

      // Easing and scale calculation: start big, shrink to normal
      const eased = 1 - Math.pow(1 - t, this.speed);
      const scale = this.startScale + (this.endScale - this.startScale) * eased;

      el.style.transform = `translate3d(0,0,0) scale(${scale})`;
    }
  }
}

// Initialize the scroll animation system
const scrollAnimationController = new ScrollAnimationController();



class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.responsive = new Responsive(true, false);

    this.pageOverlayElement = document.querySelector('.pageOverlay');
    this.carouselElement = this.element.querySelector('[data-swiper-settings]');
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(
      this.element.getAttribute('data-section-settings')
    );

    this.fullWidthMediaContent = this.element.querySelector(
      '.full-width-media_content'
    );
    this.ticking = false;
    this.scrollAnimation = this.options.scrollAnimation || 'none';

    this.MAX_SCROLL = 300;
    this.MAX_SCALE_REDUCTION = 0.05;
  }

  connectedCallback() {
    window.addEventListener('scroll', this.handleScroll.bind(this), {
      passive: true,
    });

    // Ensure the initial scale is set before the first scroll event.
    if (this.fullWidthMediaContent) {
      requestAnimationFrame(() => this.updateBannerOnScroll());
    }
  }

  updateBannerOnScroll() {
    if (!this.fullWidthMediaContent) return;

    const rect = this.getBoundingClientRect();
    const contentRect = this.fullWidthMediaContent.getBoundingClientRect();
    const contentTop = contentRect.top + window.scrollY;
    const elementHeight = rect.height;
    const scrollY = window.scrollY;

    const animationStartScroll = contentTop;

    const animationEndScroll = contentTop + (elementHeight / 2);

    if (scrollY < animationStartScroll) {
      this.applyZoomOutEffect(0);
      return;
    }

    if (scrollY >= animationEndScroll) {
      this.applyZoomOutEffect(1);
      return;
    }

    const totalDistance = animationEndScroll - animationStartScroll;
    const currentDistance = scrollY - animationStartScroll;
    const progress = Math.max(0, Math.min(1, currentDistance / totalDistance));

    this.applyZoomOutEffect(progress);
  }

  applyZoomOutEffect(progress) {
    const scale = 1.05 - progress * this.MAX_SCALE_REDUCTION;

    if (this.fullWidthMediaContent) {
      this.fullWidthMediaContent.style.setProperty(
        '--banner-scale',
        scale.toString()
      );
    }
  }

  resetScrollEffects() {
    if (this.fullWidthMediaContent) {
      this.fullWidthMediaContent.style.setProperty('--banner-scale', '1');
    }
  }

  handleScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.updateBannerOnScroll();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }
}
customElements.define('banner-hero', Banner);


class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.menuOverlayElement = document.querySelector(".menuOverlay");
    if (!this.menuOverlayElement) {
      this.menuOverlayElement = document.createElement('div');
      this.menuOverlayElement.className = 'menuOverlay';
      const pageOverlay = document.querySelector('.pageOverlay');
      if (pageOverlay?.parentNode) {
        pageOverlay.parentNode.insertBefore(this.menuOverlayElement, pageOverlay.nextSibling);
      } else {
        document.body.appendChild(this.menuOverlayElement);
      }
    }
    this._desktopMenuFocusActive = false;
    this._pageOverlayWasVisible = false;
    this._bodyWasScrollLocked = false;
    this._desktopMenuOverlayClickListener = () => this.closeMenu();
    this._desktopMenuEscListener = (e) => {
      if (e.key === 'Escape' || e.key === 'Esc') {
        this.closeMenu();
      }
    };
    this.headerTransparent = false;
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (this.options.sticky) {
      this.toggleSticky();
    }
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    this.updateVisibleHeight();
    window.onload = () => setTimeout(() => this.updateVisibleHeight(), 500);
    this.bindEvents();
    this.menuOverlapHandler();
    this.menusClosing = new Set();
    this._menuCloseTimer = null;
    this._menuOpenTimer = null;
    // Hover-intent: how long (ms) the pointer must rest on a top-level item
    // before its dropdown opens, so merely passing over it doesn't trigger it.
    this._openDelay = 180;
    this._isClosing = false;

  }



  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".header__menu-items"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".header--wrapper"),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".header-main-links");
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove("mt-m");
      menuItems.classList.remove("mainMenu--Overlapping");
      menuWrapper.querySelector(".header__main-menu-items").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.classList.add("mainMenu--Overlapping");
      menuItems.closest(".header").appendChild(menuItems);
    }
    document.documentElement.style.setProperty(
      "--header-height",
      _this.element.clientHeight + "px"
    );
    menuItems.style.opacity = 1;
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--sticky");
    this.element.parentElement.classList.remove("Header--Transparent");
  }

  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function () {
      _this.menuOverlapHandlerListener();
    });
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    window.addEventListener("resize", this.menuOverlapHandlerListener);
    this.toggleColorListener = this.toggleColor.bind(this);

    if (this.options.transparent || this.options.sticky) {
      this.toggleColorListener = this.toggleColor.bind(this);
      scrollListener.addScrollListener(this, this.toggleColorListener);
    }

    window.addEventListener("scroll", this.toggleColorListener);
    window.addEventListener("scroll", this.toggleTopBarListener);

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);
    this.delegateBody.on("popup:close-drawer", this.closeMenu.bind(this), true);
    this.delegateBody.on("cart-drawer:open", this.closeMenu.bind(this), true);
    this.delegateBody.on("account-drawer:open", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.scheduleOpenMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-hasMenu='true']",
      this.cancelScheduledOpen.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singleMenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      ".desktop-menu__dropdown-wrapper, [aria-submenu], .header-row-desktop",
      () => clearTimeout(this._menuCloseTimer),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      ".desktop-menu__dropdown-wrapper, [aria-submenu], .header-row-desktop",
      (e, submenuEl) => {
        const to = e.relatedTarget;
        if (to && (submenuEl.contains(to) || to.closest('[aria-hasMenu="true"]') || to.closest('.header--wrapper'))) return;
        this.closeMenu(e, submenuEl);
      },
      true
    );

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }
  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate the visible height
      let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);


      // Ensure the visibleHeight is never negative
      visibleHeight = Math.max(visibleHeight, 0);
      // Update the height of header with the visible height
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `${visibleHeight}px`
      );

      document.documentElement.style.setProperty(
        "--header-height-fixed",
        document.querySelector("#header").offsetHeight + "px"
      );
    }, 550);

  }
  toggleTopBar() {
    let current = window.scrollY;
    let annBar = document.querySelector(".announcement-bar");
    let element_height = this.element.offsetHeight;

    if ((element_height + annBar.offsetHeight) * 2 < current) {
      this.element.parentElement.classList.add("header--fixed-top-bar");
    }

    if (current <= annBar.offsetHeight) {
      this.element.parentElement.classList.remove("header--fixed-top-bar");
    }

    if (
      this.prevOffset < current &&
      current >= annBar.offsetHeight + this.element.offsetHeight
    ) {
      this.element.parentElement.classList.add("header--hide");
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `0px`
      );
    } else {
      this.element.parentElement.classList.remove("header--hide");
      this.updateVisibleHeight();
    }

    this.prevOffset = current;
  }
  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",

      `${document.querySelector("#header").offsetHeight}px`
    );
  }


  // Hover-intent gate: wait for the pointer to rest on a top-level item before
  // opening its dropdown, so just sweeping the cursor across the bar doesn't open
  // (and close) menus. Keyboard focus (focusin) bypasses this and opens immediately.
  scheduleOpenMenu(event, target) {
    // Mirror openMenu's guard so we only react to a real enter of the menu item,
    // not bubbled enters from child elements (e.g. the inner <a>).
    if (event.type === "mouseenter" && target !== event.target) return;

    if (this._menuOpenTimer) clearTimeout(this._menuOpenTimer);

    if (this._isClosing) return;
    if (target.getAttribute('aria-expanded') === "true") return;

    // If a menu is already open, switch instantly — the user is already committed
    // to browsing the menus, so a delay there would feel laggy.
    const anyOpen = this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]');
    const delay = anyOpen ? 0 : this._openDelay;

    this._menuOpenTimer = setTimeout(() => {
      this._menuOpenTimer = null;
      this.openMenu(event, target);
    }, delay);
  }

  cancelScheduledOpen(event, target) {
    if (event && event.type === "mouseleave" && target !== event.target) return;
    if (this._menuOpenTimer) {
      clearTimeout(this._menuOpenTimer);
      this._menuOpenTimer = null;
    }
  }

  openMenu(event, target) {
    const targetDropdown = target.querySelector(".desktop-menu__dropdown-wrapper");
    if (!targetDropdown) return;

    if (this._isClosing) return;

    if (target.getAttribute('aria-expanded') === "true") return;

    if (event.type === "mouseenter" && target !== event.target) return;

    if (this._menuOpenTimer) {
      clearTimeout(this._menuOpenTimer);
      this._menuOpenTimer = null;
    }

    if (this._menuCloseTimer) clearTimeout(this._menuCloseTimer);

    Drawer.closeAllDrawers();
    this.element.dispatchEvent(new CustomEvent("drawer:close-other", { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent("close:search", { bubbles: true }));

    if (this.element.classList.contains("Header--Transparent")) {
      this.element.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }

    const siblings = Array.from(target.parentElement.children)
      .filter(el => el !== target && el.getAttribute("aria-expanded") === "true");

    this._isClosing = true;
    Promise.all(siblings.map(s => this.closeSiblingMenu(s)))
      .then(() => {
        this._isClosing = false;

        this.updateMenuPosition(target);
        targetDropdown.style.display = '';
        targetDropdown.offsetHeight;

        target.setAttribute("aria-expanded", "true");

        if (window.innerWidth >= 1025) {
          this.enableDesktopMenuFocus();
        }

        if (window.innerWidth < 1025 && this.scrollableElement) {
          try { bodyScrollLock.disableBodyScroll(this.scrollableElement, bodyScrollLockOptions); } catch (e) { }
        }
      });
  }

  enableDesktopMenuFocus() {
    if (this._desktopMenuFocusActive) return;
    this._desktopMenuFocusActive = true;

    this._bodyWasScrollLocked = document.body.classList.contains('scrollLock');
    document.body.classList.add('scrollLock');

    if (!this.menuOverlayElement) return;

    this._pageOverlayWasVisible = this.menuOverlayElement.classList.contains('is-visible');
    this.menuOverlayElement.classList.add('is-visible');

    this.menuOverlayElement.removeEventListener('click', this._desktopMenuOverlayClickListener);
    this.menuOverlayElement.addEventListener('click', this._desktopMenuOverlayClickListener);

    document.removeEventListener('keydown', this._desktopMenuEscListener);
    document.addEventListener('keydown', this._desktopMenuEscListener);
  }

  disableDesktopMenuFocus() {
    if (!this._desktopMenuFocusActive) return;
    this._desktopMenuFocusActive = false;

    document.removeEventListener('keydown', this._desktopMenuEscListener);

    if (this.menuOverlayElement) {
      this.menuOverlayElement.removeEventListener('click', this._desktopMenuOverlayClickListener);

      if (!this._pageOverlayWasVisible) {
        this.menuOverlayElement.classList.remove('is-visible');
      }
    }

    if (!this._bodyWasScrollLocked) {
      document.body.classList.remove('scrollLock');
    }
  }
  closeSiblingMenu(element) {
    return new Promise(resolve => {
      if (!element) return resolve();

      const wrapper = element.querySelector('.desktop-menu__dropdown-wrapper');
      if (!wrapper) return resolve();

      wrapper.classList.add('is-closing');
      element.setAttribute('aria-expanded', 'false');

      const handleEnd = (e) => {
        if (e.target !== wrapper) return;
        wrapper.removeEventListener('transitionend', handleEnd);
        wrapper.style.display = 'none';
        wrapper.classList.remove('is-closing');
        element.setAttribute('aria-hidden', 'true');
        resolve();
      };
      wrapper.addEventListener('transitionend', handleEnd);

      setTimeout(() => {
        wrapper.removeEventListener('transitionend', handleEnd);
        wrapper.style.display = 'none';
        wrapper.classList.remove('is-closing');
        element.setAttribute('aria-hidden', 'true');
        resolve();
      }, 300);
    });
  }


  closeMenu(event, target) {
    if (event && event.type === "mouseleave" && target !== event.target) return;

    if (this._menuCloseTimer) clearTimeout(this._menuCloseTimer);

    this._menuCloseTimer = setTimeout(async () => {
      this._menuCloseTimer = null;

      const openElement = this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]');
      if (openElement) {
        await this.closeSiblingMenu(openElement);
      }

      if (window.innerWidth >= 1025) {
        this.disableDesktopMenuFocus();
      }

      this.toggleColor();

      if (window.innerWidth < 1025 && this.scrollableElement) {
        try { bodyScrollLock.enableBodyScroll(this.scrollableElement); } catch (e) { }
      }
    }, 100);
  }


  toggleColor() {
    if (window.pageYOffset > 25) {
      this.element.classList.add("Header--Scrolled");
    } else {
      this.element.classList.remove("Header--Scrolled");
    }

    if (this.options.showScrollBorder) {
      this.element.classList.add("Header--scroll-border");
    } else {
      this.element.classList.remove("Header--scroll-border");
    }
    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    const menuDrawer = this.element.querySelector(".Drawer--wrapper");

    new Drawer(menuDrawer);


    this.bindEvents();
  }
  bindEvents() {

  }

}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {

      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();


class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  bindHoverEvents() {
    if (this.options["play_in_view_mob_hover_desk"]) {
      this.onMouseEnterListener = this.onMouseEnter.bind(this);
      this.onMouseLeaveListener = this.onMouseLeave.bind(this);

      this.element.addEventListener("mouseenter", this.onMouseEnterListener);
      this.element.addEventListener("mouseleave", this.onMouseLeaveListener);
    }
  }

  onMouseEnter() {
    const isMobile = responsive.matchesBreakpoint("pocket");

    // Only handle hover for play_in_view_mob_hover_desk setting
    if (!isMobile && this.videoPlayer && this.options["play_in_view_mob_hover_desk"] && !this.options["play_in_view"]) {
      if (this.options["muted"]) {
        this.videoPlayer.muted("true");
      }
      this.videoPlayer.play();
    }
  }

  onMouseLeave() {
    const isMobile = responsive.matchesBreakpoint("pocket");

    // Only handle hover for play_in_view_mob_hover_desk setting
    if (!isMobile && this.videoPlayer && this.options["play_in_view_mob_hover_desk"] && !this.options["play_in_view"]) {
      if (this.videoPlayer.el_.classList.contains("vjs-playing")) {
        this.videoPlayer.pause();
      }
    }
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    const isMobile = responsive.matchesBreakpoint("pocket");

   

    if (event.detail.currentIndex == this.elementPosition) {
      // Active slide - initialize or reinitialize video
      if (this.element.getAttribute("loaded")) {
        // Already loaded - on desktop, always reinitialize for fresh controls
        if (!isMobile && this.videoPlayer) {
          console.log('VideoComponent: Desktop reinitialize');
          this.reinitializeVideoPlayer();
        } else if (!this.videoPlayer) {
          console.log('VideoComponent: No video player, initializing');
          this.checkLoaded();
        }
      } else {
        // First time loading
        console.log('VideoComponent: First time loading');
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        this.checkLoaded();
      }

      // Handle autoplay if enabled
      if ((this.options["play_in_view"]) || (this.options["play_in_view_mob_hover_desk"] && isMobile)) {
        setTimeout(() => {
          if (this.videoPlayer) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }, 200);
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      // Not active slide - pause if playing
      console.log('VideoComponent: Pausing video on slide exit');
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      bigPlayButton: true,
      controlBar: this.options["controls"]
        ? {
          children: [
            "playToggle",
            "progressControl",
            "currentTimeDisplay",
            "timeDivider",
            "durationDisplay",
            "CustomControlSpacer",
            "MuteToggle",
            "fullscreenToggle"
          ]
        }
        : false,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
   
      _this.element.querySelector(".videoHolder").style.display = "block";

      // Bind hover events for desktop behavior
      _this.bindHoverEvents();

      // Force controls to be interactive on desktop
      const isMobile = responsive.matchesBreakpoint("pocket");
      if (!isMobile) {
        setTimeout(() => {
          _this.ensureDesktopControls();
        }, 100);
      }

      if (_this.trueObserver == false && (_this.options["play_in_view_mob_hover_desk"] || _this.options["play_in_view"])) {
        _this.createObserver();
      }
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    } else {
      // Controls are disabled - remove manual interactions but keep automatic behavior
     
      // Disable click interactions completely
      this.videoPlayer.off('click');
      this.videoPlayer.off('touchstart');

      // Hide controls completely
      this.videoPlayer.controls(false);

      // Keep hover/mouseover functionality for desktop autoplay but disable manual clicking
      const videoEl = this.element.querySelector('.video-js');
      if (videoEl) {
        // Don't disable pointer events completely - we need hover to work
        // videoEl.style.pointerEvents = 'none';
        videoEl.style.cursor = 'default';

        // Add a custom click handler that does nothing to prevent any manual control
        videoEl.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, true);

        // Allow native vertical page scroll when the touch starts on the video.
        // Passive so preventDefault can never cancel the scroll gesture; the
        // sibling click handler above already suppresses tap-to-play/pause.
        videoEl.addEventListener('touchstart', function (e) {
          e.stopPropagation();
        }, { capture: true, passive: true });
      }
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    const element = this.element;
    observer.observe(element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    const isMobile = responsive.matchesBreakpoint("pocket");

    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        // Handle play_in_view setting (both devices)
        if (this.options["play_in_view"] && this.videoPlayer) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
        // Handle play_in_view_mob_hover_desk setting (mobile only)
        else if (this.options["play_in_view_mob_hover_desk"] && this.videoPlayer && isMobile) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        // Handle play_in_view setting (both devices)
        if (this.options["play_in_view"] && this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
        // Handle play_in_view_mob_hover_desk setting (mobile only)
        else if (this.options["play_in_view_mob_hover_desk"] && isMobile &&
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }

  disposeVideoPlayer() {
    if (this.videoPlayer) {
      try {
        console.log('VideoComponent: Disposing video player');
        this.videoPlayer.dispose();
        this.videoPlayer = null;
        console.log('VideoComponent: Video player disposed successfully');
      } catch (e) {
        console.warn('VideoComponent: Error disposing video player:', e);
        this.videoPlayer = null; // Force null even if dispose fails
      }
    }
  }

  ensureDesktopControls() {
    if (!this.videoPlayer) return;

    // Only enable controls if they are supposed to be enabled
    if (this.options["controls"]) {
      // Force controls to be enabled
      this.videoPlayer.controls(true);

      // The main issue was CSS pointer-events, but we can still ensure controls are clickable
      const isMobile = responsive.matchesBreakpoint("pocket");
      if (!isMobile) {
        // Make sure text track display doesn't block clicks
        const textTrackDisplay = this.element.querySelector('.vjs-text-track-display');
        if (textTrackDisplay) {
          textTrackDisplay.style.pointerEvents = 'none';
        }
      }
    } else {
      console.log('VideoComponent: Controls disabled, ensuring no interactions');
      // Make sure controls stay disabled
      this.videoPlayer.controls(false);

      // Ensure video is non-interactive
      const videoEl = this.element.querySelector('.video-js');
      if (videoEl) {
        videoEl.style.pointerEvents = 'none';
        videoEl.style.cursor = 'default';
      }
    }
  }

  reinitializeVideoPlayer() {
    console.log('VideoComponent: Reinitializing video player for element:', this.element);

    this.disposeVideoPlayer();

    // Clear the loaded attribute so video can be reinitialized
    this.element.removeAttribute('loaded');
    this.element.removeAttribute('data-loaded');

    // Remove existing video holder completely
    const existingHolder = this.element.querySelector('.videoHolder');
    if (existingHolder) {
      existingHolder.remove();
    }

    // Force a fresh start
    setTimeout(() => {
      this.checkLoaded();
    }, 50);
  }
}
customElements.define("video-component", VideoComponent);



var contentCache = {};

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.boundEventHandlers = new Map();

    this._thumbSync = null;
    this._thumbResizeListener = null;

    this.changeImageQuality();
    new AddToCart(this.element);
  }

  connectedCallback() {
    this.carouselElement = this.element.querySelector(".mainSwiper");


    this.carouselElementThumbs = this.element.querySelector(".main-product__thumbs");
    this.uspSwiperElement = this.element.querySelector(".product-usp__swiper.swiper");
    this.tintElement = this.element.querySelector('.ProductSlider--Tint');
    this.wrapperElement = this.element.querySelector('.main-product__slider');
    this.productInfoWrapper = document.querySelector('.product-info__wrapper');
    this.mainAtc = this.element.querySelector(".product-info__actions");
    this.valuesWrap = this.element.querySelectorAll(".ProductOption--ValusWrapper");

    const slides = this.carouselElement?.querySelectorAll('.swiper-slide') || [];

    if (slides.length > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement, this.carouselElementThumbs);
    } else {
      const buttons = this.element.querySelectorAll('.pdp_swiperButton');
      buttons.forEach(btn => btn.style.display = 'none');
    }

    // === Add single-image layout class if needed ===
    if (slides.length <= 1) {
      this.element.classList.add('has-single-image');
      console.log('🖼️ Added .has-single-image to product element');
    } else {
      this.element.classList.remove('has-single-image');
    }


    if (this.options["enable_zoom"]) {
      setTimeout(() => {
        try {
          const zoom = new RevolutionImageZoom(this.element, this.carousel);
          zoom.syncHeight = zoom.syncHeight.bind(zoom);
          responsive.addResizeListener(zoom, zoom.syncHeight);
        } catch (err) {
          console.warn("⚠️ RevolutionImageZoom failed", err);
        }
      }, 200);
    }

    if (this.uspSwiperElement) {
      this.uspSwiper = new RevolutionSwiper(this.uspSwiperElement);
    }

    

    if (this.options["sticky_atc"]) {


      this.stickyAtcWrapper = this.element.querySelector(".pdp-sticky-product-atc");
      document.body.classList.add('has-sticky');
    } else {
      document.body.classList.remove('has-sticky');
    }

    this.bindEvents();
    this.bindColorHoverPreview();

    this.initScrollTintObserver();

    // Keep thumbs wrapper height aligned with the active main image.
    // Run a few times early to catch lazy-loaded images + initial Swiper layout.
    this.syncThumbnailHeight();
    requestAnimationFrame(() => this.syncThumbnailHeight());
    setTimeout(() => this.syncThumbnailHeight(), 250);

    if (this._thumbResizeListener?.removeResizeListener) {
      this._thumbResizeListener.removeResizeListener();
    }
    this._thumbResizeListener = responsive.addResizeListener(
      this,
      this.syncThumbnailHeight
    );
    this.updatePriceButtonATC();

    document.addEventListener("variant:price-updated", () => {
      this.updatePriceButtonATC();
    });

    // Initialize reload without refresh
    this.initReloadWithoutRefresh();


    this.updateNotifyButtonState();
    this.runPDPAnimations();

    this.initAwardsToggle();

  }

  initAwardsToggle() {
    setTimeout(() => {
      const swiperEl = this.element.querySelector("#productSwiperElement");
      const awardsEl = this.element.querySelector(".product-awards_wrapper");

      if (!swiperEl?.swiper || !awardsEl) return;

      const swiper = swiperEl.swiper;

      if (this._awardsToggleHandler) {
        swiper.off("slideChange", this._awardsToggleHandler);
      }

      const awardsPagination = this.element.querySelector('.main-product__awards-pagination');

      const slideHasVideoControls = (slide) => {
        if (!slide) return false;

        const videoComponent = slide.querySelector('video-component');
        if (videoComponent) {
          try {
            const settings = JSON.parse(videoComponent.getAttribute('data-section-settings') || '{}');
            if (settings.controls) return true;
          } catch (e) { }
        }

        return !!slide.querySelector('video[controls], .section-video__controls-desk--default, .vjs-control-bar');
      };

      const toggleAwards = () => {
        swiperEl.querySelectorAll('.pdp-awards-video-clone').forEach((el) => el.remove());
        awardsEl.style.display = "flex";

        if (!awardsPagination) return;

        const slide = swiper.slides[swiper.activeIndex];
        const offsetControls = responsive.matchesBreakpoint('lap_and_up') && slideHasVideoControls(slide);
        awardsPagination.classList.toggle('main-product__awards-pagination--video-controls', offsetControls);
      };

      this._awardsToggleHandler = toggleAwards;
      toggleAwards();
      swiper.on("slideChange", toggleAwards);
    }, 300);
  }

  disconnectedCallback() {
    this.cleanupEvents();
  }

  cleanupEvents() {
    if (this.domDelegate) this.domDelegate.off();
    if (this.delegateBody) this.delegateBody.off();

    if (this.carousel && this.carousel.destroy) {
      this.carousel.destroy(true, true);
      this.carousel = null;
    }
    if (this.uspSwiper && this.uspSwiper.destroy) {
      this.uspSwiper.destroy(true, true);
      this.uspSwiper = null;
    }
    if (this.boundEventHandlers.has('popstate')) {
      window.removeEventListener("popstate", this.boundEventHandlers.get('popstate'));
    }

    if (this.stickyAtcWrapper && scrollListener && typeof scrollListener.removeScrollListener === 'function') {
      try {
        scrollListener.removeScrollListener(this);
      } catch (e) { }
    }

    if (this._thumbResizeListener?.removeResizeListener) {
      try {
        this._thumbResizeListener.removeResizeListener();
      } catch (e) { }
      this._thumbResizeListener = null;
    }

    if (this._thumbSync?.destroy) {
      try {
        this._thumbSync.destroy();
      } catch (e) { }
      this._thumbSync = null;
    }

    this.boundEventHandlers.clear();
  }

  bindEvents() {
    this.domDelegate.on(
      "click",
      ".pdp-connected-product-card",
      this.selectConnectedProductCard.bind(this)
    );


    this.domDelegate.on("click", e => {
      const target = e.target;

      if (
        target.closest(".pdp-addon-product-card") ||
        target.matches("input.pdp-addon-product-card__checkbox") ||
        target.matches("input.pdp-accessory-product-card__checkbox") ||
        target.matches("label.SelectboxCircle") ||
        target.matches("div.Selectbox") ||
        target.matches("button.quantity-btn") ||
        target.matches("label.SelectboxLabelNormal")
      ) {
        this.updatePriceButtonATC();
      }
    });

    this.domDelegate.on("change", 'input[name^="options["]', (event) => {
      this.updateVariantAvailability();

      const variantJson = this.element.querySelector("variant-selects script[type='application/json']");

      const idInput = this.element.querySelector('form[data-product-form] input[name="id"]');
      if (!variantJson || !idInput) return;

      try {
        const variants = JSON.parse(variantJson.textContent);
        const currentVariant = variants.find(v => v.id == idInput.value);
        if (!currentVariant) return;

        // === Update main price ===
        const priceEls = this.element.querySelectorAll('[data-price].product-info__price--value');
        priceEls.forEach(el => {
          el.setAttribute("data-price", currentVariant.price);

          // Use theme’s format but replace any 'kr' with the actual currency code.
          const format = (window.theme.moneyFormat || "{{amount}}")
            .replace(/kr/i, window.Shopify.currency.active);

          el.textContent = Shopify.formatMoney(currentVariant.price, format);
        });


        // === Update Add to Cart and Notify wrappers ===
        const atcWrapper = this.element.querySelector('.add-to-cart__wrapper');
        const notifyWrapper = this.element.querySelector('.notify-wrapper');

        if (currentVariant.available) {
          atcWrapper?.classList.remove('hideBtn');
          notifyWrapper?.classList.add('hideBtn');
        } else {
          atcWrapper?.classList.add('hideBtn');
          notifyWrapper?.classList.remove('hideBtn');
        }

        // === Update sticky ATC ===
        const stickyAtcButton = this.stickyAtcWrapper?.querySelector('.product__atc-button');
        if (stickyAtcButton) {
          const stickyPrice = stickyAtcButton.querySelector('.button-total-price');
          if (stickyPrice) {
            stickyPrice.textContent = ` - ${Shopify.formatMoney(currentVariant.price, window.theme.moneyFormat)}`;
          }
        }

        // === Update hidden variant ID ===
        idInput.value = currentVariant.id;

        if (this.element.dataset.retailerRedirectMarket === 'true') return;

        setTimeout(() => {
          const stockContainer = [...document.querySelectorAll('.title-price__wrapper .product-info__stock')]
            .find(el => el.offsetWidth > 0 && el.offsetHeight > 0);

          if (!stockContainer) return;

          if (currentVariant.available) {
            stockContainer.classList.remove('out-of-stock');
            stockContainer.classList.add('in-stock');
            stockContainer.innerHTML = `
      <span class="stock_indicator product_avaiable"></span>
      ${window.theme.strings?.inStock || 'In stock'}
    `;
          } else {
            stockContainer.classList.remove('in-stock');
            stockContainer.classList.add('out-of-stock');
            stockContainer.innerHTML = `
      <span class="stock_indicator product_unavaiable"></span>
      ${window.theme.strings?.outOfStock || 'Out of stock'}
    `;
          }
        }, 100);




        this.updateNotifyButtonState();

      } catch (err) {
        console.warn("⚠️ Could not update ATC info for variant", err);
      }
    });




    if (this.stickyAtcWrapper) {
      if (typeof scrollListener !== 'undefined' && scrollListener.addScrollListener) {
        scrollListener.addScrollListener(this, this.showStickyAtc.bind(this));
      }
    }

    if (this.options["sticky_atc"] && this.stickyAtcWrapper) {
      this.delegateBody.on("product:added", this.hideStickyTimeout.bind(this));
      this.delegateBody.on("product:error", this.hideStickyTimeout.bind(this));
      
      // Call showStickyAtc immediately if DOM is already loaded, otherwise wait for DOMContentLoaded
      if (document.readyState === 'loading') {
        window.addEventListener("DOMContentLoaded", this.showStickyAtc.bind(this));
      } else {
        // DOM is already loaded, call it directly
        setTimeout(() => this.showStickyAtc(), 100);
      }
    }

    // Size guide overlay
    this.domDelegate.on("click", "[data-action='slidetosizeguide']", () => {
      const overlay = this.element.querySelector(".ProductSlider--SizeGuideOverlay");
      if (overlay) overlay.classList.add("is-visible");
    });

    this.domDelegate.on("click", "[data-action='closesizeguide']", () => {
      const overlay = this.element.querySelector(".ProductSlider--SizeGuideOverlay");
      if (overlay) overlay.classList.remove("is-visible");
    });

    // Reload without refresh
    const reloadPageHandler = this.reloadPage.bind(this);
    this.boundEventHandlers.set('popstate', reloadPageHandler);
    window.addEventListener("popstate", reloadPageHandler);

    this.domDelegate.on("click", '[data-action="handle-reload"]', this.updateContentWithoutReload.bind(this));


  }

  updateVariantAvailability() {
    if (this.element.dataset.retailerRedirectMarket === 'true') return;

    const variantDataEl = this.element.querySelector("variant-selects script[type='application/json']");
    if (!variantDataEl) return;

    let variants;
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch {
      console.warn("⚠️ Could not parse variant JSON");
      return;
    }

    const currentOptions = Array.from(this.element.querySelectorAll('input[name^="options["]:checked')).map(el => el.value);

    this.element.querySelectorAll('.inputSelectboxCheckbox').forEach(input => {
      const optionPos = parseInt(input.name.match(/\d+/)[0]);
      const testOptions = [...currentOptions];
      testOptions[optionPos - 1] = input.value;

      const match = variants.find(v =>
        (!v.option1 || v.option1 === testOptions[0]) &&
        (!v.option2 || v.option2 === testOptions[1]) &&
        (!v.option3 || v.option3 === testOptions[2])
      );

      const available = match && match.available;
      const label = input.nextElementSibling;
      input.classList.toggle('variant-disabled', !available);
      label.classList.toggle('opacity-50', !available);
    });
  }


  bindColorHoverPreview() {
    // scope to this component
    const currentLabelEl = this.element.querySelector('.connected-products-option-info--current');
    if (!currentLabelEl) return;

    // store original text once
    if (!currentLabelEl.dataset.originalText) {
      currentLabelEl.dataset.originalText = (currentLabelEl.textContent || '').trim();
    }

    // remove old listeners if we re-bind (optional but nice)
    if (!this._colorHoverUnbinders) this._colorHoverUnbinders = [];
    this._colorHoverUnbinders.forEach(off => off());
    this._colorHoverUnbinders = [];

    // only “other” colors have a link (current color is just a div)
    const links = this.element.querySelectorAll('.filterColor--item a[data-action="handle-reload"]');

    links.forEach(link => {
      const item = link.closest('.filterColor--item');
      if (!item) return;

      // The colour name as the merchant wrote it, diacritics included. Falls back to the old
      // derivation from the input id for markup rendered before data-color-label existed, which
      // loses characters like the ring on the Swedish a because the id is handleized.
      const input = item.querySelector('input[id^="Color-"]');
      const prettyName = item.dataset.colorLabel
        || (input?.id?.slice(6) || '')
          .replace(/-/g, ' ')
          .replace(/\b\w/g, c => c.toUpperCase());

      const enter = () => {
        if (prettyName) currentLabelEl.textContent = prettyName;
      };
      const leave = () => {
        currentLabelEl.textContent = currentLabelEl.dataset.originalText || '';
      };

      link.addEventListener('mouseenter', enter);
      link.addEventListener('mouseleave', leave);

      // keep unbinders so we can cleanly rebind after reload
      this._colorHoverUnbinders.push(() => {
        link.removeEventListener('mouseenter', enter);
        link.removeEventListener('mouseleave', leave);
      });
    });
  }



  // ========== RELOAD WITHOUT REFRESH ==========

  initReloadWithoutRefresh() {
    sessionStorage.setItem("elementaryLoad", "true");

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.preloadConnectedProducts();
        this.preloadVariants();

      });
    } else {
      this.preloadConnectedProducts();
      this.preloadVariants();

    }
  }

  async preloadVariants() {
    const variantJson = this.element.querySelector("variant-selects script[type='application/json']");
    if (!variantJson) return;

    try {
      const variants = JSON.parse(variantJson.textContent);
      const urls = variants.map(v => `${window.location.pathname}?variant=${v.id}`);
      await Promise.all(urls.map(async (url) => {
        if (contentCache[url]) return;
        const res = await fetch(url);
        if (res.ok) {
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, "text/html");
          contentCache[url] = doc;
        }
      }));
     
    } catch (err) {
      console.warn("⚠️ Could not preload variants", err);
    }
  }

  async preloadConnectedProducts() {
    const connectedProductLinks = this.element.querySelectorAll('[data-action="handle-reload"]');
    const urlsToFetch = Array.from(connectedProductLinks).map((link) => link.href);

    if (urlsToFetch.length === 0) return;

    const fetchAndCacheContent = async (url) => {
      try {
        const response = await fetch(url);
        if (response.ok) {
          const htmlContent = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlContent, "text/html");
          contentCache[url] = doc;
        }
      } catch (error) {
        console.error("Error fetching:", url, error);
      }
    };

    await Promise.all(urlsToFetch.map(fetchAndCacheContent));

    // Preload images
    const preloadImages = (doc) => {
      const images = doc.querySelectorAll(".ProductSlider--ImageFirst");
      images.forEach((img) => {
        const preloadedImage = new Image();
        const src = img.getAttribute("data-src") || img.getAttribute("src");
        if (src) {
          preloadedImage.src = src.replace("{width}x", "2600x");
        }
      });
    };

    Object.values(contentCache).forEach(preloadImages);
  }

  updateDynamicPdpSections(cachedDoc) {
    if (!cachedDoc) return;

    document.querySelectorAll('[data-pdp-dynamic]').forEach((marker) => {
      const sectionId = marker.getAttribute('data-pdp-dynamic');
      if (!sectionId) return;

      const currentSection = document.getElementById(`shopify-section-${sectionId}`);
      const cachedSection = cachedDoc.getElementById(`shopify-section-${sectionId}`);
      if (!currentSection || !cachedSection) return;

      currentSection.innerHTML = cachedSection.innerHTML;
      this.reinitializePdpSection(currentSection);
    });
  }

  reinitializePdpSection(sectionEl) {
    if (!sectionEl) return;

    sectionEl.querySelectorAll('section-usp').forEach((el) => {
      customElements.upgrade(el);
      if (typeof el.connectedCallback === 'function') {
        el.connectedCallback();
      }
    });

    sectionEl.querySelectorAll('swiper-init').forEach((el) => {
      customElements.upgrade(el);
      if (typeof el.connectedCallback === 'function') {
        el.connectedCallback();
      }
    });

    new RevolutionAnimation(sectionEl);
  }

  updateContentWithoutReload(e) {
    e.preventDefault();
    const link = e.target.closest('[data-action="handle-reload"]');
    if (!link) return;

    const url = link.href;
    const cachedContent = contentCache[url];

    if (cachedContent) {
      // Update title
      const cachedTitle = cachedContent.querySelector('title');
      if (cachedTitle) {
        document.title = cachedTitle.textContent;
      }

      const currentProductComponent = document.querySelector("product-component");

      if (currentProductComponent && cachedContent) {
        const cachedProductComponent = cachedContent.querySelector("product-component");

        if (cachedProductComponent) {
          // Replace content
          currentProductComponent.innerHTML = cachedProductComponent.innerHTML;
          currentProductComponent.className = cachedProductComponent.className;
          Array.from(cachedProductComponent.attributes).forEach(attr => {
            currentProductComponent.setAttribute(attr.name, attr.value);
          });

          // Cleanup and reinitialize
          this.cleanupEvents();
          this.reinitializeAfterContentUpdate();
          this.updateDynamicPdpSections(cachedContent);

          // Dispatch recommendations reload
          const sectionSettings = JSON.parse(this.element.getAttribute("data-section-settings"));
          if (sectionSettings && sectionSettings.product_id) {
            document.body.dispatchEvent(
              new CustomEvent("recommendations:reload", {
                bubbles: true,
                detail: sectionSettings.product_id
              })
            );
          }

          // Update URL
          history.pushState(null, null, url);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          this.fetchAndNavigate(url);
        }
      } else {
        this.fetchAndNavigate(url);
      }
    } else {
      this.fetchAndNavigate(url);
    }
  }

  async handleVariantChangeReload(variantId) {
    if (!variantId) return;

    const url = `${window.location.pathname}?variant=${variantId}`;
    let cachedContent = contentCache[url];

    if (!cachedContent) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch variant content");
        const html = await response.text();
        const parser = new DOMParser();
        cachedContent = parser.parseFromString(html, "text/html");
        contentCache[url] = cachedContent;
      } catch (err) {
        console.error("❌ Error fetching variant:", err);
        window.location.href = url;
        return;
      }
    }

    const currentProductComponent = document.querySelector("product-component");
    const cachedProductComponent = cachedContent.querySelector("product-component");
    if (!currentProductComponent || !cachedProductComponent) return;

    // Replace the full element instead of just innerHTML
    const newComponent = cachedProductComponent.cloneNode(true);
    currentProductComponent.replaceWith(newComponent);

    // ✅ Rebind custom element manually
    customElements.upgrade(newComponent);

    // ✅ Manually run its lifecycle setup again
    if (typeof newComponent.connectedCallback === "function") {
      newComponent.connectedCallback();
    }

    history.replaceState(null, null, url);
    console.log("✅ Variant reload fully replaced & reinitialized:", url);
  }

  updateNotifyButtonState() {
    const translationsEl = document.querySelector('#notify-translations');
    const soldOutText = translationsEl?.dataset.soldOut;
    const outOfStockText = translationsEl?.dataset.outOfStock;

    const hasPopup = !!document.querySelector('notify-me-popup');
    const notifyBtn = this.element.querySelector('.notify-wrapper button, .notify-wrapper [role="button"]');

    if (!notifyBtn) return;

    if (hasPopup) {
      notifyBtn.textContent = soldOutText;
      notifyBtn.removeAttribute('disabled');
      notifyBtn.setAttribute('data-action', 'toggle-popup');
      notifyBtn.setAttribute('aria-controls', 'notify-me-popup');
    } else {
      notifyBtn.textContent = outOfStockText;
      notifyBtn.setAttribute('disabled', 'disabled');
      notifyBtn.removeAttribute('data-action');
      notifyBtn.removeAttribute('aria-controls');
    }
  }



  async fetchAndNavigate(url) {
    const currentProductComponent = document.querySelector("product-component");
    if (currentProductComponent) {
      currentProductComponent.style.opacity = '0.5';
      currentProductComponent.style.pointerEvents = 'none';
    }

    try {
      const response = await fetch(url);
      if (response.ok) {
        const htmlContent = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, "text/html");

        contentCache[url] = doc;

        if (currentProductComponent) {
          currentProductComponent.style.opacity = '';
          currentProductComponent.style.pointerEvents = '';
        }

        this.updateContentWithoutReload({
          preventDefault: () => { },
          target: { closest: () => ({ href: url }) }
        });
      } else {
        window.location.href = url;
      }
    } catch (error) {
      window.location.href = url;
    }
  }

  reinitializeAfterContentUpdate() {
    this.carousel = null;
    this.uspSwiper = null;

    // Re-query elements
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(".main-product__thumbs");
    this.uspSwiperElement = this.element.querySelector(".product-usp__swiper.swiper");
    this.tintElement = this.element.querySelector('.ProductSlider--Tint');
    this.wrapperElement = this.element.querySelector('.main-product__slider');
    this.productInfoWrapper = document.querySelector('.product-info__wrapper');
    this.mainAtc = this.element.querySelector(".product-info__actions");
    this.stickyAtcWrapper = this.element.querySelector(".pdp-sticky-product-atc");
    this.valuesWrap = this.element.querySelectorAll(".ProductOption--ValusWrapper");

    // Re-parse options
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    // Reinitialize carousel
    const slides = this.carouselElement?.querySelectorAll('.swiper-slide') || [];

    if (slides.length > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement, this.carouselElementThumbs);
    } else {
      const buttons = this.element.querySelectorAll('.pdp_swiperButton');
      buttons.forEach(btn => btn.style.display = 'none');
    }

    if (slides.length <= 1) {
      this.element.classList.add('has-single-image');
    } else {
      this.element.classList.remove('has-single-image');
    }


    // Reinitialize zoom
    if (this.options["enable_zoom"]) {
      setTimeout(() => {
        try {
          const zoom = new RevolutionImageZoom(this.element, this.carousel);
          zoom.syncHeight = zoom.syncHeight.bind(zoom);
          responsive.addResizeListener(zoom, zoom.syncHeight);
        } catch (err) {
          console.warn("⚠️ Zoom failed", err);
        }
      }, 200);
    }

    // Reinitialize USP swiper
    if (this.uspSwiperElement) {
      this.uspSwiper = new RevolutionSwiper(this.uspSwiperElement);
    }

    // Reinitialize other components
    new AddToCart(this.element);
    this.bindEvents();
    this.bindColorHoverPreview();
    this.initScrollTintObserver();

    // Update sticky ATC
    if (this.options["sticky_atc"]) {
      document.body.classList.add('has-sticky');
      // Reinitialize sticky ATC after content update
      setTimeout(() => {
        if (this.stickyAtcWrapper) {
          this.showStickyAtc();
        }
      }, 200);
    } else {
      document.body.classList.remove('has-sticky');
    }

    // Sync heights
    if (this._thumbSync?.destroy) {
      try {
        this._thumbSync.destroy();
      } catch (e) { }
      this._thumbSync = null;
    }

    this.syncThumbnailHeight();
    requestAnimationFrame(() => this.syncThumbnailHeight());
    setTimeout(() => this.syncThumbnailHeight(), 250);

    if (this._thumbResizeListener?.removeResizeListener) {
      try {
        this._thumbResizeListener.removeResizeListener();
      } catch (e) { }
    }
    this._thumbResizeListener = responsive.addResizeListener(
      this,
      this.syncThumbnailHeight
    );
    this.updatePriceButtonATC();
    this.changeImageQuality();

    this.initAwardsToggle();

    // === Ensure Buy Buttons Visibility ===
    const forms = this.element.querySelectorAll('form[data-product-form]');
    forms.forEach((form) => {
      const atcWrapper = form.querySelector('.add-to-cart__wrapper');
      const notifyWrapper = form.querySelector('.notify-wrapper');
      const idInput = form.querySelector('input[name="id"]');
      const variantId = idInput?.value;

      if (!variantId) return;

      const variantData = this.element.querySelector('variant-selects script[type="application/json"]');
      if (!variantData) return;

      try {
        const variants = JSON.parse(variantData.textContent);
        const currentVariant = variants.find(v => v.id == variantId);
        if (!currentVariant) return;

        if (currentVariant.available) {
          atcWrapper?.classList.remove('hideBtn');
          notifyWrapper?.classList.add('hideBtn');
        } else {
          atcWrapper?.classList.add('hideBtn');
          notifyWrapper?.classList.remove('hideBtn');
        }
      } catch (err) {
        console.warn("⚠️ Could not toggle buy buttons after reload", err);
      }
    });

  }

  reloadPage(e) {
    window.location.reload();
  }

  // ========== EXISTING METHODS ==========

  updateImage(event) {
    let imageID = this.options.variant_image_id;
    if (event?.detail?.new_image) {
      imageID = event.detail.new_image;
    }
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);
    if (!imageEl) return;

    const slideElement = imageEl.closest('.swiper-slide');
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(slideElement);

    this.carousel.selectCell(realIndex);
  }

  syncThumbnailHeight() {
    const mainWrapper = this.element.querySelector('.main-product__slider');
    const thumbsWrapper = this.element.querySelector('.main-product__thumbs-wrapper');
    if (!mainWrapper || !thumbsWrapper) return;

    const reset = () => {
      thumbsWrapper.style.height = '';
      thumbsWrapper.style.maxHeight = '';
      thumbsWrapper.style.overflow = '';
      const innerSwiperEl = thumbsWrapper.querySelector('.swiper');
      if (innerSwiperEl) {
        innerSwiperEl.style.height = '';
        innerSwiperEl.style.overflowY = '';
      }
    };

    // Mobile/tablet: don't force a fixed height.
    if (window.innerWidth < 1025) {
      reset();
      return;
    }

    // Create a single, reusable sync controller so we don't attach duplicate listeners
    // every time this method is called (it is also invoked on resize).
    if (!this._thumbSync) {
      const state = {
        raf: null,
        tries: 0,
        maxTries: 24,
        ro: null,
        onImgLoad: null,
        mainSwiper: null,
        mainSwiperHandlers: [],
      };

      const getActiveMediaHeight = () => {
        const slider =
          this.element.querySelector('.swiper.mainSwiper') ||
          this.element.querySelector('.main-product__slider .swiper');

        const activeSlide =
          slider?.querySelector('.swiper-slide-active') ||
          this.element.querySelector('.swiper-slide-active');

        if (!activeSlide) return 0;

        // Prefer a specific media element height, but fall back to the slide height
        // (important when the first slide is a video or model, not an image).
        const candidates = [
          activeSlide.querySelector('img.ProductSlider--Image'),
          activeSlide.querySelector('img'),
          activeSlide.querySelector('video'),
          activeSlide.querySelector('.VideoRatio'),
          activeSlide.querySelector('.videoWrapper'),
          activeSlide.querySelector('model-viewer'),
          activeSlide.querySelector('.AspectRatio'),
        ].filter(Boolean);

        let best = 0;
        candidates.forEach((el) => {
          const h = el.getBoundingClientRect().height;
          if (h > best) best = h;
        });

        if (best > 0) return best;
        return activeSlide.getBoundingClientRect().height || 0;
      };

      const applyHeight = (imgHeight) => {
        const wrapper = this.element.querySelector('.main-product__thumbs-wrapper');
        if (!wrapper) return;

        wrapper.style.height = `${imgHeight}px`;
        wrapper.style.maxHeight = `${imgHeight}px`;
        wrapper.style.overflow = 'hidden';

        const innerSwiperEl = wrapper.querySelector('.swiper');
        if (innerSwiperEl) {
          innerSwiperEl.style.height = `${imgHeight}px`;
          innerSwiperEl.style.overflowY = 'auto';
        }

        // Update thumbs swiper (if present) after sizing.
        const thumbsSwiper =
          this.carousel?.thumbSwiper ||
          this.element.querySelector('.main-product__thumbs')?.swiper;
        thumbsSwiper?.update?.();
      };

      const updateOnce = () => {
        const wrapper = this.element.querySelector('.main-product__thumbs-wrapper');
        if (!wrapper) return;

        if (window.innerWidth < 1025) {
          reset();
          return;
        }

        const mediaHeight = getActiveMediaHeight();
        const valid =
          mediaHeight > 50 &&
          mediaHeight < window.innerHeight * 2 &&
          Number.isFinite(mediaHeight);

        if (valid) {
          state.tries = 0;
          applyHeight(mediaHeight);
          return;
        }

        // When refreshing, the active image is often not laid out yet (lazyload/Swiper init).
        // Retry for a short period so it syncs from the start without user interaction.
        if (state.tries < state.maxTries) {
          state.tries += 1;
          state.raf = requestAnimationFrame(updateOnce);
        }
      };

      const bindSwiperIfNeeded = () => {
        const swiper = this.carousel?.swiperElement || this.carouselElement?.swiper;
        if (!swiper || swiper === state.mainSwiper) return;

        state.mainSwiper = swiper;

        const on = (eventName, handler) => {
          try {
            swiper.on(eventName, handler);
            state.mainSwiperHandlers.push([eventName, handler]);
          } catch (e) { }
        };

        const updateDebounced = debounce(() => updateOnce(), 50);
        on('afterInit', updateDebounced);
        on('imagesReady', updateDebounced);
        on('resize', updateDebounced);
        on('observerUpdate', updateDebounced);
        on('slideChangeTransitionEnd', updateDebounced);
      };

      // Capture `load` events for any image inside the main wrapper (works even if
      // images are added later), and re-sync.
      state.onImgLoad = () => updateOnce();
      mainWrapper.addEventListener('load', state.onImgLoad, true);

      // Watch layout shifts of the main wrapper.
      state.ro = new ResizeObserver(() => updateOnce());
      state.ro.observe(mainWrapper);

      // Public controller API
      this._thumbSync = {
        update: () => {
          if (state.raf) cancelAnimationFrame(state.raf);
          state.tries = 0;
          bindSwiperIfNeeded();
          updateOnce();
          // Also retry once shortly after, for late style/layout application.
          setTimeout(() => updateOnce(), 120);
        },
        destroy: () => {
          if (state.raf) cancelAnimationFrame(state.raf);
          if (state.onImgLoad) mainWrapper.removeEventListener('load', state.onImgLoad, true);
          if (state.ro) state.ro.disconnect();
          if (state.mainSwiper && state.mainSwiper.off) {
            state.mainSwiperHandlers.forEach(([eventName, handler]) => {
              try {
                state.mainSwiper.off(eventName, handler);
              } catch (e) { }
            });
          }
          state.mainSwiperHandlers = [];
          state.mainSwiper = null;
        }
      };
    }

    this._thumbSync.update();
  }


  initScrollTintObserver() {
    if (!this.wrapperElement || !this.tintElement || !this.productInfoWrapper) return;

    window.addEventListener('scroll', this.updateTintOpacity.bind(this));
    window.addEventListener('resize', this.updateTintOpacity.bind(this));

    this.updateTintOpacity();
  }

  selectConnectedProductCard(event) {
    const clickedCard = event.target.closest(".pdp-connected-product-card");
    if (!clickedCard) return;

    const allCards = this.element.querySelectorAll(".pdp-connected-product-card");
    allCards.forEach(card => card.classList.remove("pdp-connected-product-card--selected"));

    clickedCard.classList.add("pdp-connected-product-card--selected");
  }

  updateTintOpacity() {
    const wrapperRect = this.wrapperElement.getBoundingClientRect();
    const infoRect = this.productInfoWrapper.getBoundingClientRect();

    const overlapTop = Math.max(wrapperRect.top, infoRect.top);
    const overlapBottom = Math.min(wrapperRect.bottom, infoRect.bottom);
    const overlapHeight = Math.max(0, overlapBottom - overlapTop);

    const wrapperHeight = wrapperRect.height;
    const overlapRatio = Math.min(overlapHeight / wrapperHeight, 1);

    const scaledOpacity = Math.max(0, Math.min(overlapRatio * 2, 1));

    this.tintElement.style.opacity = scaledOpacity.toFixed(2);
  }

  calculateTotalPrice() {
    let total = 0;

    const mainPriceEl = this.element.querySelector('[data-price].product-info__price--value');
    if (mainPriceEl) {
      const price = parseFloat(mainPriceEl.getAttribute("data-price"));
      total += isNaN(price) ? 0 : price;
    }

    const checkedAddons = this.element.querySelectorAll('.pdp-addon-product-card__checkbox:checked[data-price]');
    checkedAddons.forEach(input => {
      const price = parseFloat(input.getAttribute("data-price")) || 0;
      total += price;
    });

    const checkedAccessories = this.element.querySelectorAll('.pdp-accessory-product-card__checkbox:checked[data-price]');
    checkedAccessories.forEach(input => {
      const price = parseFloat(input.getAttribute("data-price")) || 0;
      const productId = input.getAttribute("data-productid");
      const qtyInput = this.element.querySelector(`.quantity-input[data-productid="${productId}"]`);
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      total += price * qty;
    });

    return total;
  }

  updatePriceButtonATC() {
    const total = this.calculateTotalPrice();
    const formatted = Shopify.formatMoney(total, window.theme.moneyFormat);

    this.element.querySelectorAll(".product__atc-button .button-total-price").forEach(span => {
      const button = span.closest(".product__atc-button");
      if (button && button.hasAttribute("disabled")) return;

      span.textContent = ` - ${formatted}`;
    });
  }

  hideStickyTimeout() {
    this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
    this.hideSticky = true;
    setTimeout(() => {
      this.hideSticky = false;
      this.showStickyAtc();
    }, 3000);
  }

  showStickyAtc() {
    if (!this.stickyAtcWrapper || this.hideSticky) return;

    const mainAtc = this.mainAtc;
    if (!mainAtc) return;

    const footer = document.querySelector("footer");

    const isAtBottom = () => {
      if (footer) {
        const footerHeight = footer.offsetHeight;
        return window.innerHeight + window.scrollY >= document.body.offsetHeight - footerHeight + 60;
      }
      return window.innerHeight + window.scrollY >= document.body.offsetHeight - 100;
    };

    const updateSticky = () => {
      if (this.hideSticky) return;
      const rect = mainAtc.getBoundingClientRect();
      // Only show when main ATC has been scrolled past (bottom above viewport)
      const scrolledPast = rect.bottom < 0;
      if (isAtBottom()) {
        this.toggleStickyAtc(false);
      } else {
        this.toggleStickyAtc(scrolledPast);
      }
    };

    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();
  }



  toggleStickyAtc(show) {
    if (this.hideSticky) return;
    this.stickyAtcWrapper.setAttribute("aria-hidden", show ? "false" : "true");
    document.body.classList.toggle("has-sticky", show);
  }

  changeImageQuality() {
    const imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }


  runPDPAnimations() {
    const items = this.element.querySelectorAll("[data-animation]:not([data-loaded])");

    items.forEach((item, i) => {
      const type = item.dataset.animation;

      const animations = {
        elementFadeIn: [
          { opacity: 0 },
          { opacity: 1 }
        ],
        elementFromTop: [
          { transform: "translateY(-30px)", opacity: 0 },
          { transform: "translateY(0)", opacity: 1 }
        ],
        elementFromBottom: [
          { transform: "translateY(30px)", opacity: 0 },
          { transform: "translateY(0)", opacity: 1 }
        ]
      };

      const keyframes = animations[type] || animations.elementFadeIn;

      item.setAttribute("data-loaded", "true");

      setTimeout(() => {
        item.animate(keyframes, {
          duration: window.theme.animationDuration || 400,
          fill: "forwards"
        });
      }, (window.theme.animationBetweenElements || 50) * i);
    });
  }



}

customElements.define("product-component", ProductElement);


class VariantSelectBox extends HTMLElement {
  constructor() {
    super();
    this.element = this; // reference to our element
  }

  connectedCallback() {
    // Keep this minimal: just init, observe resize, bind events, do initial layout
    this.observeResize();
    this.bindEvents();
    this.calculateLayout();
  }

  /**
   * If you have a custom responsive utility, use that;
   * otherwise, fall back to window resize
   */
  observeResize() {
    if (typeof responsive !== "undefined" && responsive.addResizeListener) {
      responsive.addResizeListener(this, this.handleResize.bind(this));
    } else {
      window.addEventListener("resize", this.handleResize.bind(this));
    }
  }

  /**
   * Use your original approach (Delegate) to bind show-more / show-less
   */
  bindEvents() {
    // We attach delegate to the wrapper (or this.element) - your choice
    this.delegateElement = new Delegate(this.selectBoxWrapper);

    // Show more
    this.delegateElement.on(
      "click",
      '[data-action="show-more"]',
      this.showAllVariants.bind(this)
    );

    // Show less
    this.delegateElement.on(
      "click",
      '[data-action="show-less"]',
      this.showLessVariants.bind(this)
    );
  }

  /**
   * Main layout logic: measure how many variants fit in one row,
   * ensuring the + x more button (if needed) is also in the same row.
   */
  calculateLayout() {
    if (!this.selectBoxWrapper) return;

    // Temporarily show everything so we can measure
    this.variants.forEach((variant) => {
      variant.style.display = ""; // revert to default (inline-block/flex)
    });
    // Show plus, hide minus for measurement
    if (this.plusButton) this.plusButton.style.display = "";
    if (this.minusButton) this.minusButton.style.display = "none";

    const availableWidth = this.selectBoxWrapper.offsetWidth;
    if (!availableWidth) return;

    // If no variants, just hide plus/minus
    if (this.totalVariants === 0) {
      if (this.plusButton) this.plusButton.style.display = "none";
      if (this.minusButton) this.minusButton.style.display = "none";
      return;
    }

    // Measure a single variant's width (use first variant as a reference)
    const singleVariantWidth = this.variants[0].offsetWidth;
    // Gap (if you have margin, measure it via getComputedStyle; here we assume 4px)
    const variantGap = 8;

    // Measure plus button width
    const plusButtonWidth = this.plusButton ? this.plusButton.offsetWidth : 0;
    let itemsInFirstRow = 0;
    let totalWidthSoFar = 0;

    // Figure out how many variants we can fit in one row
    for (let i = 0; i < this.variants.length; i++) {
      // Width for this variant (plus gap if it's not the first)
      const widthNeeded = variantGap + singleVariantWidth;

      // If there's another variant *after* this one,
      // we must reserve space for the plus button in THIS row.
      const stillMoreVariantsRemain = (i < this.variants.length - 1);
      const spaceNeededForPlus = stillMoreVariantsRemain ? plusButtonWidth : 0;


      // Check if this variant + plus button (if more remain) fits
      if (totalWidthSoFar + widthNeeded + spaceNeededForPlus <= availableWidth) {
        itemsInFirstRow++;
        totalWidthSoFar += widthNeeded;

      } else {
        // As soon as we can't fit the next variant + button, we stop
        break;
      }
    }

    // If all variants fit, hide plus/minus
    if (itemsInFirstRow >= this.totalVariants) {
      // Show all
      this.variants.forEach((variant) => {
        variant.style.display = "";
      });
      if (this.plusButton) this.plusButton.style.display = "none";
      if (this.minusButton) this.minusButton.style.display = "none";
    } else {
      // We show only itemsInFirstRow
      this.variants.forEach((variant, idx) => {
        variant.style.display = idx < itemsInFirstRow ? "" : "none";
      });

      // Show plus button with the correct count
      if (this.plusButton) {
        this.remaining = this.totalVariants - itemsInFirstRow;
        this.plusButton.style.display = "";
        this.plusButton.innerText = `+ ${this.remaining} more`;
      }
      // Hide minus button initially
      if (this.minusButton) {
        this.minusButton.style.display = "none";
      }
    }
  }

  handleResize() {
    this.calculateLayout();
  }

  /**
   * Show all items, hide plus button, show minus button
   */
  showAllVariants(event, target) {
    // Show all variants
    this.variants.forEach((variant) => {
      variant.style.display = "";
    });
    // Hide plus button
    if (this.plusButton) {
      this.plusButton.style.display = "none";
    }
    // Show minus with updated text
    if (this.minusButton) {
      this.minusButton.innerText = `- ${this.remaining} less`;
      this.minusButton.style.display = "";
    }
  }

  /**
   * Collapse items back to what fits in one row
   */
  showLessVariants(event, target) {
    this.calculateLayout();
  }
}

customElements.define("variant-selectbox", VariantSelectBox);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.atcButtons = document.querySelectorAll(".product__atc-button");
    this.stickyAtcWrapper = document.querySelector(".pdp-sticky-product-atc");
    this.notifyButtons = document.querySelectorAll(
      ".product-module__product-atc-notify"
    );

    this.notifyStickyAddButton = document.querySelector(
      ".product-module__product-atc"
    );

    this.regularPrice = document.querySelector(
      "product-component .product-info__price--regular span"
    );
    this.compareAtPrice = document.querySelector(
      "product-component .product-info__price--compare"
    );

    this.regularPriceSticky = document.querySelector(".product-module__sticky-atc product-info__price--regular span");
    this.compareAtPriceSticky = document.querySelector(".product-module__sticky-atc .product-info__price--compare");

    this.pricesWrapper = document.querySelector(
      ".product-info__price"
    );



    this.bindEvents();
  }

  bindEvents() {
    this.onVariantChange();

    this.delegateElement.on('change', 'select, input', this.onVariantChange.bind(this));
    this.delegateBody.on('click', '[data-action="click-atc"]', this.clickAtc.bind(this));
    this.delegateElement.on('click', '.quantity-btn.increase, .quantity-btn.decrease', () => {
      this.initAccessoryStateSync();
    });
  }

  clickAtc(event) {
    event.preventDefault();
    document.querySelector('.product-info__actions .product__atc-button').click();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    this.toggleAddButton();
    this.updateAvailability();
    this.updatePriceElements(this.regularPrice, this.compareAtPrice);
    if (this.stickyAtcWrapper) this.updatePriceElements(this.regularPriceSticky, this.compareAtPriceSticky);
    document.dispatchEvent(new CustomEvent("variant:price-updated"));
    this.updateLowestPrice();
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateSelectedTexts();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateAvailability() {
    const productComponent = this.closest('product-component');
    if (productComponent?.dataset.retailerRedirectMarket === 'true') return;

    let availableSuccessDiv = document.querySelector(".availability-success__wrapper");
    let availableErrorDiv = document.querySelector(".availability-error__wrapper")

    this.currentVariant = this.updateMasterId();

    if (this.currentVariant.available) {
      availableSuccessDiv.setAttribute("aria-hidden", false);
      availableErrorDiv.setAttribute("aria-hidden", true);
    } else {
      availableSuccessDiv.setAttribute("aria-hidden", true);
      availableErrorDiv.setAttribute("aria-hidden", false);
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    return this.currentVariant;
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updatePriceElements(regularPriceElement, compareAtPriceElement) {
    if (regularPriceElement) {
      this.regularPriceTag = this.currentVariant.price;
      regularPriceElement.innerHTML = Shopify.formatMoney(
        this.regularPriceTag,
        window.theme.moneyFormat
      );
      regularPriceElement.setAttribute('data-price', this.regularPriceTag);
    }

    if (compareAtPriceElement) {
      this.compareAtPriceTag = this.currentVariant.compare_at_price;
      if (this.compareAtPriceTag) {
        compareAtPriceElement.innerHTML = Shopify.formatMoney(
          this.compareAtPriceTag,
          window.theme.moneyFormat
        );
        compareAtPriceElement.setAttribute('data-price', this.compareAtPriceTag);
      } else {
        compareAtPriceElement.innerText = "";
        compareAtPriceElement.removeAttribute('data-price');
      }
    } else if (this.currentVariant.compare_at_price) {
      this.compareAtPriceTag = this.currentVariant.compare_at_price;
      const compareAtPriceEl = this.element.querySelector(".product-info__price--compare");

      if (compareAtPriceEl) {
        compareAtPriceEl.textContent = Shopify.formatMoney(
          this.compareAtPriceTag,
          window.theme.moneyFormat
        );
        compareAtPriceEl.setAttribute('data-price', this.compareAtPriceTag);
      }
    } else {
      if (compareAtPriceElement) {
        compareAtPriceElement.innerText = "";
        compareAtPriceElement.removeAttribute('data-price');
      }
    }
  }

  updateLowestPrice() {
    let allMetaVariants = document.querySelectorAll(".lowest-price-meta");
    const lowestPriceInput = document.querySelectorAll(
      ".product-info__price--lowest span"
    );

    const lowestPriceDiv = document.querySelectorAll(
      ".product-info__price--lowest"
    );

    allMetaVariants.forEach((meta) => {
      if (meta.getAttribute("data-variant_id") == this.currentVariant.id) {
        let lowestPrice = meta.getAttribute("meta-data");

        lowestPriceInput.forEach((input) => {
          input.innerHTML = Shopify.formatMoney(
            lowestPrice * 100,
            window.theme.moneyFormat
          );
        });

        lowestPriceDiv.forEach((item) => {
          item.style.display = "flex";
        });

        if (lowestPrice == 0) {
          lowestPriceDiv.forEach((item) => {
            item.style.display = "none";
          });
        }
      }
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".ProductInfo--Prices";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);


        if (source && destinations) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        this.toggleAddButton();
      });
  }

  toggleAddButton() {
    const productComponent = this.closest('product-component');
    if (productComponent?.dataset.retailerRedirectMarket === 'true') return;

    let hideButtons = document.querySelectorAll(".hideBtn");
    hideButtons.forEach(function (button) {
      button.classList.remove("hideBtn");
    });

    const addButton = document.querySelectorAll(".product__atc-button");

    if (!addButton) return;

    if (this.currentVariant.available == false) {
      addButton.forEach((button) => {
        button.classList.add("hideBtn");
      });
    } else {
      addButton.forEach((button) => {
        button.dataset.action = 'add-to-cart';
        if (button.classList.contains('product-module__product-atc--sticky')) {
          button.dataset.action = 'click-atc';
        }

        button.classList.remove("hideBtn");
        const addToCartTxt = button.querySelectorAll('.product__atc-button .ButtonText:not(.button-total-price)');
        addToCartTxt.forEach(txt => {
          txt.textContent = window.variantStrings.addToCart.toUpperCase();
        })
      });
    }

    this.showNotifyMeButton(this.currentVariant.available);
  }

  showNotifyMeButton(available) {
    if (!this.notifyButtons) return;

    if (available) {
      this.notifyButtons.forEach((btn) => (btn.style.display = "none"));
      this.atcButtons.forEach((btn) => (btn.style.display = "flex"));

    } else {
      this.notifyButtons.forEach((btn) => (btn.style.display = "flex"));
      this.atcButtons.forEach((btn) => (btn.style.display = "none"));
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateSelectedTexts() {
    if (!this.currentVariant) return;

    // Loop through all spans with data-selected-text
    this.querySelectorAll('[data-selected-text]').forEach(el => {
      const index = parseInt(el.getAttribute('data-option-index'), 10);
      const value = this.currentVariant.options[index]; // options array from Shopify
      if (value) el.textContent = value;
    });
  }


}
customElements.define("variant-selects", VariantSelects);

class AccessoryProductQuantity extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.input = this.element.querySelector(".quantity-input");
    this.decreaseBtn = this.element.querySelector(".quantity-btn.decrease");
    this.increaseBtn = this.element.querySelector(".quantity-btn.increase");
    this.priceElement = this.element.querySelector(".pdp-accessory-product-card--price");

    this.initPriceSync();
    this.initAccessoryStateSync();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '.quantity-btn.increase', this.onIncreaseClick.bind(this));
    this.delegateElement.on('click', '.quantity-btn.decrease', this.onDecreaseClick.bind(this));
    this.delegateElement.on('change', '.pdp-accessory-product-card__checkbox', this.updateAccessoryState.bind(this));
    this.delegateElement.on('input', '.quantity-input', this.updateAccessoryState.bind(this));
  }

  initPriceSync() {
    if (!this.input || !this.priceElement || !this.increaseBtn || !this.decreaseBtn) return;

    const base = parseFloat(this.priceElement.dataset.basePrice);
    if (isNaN(base)) return;
    this.basePrice = base;

    this.updatePrice();
  }

  initAccessoryStateSync() {
    const checkbox = this.closest('.pdp-accessory-product-card')?.querySelector('.pdp-accessory-product-card__checkbox');
    const rightElement = this.element.querySelector('.pdp-accessory-product-card--right');
    const quantityInput = this.closest('.pdp-accessory-product-card')?.querySelector('.quantity-input');
    const decreaseButton = this.closest('.pdp-accessory-product-card')?.querySelector('.quantity-btn.decrease');

    if (checkbox && rightElement && quantityInput && decreaseButton) {
      const updateState = () => {
        rightElement.classList.toggle('pdp_accessory-disabled', !checkbox.checked);

        (checkbox.checked && parseInt(quantityInput.value, 10) === 1)
          ? decreaseButton.classList.add('decrease--disabled')
          : decreaseButton.classList.remove('decrease--disabled');
      };

      this.updateAccessoryState = updateState;
      updateState();
    }
  }

  onIncreaseClick(event) {
    let value = Number(this.input.value);
    const max = parseInt(this.input.max);

    if (value < max) {
      this.input.value = value + 1;
      this.updatePrice();
      this.triggerQuantityInputEvent();
    }
  }

  onDecreaseClick(event) {
    let value = Number(this.input.value);
    const min = parseInt(this.input.min);

    if (value > min) {
      this.input.value = value - 1;
      this.updatePrice();
      this.triggerQuantityInputEvent();
    }
  }

  updatePrice() {
    const min = parseInt(this.input.min);
    const max = parseInt(this.input.max);
    let quantity = Math.min(Math.max(parseInt(this.input.value) || 0, min), max);
    this.input.value = quantity;

    const total = this.basePrice * quantity;
    this.priceElement.textContent = `+ ${Shopify.formatMoney(total, window.theme.moneyFormat)}`;

    this.dispatchEvent(new CustomEvent("quantity:changed", { bubbles: true }));
  }

  triggerQuantityInputEvent() {
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('accessory-product-quantity', AccessoryProductQuantity);

class NotifyMePopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(document.body);
    this.bindEvents();

  }

  bindEvents() {
    this.delegateElement.on(
      "submit",
      ".notify-me__popup-inputs",
      (e) => {
        console.log("Delegate caught form submit event!", e.target);
        this.submitNotifyMe(e);
      }
    );


    this.delegateElement.on("click", ".notify-me__close-btn", (e) => {
      e.preventDefault();
      this.closeNotifyPopup();
    });



  }


  closeNotifyPopup() {
    const popup = document.getElementById("notify-me-popup");
    if (!popup) return;

    const overlay = document.querySelector(".notify-me__overlay");
    const scrollableElement = popup.querySelector('[data-scrollable]') || popup;

    if (window.globalPopup) {
      const index = window.globalPopup.activePopups.indexOf(popup);
      if (index !== -1) {
        window.globalPopup.activePopups.splice(index, 1);
      }
      if (overlay && popup._overlayClickHandler) {
        overlay.removeEventListener('click', popup._overlayClickHandler);
        delete popup._overlayClickHandler;
      }
      removeTrapFocus(popup);
      window.globalPopup.updateToggleAria(popup, false);
    }

    popup._isOpening = false;
    popup._isClosing = false;
    popup.style.display = '';
    popup.style.transform = '';
    popup.style.opacity = '';
    popup.style.visibility = '';
    popup.style.pointerEvents = '';

    if (typeof bodyScrollLock !== 'undefined' && scrollableElement) {
      try {
        bodyScrollLock.enableBodyScroll(scrollableElement);
      } catch (error) { }
    }
    document.body.classList.remove("scrollLock");

    overlay?.classList.remove("is-visible");
    popup.setAttribute("aria-expanded", "false");

    popup.classList.add("closing");
    popup.addEventListener(
      "animationend",
      () => {
        popup.classList.remove("closing");
        popup.setAttribute("aria-hidden", "true");
        popup.setAttribute("aria-visible", "false");
      },
      { once: true }
    );
  }


  openPopup() {
    const popup = document.getElementById("notify-me-popup");
    const overlay = document.querySelector(".notify-me__overlay");
    const scrollableElement = popup?.querySelector('[data-scrollable]') || popup;

    if (popup) {
      popup.setAttribute("aria-hidden", "false");
      popup.setAttribute("aria-visible", "true");
      overlay?.classList.add("is-visible");
      if (typeof bodyScrollLock !== 'undefined' && scrollableElement) {
        try {
          bodyScrollLock.disableBodyScroll(scrollableElement, bodyScrollLockOptions);
        } catch (error) { }
      }
    }
  }


  submitNotifyMe(e) {
    e.preventDefault();
    const emailInput = this.element.querySelector('.notify-me__input');
    const emailTxt = emailInput.value.trim();
    const alertErr = this.element.querySelector('.notify-me__popup-content .AlertError');

    //validation for email
    if (emailTxt === "" || !emailTxt.includes("@")) {
      // Invalid email format
      alertErr.style.display = "block";
      setTimeout(() => {
        alertErr.style.display = "none";
      }, 3000);

      return;
    } else {
      alertErr.style.display = "none";
    }

    //Send request to API
    this.handleKlaviyoAPI(emailTxt);
  }

  async handleKlaviyoAPI(myEmail) {
    let elementWithId = this.element.querySelector('.notify-me__popup-wrapper');

    if (elementWithId) {
      let variantID = elementWithId.getAttribute('variant-value');

      //Klaviyo API data
      const data = {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: myEmail
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantID}`
            }
          }
        }
      };


      const endpoint = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.element.dataset.key}`;

      const shopifyResponse = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json',
          "revision": "2024-06-15"
        },
        body: JSON.stringify({ data }),
      });

      if (!shopifyResponse.ok) {
        throw new Error(`Failed to capture email on Shopify: ${shopifyResponse.statusText}`);
      }
      // Handle success on Shopify (e.g., show a success message to the user)

      elementWithId.setAttribute('notify-me-success', 'true');
      elementWithId.style.opacity = 0;
      elementWithId.querySelector('.notify-me__popup-content').style.display = "none";
      elementWithId.querySelector('.notify-me__heading').style.display = "none";

      setTimeout(() => {
        elementWithId.style.opacity = 1;
        elementWithId.querySelector('.notify-me__success-msg').style.display = "flex";
        elementWithId.querySelector('.notify-me__heading--success').style.display = "flex";
      }, 500);


    } else {
      return;
    }

  }

}
customElements.define("notify-me-popup", NotifyMePopup);


class SearchBar extends HTMLElement {
  constructor() {
    super();

    // base refs
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    // key elements (guard every lookup)
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.searchResultsElement = this.element.querySelector('.searchWrapper');
    this.pageOverlayElement = document.querySelector('.pageOverlay');
    this.clearSearchButton = this.element.querySelector('.search-input__clear');
    this.closeBtnMobile = this.element.querySelector(
      '.search__close-btn-wrapper'
    );
    this.searchInputContainer = this.element.querySelector(
      '.search-header__input-container'
    );
    this.formElement = this.element.querySelector('form.searchForm');

    // options
    const settingsAttr = this.element.getAttribute('data-settings');
    try {
      this.options = settingsAttr ? JSON.parse(settingsAttr) : {};
    } catch {
      this.options = {};
    }
    this.showRecentSearches = !!this.options.recentSearchesEnabled;

    // initial layout snapshot (guard)
    this.initialSearchLayout = this.searchResultsElement
      ? this.searchResultsElement.cloneNode(true)
      : null;

    // header sizing (guard)
    const headerEl = this.element.querySelector('.search-header');
    if (headerEl) {
      document.documentElement.style.setProperty(
        '--search-header-height',
        `${headerEl.offsetHeight + 48}px`
      );
    }

    // feature flags
    this.headerTransparent = false;
    this.isOpen = false;

    // recent searches on boot if enabled
    if (this.showRecentSearches) {
      this.getRecentSearches();
    }

    this.bindEvents();
    this.updateSearchToggleButtons(false);
  }

  bindEvents() {
    this._onInputListener = debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      'click',
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateBody.on(
      'click',
      '.search[aria-expanded=false] .searchInput--Wrapper',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      'click',
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      'click',
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    if (this.searchInputElement) {
      this.searchInputElement.addEventListener('input', this._onInputListener);
    }

    this.delegateElement.on(
      'click',
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateElement.on(
      'keypress',
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateBody.on('menu:open', this.closeSearch.bind(this));
    this.delegateBody.on('close:search', this.closeSearch.bind(this));
    this.delegateBody.on('drawer:opened', this.closeSearch.bind(this));
    this.delegateBody.on('popup:opened', this.closeSearch.bind(this));

    this.delegateBody.on(
      'mobile-menu:open',
      this.showSearchInputMobile.bind(this)
    );
    this.delegateBody.on(
      'mobile-menu:close',
      this.hideSearchInputMobile.bind(this)
    );

    this.delegateElement.on('submit', 'form.searchForm', this.handleFormSubmit.bind(this));
  }

  updateSearchToggleButtons(isExpanded) {
    const toggles = document.querySelectorAll('[data-action="open-search"]');
    toggles.forEach((toggle) =>
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false')
    );
  }

  handleFormSubmit(event) {
    event.preventDefault();

    let url = new URL(this.formElement.action, window.location.origin);
    url.searchParams.set('q', this.searchInputElement.value);

    if (this.element.querySelector('product-card')) {
      url.searchParams.set('type', 'product');
    } else {
      url.searchParams.set('type', 'article');
    }

    window.location.href = url.toString();
  }

  initCarousel() {
    if (!this.searchResultsElement) return;
    const carousel = this.searchResultsElement.querySelector(
      '[data-swiper-settings]'
    );
    if (!carousel) return;
    const swiperEl = carousel.closest('swiper-init') || carousel;
if (swiperEl && typeof swiperEl.initSwiper === 'function') {
  swiperEl.initSwiper();
  this.newCarousel = swiperEl.getSwiper();
}
  }

  showSearchInputMobile() {
    this.element.style.display = '';
    requestAnimationFrame(() => {
      this.element.setAttribute('aria-hidden', 'false');
      this.searchResultsElement.setAttribute('aria-hidden', true);
      this.searchResultsElement.style.display = 'none';
    });
    document.documentElement.style.setProperty(
      '--search-input-heignt',
      `${this.element.querySelector('.searchInput--Wrapper').offsetHeight}px`
    );
  }

  hideSearchInputMobile() {
    const handleTransitionEnd = () => {
      const mobileMenuDrawer = document.querySelector('main-menu-dropdown .menu__drawer');
      if (mobileMenuDrawer.getAttribute('aria-hidden') == 'false' && responsive.currentBreakpoint != 'desktop') {
        this.element.style.display = 'none';
      }

      this.searchInputContainer.removeEventListener(
        'transitionend',
        handleTransitionEnd
      );
    };
    this.searchInputContainer.addEventListener(
      'transitionend',
      handleTransitionEnd
    );

    this.searchResultsElement.setAttribute('aria-hidden', '');
    this.searchResultsElement.style.display = '';
    this.element.setAttribute('aria-hidden', 'true');
  }

  openSearch(event) {
    if (event?.preventDefault) event.preventDefault();
    if (window.Drawer && Drawer.active) Drawer.active.closeDrawer();
    if (window.globalPopup) window.globalPopup.closeAllPopups?.();

    // Prevent opening if already opening or if currently closing
    if (this.isOpen || this._isOpening || this._isClosing) {
      // If already open (and settled), allow it to toggle closed.
      // While the open animation is still running we ignore the click instead,
      // so rapid clicks can't restart the transition (mirrors Drawer.toggleDrawer).
      if (this.isOpen && !this._isClosing && !this._isOpening) {
        this.closeSearch();
      }
      return;
    }

    this._isOpening = true;

    // Hold the opening guard until the panel finished animating in, otherwise a
    // second click restarts the transition mid-flight. Scheduled up front so the
    // guard is released even if anything below throws.
    if (this._openTimeout) clearTimeout(this._openTimeout);
    // timeout: matches the .searchWrapper transform (0.5s) in component-search.css
    this._openTimeout = setTimeout(() => {
      this._isOpening = false;
      this._openTimeout = null;
    }, 500);

    // broadcast close events for other UI
    this.element.dispatchEvent(
      new CustomEvent('menu:close', { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent('drawer:close-other', { bubbles: true })
    );

    // ensure element exists
    if (!this.element) {
      console.error('Search element not found');
      this._isOpening = false;
      return;
    }

    // show container
    this.element.style.display = 'block';

    // ARIA setup
    requestAnimationFrame(() => {
      const search = document.querySelector('#quickSearch');

      if (search) {
        search.setAttribute('aria-hidden', 'false');
        search.setAttribute('aria-expanded', 'true');
      }
    });

    if (responsive.currentBreakpoint != 'desktop' || this.searchResultsElement.style.display == 'none') {
      this.searchResultsElement.style.display = '';

      requestAnimationFrame(() => {
        this.searchResultsElement.setAttribute('aria-hidden', 'false');
      });

      this.closeBtnMobile.style.display = '';

      setTimeout(() => {
        requestAnimationFrame(() => {
          this.closeBtnMobile.setAttribute('aria-hidden', 'false');
        });
      }, 300);
    }

    const headerSearchBar = document.querySelector('.header-search');
    if (headerSearchBar) headerSearchBar.classList.add('hidden');

    // overlay placement
    if (typeof responsive !== 'undefined' && responsive.currentBreakpoint == 'desktop') {
      this.pageOverlayElement.style.top =
        'calc(var(--header-height-fixed) + var(--announcement-dynamic-height))';
      this.pageOverlayElement.classList.add('is-visible');
    }

    // lock scroll (guard external lib)
    const scrollable = this.element.querySelector('[data-scrollable]');
    if (typeof bodyScrollLock !== 'undefined' && scrollable) {
      try {
        bodyScrollLock.disableBodyScroll(
          scrollable,
          window.bodyScrollLockOptions || undefined
        );
      } catch { }
    }
    document.body.classList.add('scrollLock');

    // focus input
    setTimeout(() => {
      if (this.searchInputElement) this.searchInputElement.focus();
    }, 200);

    // header transparency handling — fixed so transparent headers stay transparent
    const headerElement = document.querySelector('header-component');
    if (headerElement && headerElement.classList.contains("Header--Transparent")) {
      this.element._wasTransparentBeforeOpen = true;
      // Block automatic transparency while popup is open
      if (headerElement.drawerBlocksTransparency !== undefined) {
        headerElement.drawerBlocksTransparency = true;
      }
      headerElement.classList.remove("Header--Transparent");
    } else {
      this.element._wasTransparentBeforeOpen = false;
    }


    // state + overlay click to close
    this.isOpen = true;
    this.updateSearchToggleButtons(true);

    if (this.pageOverlayElement && responsive.currentBreakpoint == 'desktop') {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener('click', this.closeListener);
    }
  }

  closeSearch(event) {
    if (event?.preventDefault) event.preventDefault();
    if (!this.isOpen) return;


    // Prevent multiple close operations
    if (this._isClosing) return;
    this._isClosing = true;

    // A close taking over mid-open owns the state from here on
    if (this._openTimeout) {
      clearTimeout(this._openTimeout);
      this._openTimeout = null;
    }
    this._isOpening = false;


    const onCloseBtnTransitionend = () => {
      this.closeBtnMobile.style.display = 'none';
      this.closeBtnMobile.removeEventListener('transitionend', onCloseBtnTransitionend);
    };

    this.closeBtnMobile.addEventListener('transitionend', onCloseBtnTransitionend);

    this.closeBtnMobile.setAttribute('aria-hidden', 'true');

    setTimeout(onCloseBtnTransitionend, 500);

    if (responsive.currentBreakpoint == 'desktop') this.element.setAttribute('aria-hidden', 'true');
    this.element.setAttribute('aria-expanded', 'false');

    // Clean up any existing listener to prevent stacking
    if (this.handleSearchCloseBinder) {
      this.element.removeEventListener(
        'transitionend',
        this.handleSearchCloseBinder
      );
    }

    this.handleSearchCloseBinder = this.handleSearchClose.bind(this);
    this.element.addEventListener(
      'transitionend',
      this.handleSearchCloseBinder,
      { once: true }
    );

    if (this.pageOverlayElement && responsive.currentBreakpoint == 'desktop') {
      this.pageOverlayElement.classList.remove('is-visible');
      // Remove the click listener immediately
      if (this.closeListener) {
        this.pageOverlayElement.removeEventListener(
          'click',
          this.closeListener
        );
        this.closeListener = null;
      }
    }

    this.isOpen = false;
    this.updateSearchToggleButtons(false);

    const headerSearchBar = document.querySelector('.header-search');
    if (headerSearchBar) headerSearchBar.classList.remove('hidden');

    // Clear any existing fallback timeout
    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
    }

    // Fallback: force cleanup if transition doesn't fire
    this._closeTimeout = setTimeout(() => {
      if (!this.isOpen && this._isClosing) {
        this.handleSearchClose({ propertyName: 'opacity' });
      }
    }, 400); // Increased to 400ms to avoid conflicts
  }

  handleSearchClose(e) {
    // Only run once per close operation
    if (!this._isClosing) return;

    // Only proceed on the opacity transition or forced cleanup
    if (e?.propertyName !== 'opacity') return;

    try {
      // Clear the fallback timeout
      if (this._closeTimeout) {
        clearTimeout(this._closeTimeout);
        this._closeTimeout = null;
      }

      // Restore transparent header if it was previously transparent
      if (this.element._wasTransparentBeforeOpen) {
        const headerElement = document.querySelector('header-component');
        if (headerElement) {
          headerElement.classList.add('Header--Transparent');
          // Restore transparency blocking
          if (headerElement.drawerBlocksTransparency !== undefined) {
            headerElement.drawerBlocksTransparency = false;
          }
        }
        this.element._wasTransparentBeforeOpen = false;
      }

      // Unlock scroll - but check if mobile menu is open first
      const mobileMenu = document.querySelector('main-menu-dropdown .menu__drawer');
      const isMobileMenuOpen = mobileMenu && mobileMenu.getAttribute('aria-expanded') === 'true';
    
      // Only remove scrollLock class if no drawer is open
      if (!isMobileMenuOpen && (!Drawer.active || !Drawer.active.isOpen)) {
        document.body.classList.remove('scrollLock');
      }
    
      const scrollable = this.element.querySelector('[data-scrollable]');
      if (typeof bodyScrollLock !== 'undefined' && scrollable) {
        try {
          // Only enable scroll for this specific element, don't clear all locks
          bodyScrollLock.enableBodyScroll(
            scrollable,
            window.bodyScrollLockOptions || undefined
          );
        } catch { }
      }

      // Hide element appropriately based on context
      // On mobile with menu open, show just the search input (not results)
      // Otherwise, hide the entire search element
      if (responsive.currentBreakpoint != 'desktop' && isMobileMenuOpen) {
        this.showSearchInputMobile();
      } else {
        this.element.style.display = 'none';
      }

      this.resetSearch();

      // Reset overlay
      if (
        typeof responsive !== 'undefined' &&
        responsive.matchesBreakpoint &&
        responsive.matchesBreakpoint('lap_and_up')
      ) {
        if (this.pageOverlayElement)
          this.pageOverlayElement.removeAttribute('style');
      }

      // Clean up listener
      if (this.handleSearchCloseBinder) {
        this.element.removeEventListener(
          'transitionend',
          this.handleSearchCloseBinder
        );
        this.handleSearchCloseBinder = null;
      }

    } catch (error) {
      console.error('[SearchBar] close cleanup failed:', error);
    } finally {
      // Always release the guard. If anything above throws, openSearch would
      // bail out on _isClosing forever and the search could never reopen.
      this._isClosing = false;
    }
  }

  async onInput(event) {
    this.allPredictiveSearchInstances = this.allPredictiveSearchInstances || [];

    // 1) get the value (typing OR clicking a suggestion)
    const source = event?.target;
    let val = source && 'value' in source ? source.value : '';
    if (source?.getAttribute && source.getAttribute('data-value') && !val) {
      val = source.getAttribute('data-value');
      const el = this.element.querySelector('.searchInput');
      if (el) {
        el.value = val;
        el.setAttribute('value', val);
      }
    }
    this.lastInputValue = val;


    // 2) empty input → reset
    if (!val.trim()) {
      if (this.initialSearchLayout && this.searchResultsElement) {
        this.searchResultsElement.innerHTML =
          this.initialSearchLayout.innerHTML;
        this.searchResultsElement.style.opacity = 1;
      }
      const host = this.element.querySelector('.predictiveSearch--queries');
      if (host) host.innerHTML = '';
      if (this.showRecentSearches) this.getRecentSearches();
      if (this.clearSearchButton)
        this.clearSearchButton.setAttribute('aria-hidden', 'true');
      return;
    }

    // 3) ensure wrapper exists
    this.searchResultsElement = this.element.querySelector('.searchWrapper');
    if (!this.searchResultsElement) return;
    this.searchResultsElement.style.opacity = 0;
    if (this.clearSearchButton)
      this.clearSearchButton.setAttribute('aria-hidden', 'false');

    // 4) RACE GUARD: only latest request may update the UI
    const token = (this.currentRequestToken =
      (this.currentRequestToken || 0) + 1);

    try {
      // 5) build a clean URL (no trailing spaces) + ask for query suggestions
      const sectionId = 'search-predictive';
      const params = new URLSearchParams();
      params.set('q', val);
      params.set('resources[type]', 'query,product,collection,article,page');
      params.set('resources[limit_scope]', 'each');
      params.set(
        'resources[options][fields]',
        'title,product_type,variants.title,tag,body,author,vendor,variants.sku'
      );
      params.set('section_id', sectionId);
      params.set('_', String(Date.now())); // cache-buster
      const url = `${routes.predictive_search_url}?${params.toString()}`;

      const response = await fetch(url, { cache: 'no-store' });
      if (!response.ok) throw new Error(response.status);

      // If a newer request started, drop this one
      if (token !== this.currentRequestToken) return;

      // 6) parse the HTML and inject results
      const text = await response.text();
      const parsed = new DOMParser().parseFromString(text, 'text/html');
      const hostEl =
        parsed.querySelector(`#shopify-section-${sectionId}`) || parsed.body;
      const resultsMarkup = hostEl ? hostEl.innerHTML : '';

      this.searchResultsElement.innerHTML = resultsMarkup;
      this.initCarousel();

      // 7) UNWRAP <template> with suggestions and mount to a visible host
      // find <template> inside the injected results
      const tpl = this.searchResultsElement.querySelector('template');

      // Remove any stray hosts that live OUTSIDE the predictive section
      this.element
        .querySelectorAll('.predictiveSearch--queries')
        .forEach((n) => {
          if (!this.searchResultsElement.contains(n)) n.remove();
        });

      // Find containers INSIDE the predictive section
      const root =
        this.searchResultsElement.querySelector('.predictive-search') ||
        this.searchResultsElement;
      // Put suggestions in the same column as articles
      const leftCol =
        root.querySelector('.predictive-search__results--left') || root;

      // Create/reuse a host INSIDE the predictive section
      let suggestionsHost = root.querySelector('.predictiveSearch--queries');
      if (!suggestionsHost) {
        suggestionsHost = document.createElement('div');
        suggestionsHost.className = 'predictiveSearch--queries';
        suggestionsHost.setAttribute('aria-live', 'polite');
      }

      // Render (or clear) suggestions from the <template>
      suggestionsHost.innerHTML = '';
      if (tpl && tpl.content && tpl.content.firstElementChild) {
        suggestionsHost.appendChild(tpl.content.cloneNode(true));
        // Insert at top of the left column (above Articles)
        leftCol.insertBefore(suggestionsHost, leftCol.firstChild);
      } else {
        // No suggestions → remove any existing host to avoid empty gaps
        if (suggestionsHost.parentNode) suggestionsHost.remove();
      }

      // 8) finish
      this.searchResultsElement.style.opacity = 1;
      if (this.showRecentSearches) this.recentSearches();
    } catch (error) {
      if (error?.code === 20) return; // aborted
      console.error('[SearchBar] predictive search failed:', error);
      if (this.showRecentSearches) this.getRecentSearches();
      if (this.searchResultsElement)
        this.searchResultsElement.style.opacity = 1;
    }
  }

  resetSearch() {
    if (this.initialSearchLayout && this.searchResultsElement) {
      this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    }

    const suggestionsHost = this.element.querySelector(
      '.predictiveSearch--queries'
    );
    if (suggestionsHost) suggestionsHost.remove();

    if (this.searchInputElement) {
      this.searchInputElement.value = '';
      this.searchInputElement.removeAttribute('value');
    }

    this.initCarousel();

    if (this.searchResultsElement) this.searchResultsElement.style.opacity = '';

    setTimeout(() => {
      if (this.searchInputElement) this.searchInputElement.focus();
    }, 200);

    if (this.showRecentSearches) this.getRecentSearches();

    if (this.clearSearchButton) {
      this.clearSearchButton.setAttribute('aria-hidden', 'true');
    }
  }

  recentSearches() {
    if (!this.showRecentSearches) return;

    if ((this.lastInputValue || '').length > 2) {
      const searchTerm = JSON.parse(
        localStorage.getItem('searchTerms') || '[]'
      );
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }
      try {
        localStorage.setItem(
          'searchTerms',
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch { }
    }
  }

  getRecentSearches() {
    if (!this.showRecentSearches) return;

    let items = [];
    try {
      items = JSON.parse(localStorage.getItem('searchTerms') || '[]');
    } catch {
      items = [];
    }
    if (!Array.isArray(items)) items = [];
    items = items.slice(0, 4); // enforce max 4

    const elementToAdd = this.element.querySelector('.search__recent-searches');
    if (!elementToAdd) return;

    const recentSearchesWrapper = this.element.querySelector(
      '.predictive-search__recent-searches'
    );
    if (!recentSearchesWrapper) return;

    if (items.length > 0) {
      let appendString = '';
      items.forEach((id) => {
        appendString +=
          "<div role='option' tabIndex='0' class='search__recent-searches--item u-s3' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          '</div>';
      });

      elementToAdd.innerHTML = appendString;
      recentSearchesWrapper.style.display = '';
    } else {
      recentSearchesWrapper.style.display = 'none';
    }
  }
}

customElements.define("search-bar", SearchBar);

class TermsAndConditions extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.stickyLinksTopPadding = this.stickyLinksTopPadding.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if (!isMobile) document.addEventListener("scroll", this.stickyLinksTopPadding);
  }

  stickyLinksTopPadding() {
    const linkList = this.element.querySelector(".tc-layout-wrapper__linklist");
    if (linkList) {
      const isSticky = linkList.getBoundingClientRect().top === 0;

      if (isSticky) {
        linkList.style.paddingTop = "1.5rem";
      } else {
        linkList.style.paddingTop = "0rem";
      }
    }
  }
}

customElements.define("terms-and-conditions", TermsAndConditions);


class FormValidator {
  constructor(formElement, options = {}) {
    this.form = formElement;
    this.options = {
      errorClass: 'field--error',
      fieldSelector: '.field',
      buttonSelector: null,
      validateOnBlur: true,
      validateOnInput: false,
      errorOutputSelector: null,
      showErrorsOnSubmitOnly: false,
      ...options
    };

    this.customValidators = new Map();
    this.hasSubmittedOnce = false;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupButtonListener();

    if (this.options.buttonSelector) {
      if (this.options.showErrorsOnSubmitOnly) {
        this.enableButton();
      } else {
        this.updateButtonState();
      }
    }
  }

  enableButton() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.removeAttribute('disabled');
    button.classList.remove('disabled');
    button.setAttribute('aria-disabled', 'false');
  }

  setupButtonListener() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.addEventListener('click', (e) => {
      this.markSubmitted();
      const isValid = this.showAllErrors();

      if (button.type === 'submit' && !isValid) {
        e.preventDefault();
      }
    });
  }

  outputErrors(errors) {
    if (!this.options.errorOutputSelector) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    const container = typeof this.options.errorOutputSelector === 'string'
      ? document.querySelector(this.options.errorOutputSelector)
      : this.options.errorOutputSelector;
    if (!container) return;

    container.innerHTML = '';
    if (errors.length > 0) {
      container.innerHTML = errors.join('<br>');
    }
  }

  setupEventListeners() {
    const inputs = this.form.querySelectorAll('input, textarea, select');

    inputs.forEach(input => {
      input.addEventListener('input', () => this.handleInputForErrorClearing(input));
      if (this.options.validateOnBlur) {
        input.addEventListener('blur', () => this.handleFieldBlur(input));
      }
      input.addEventListener('change', () => this.handleInputChange(input));
    });
  }

  handleInputChange(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    // Always clear errors for empty fields
    if (!input.value.trim()) {
      this.clearFieldError(input);
    } else if (this.options.validateOnInput) {
      this.validateField(input, false);
    } else {
      this.handleInputForErrorClearing(input);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  updateErrorOutput() {
    if (!this.options.errorOutputSelector) return;
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    const errors = this.getAllErrors();
    this.outputErrors(errors);
  }

  // Updated to not include errors for empty fields
  getAllErrors() {
    const errors = [];
    this.form.querySelectorAll('input, textarea, select').forEach(field => {
      // Skip empty fields - don't show errors for them
      if (!field.value.trim()) {
        return;
      }

      if (!this.isFieldValid(field)) {
        if (this.customValidators.has(field.id)) {
          const { validatorFn } = this.customValidators.get(field.id);
          const result = validatorFn(field.value, field);
          if (typeof result === 'string') {
            errors.push(result);
          }
        } else if (field.validationMessage) {
          errors.push(field.validationMessage);
        } else {
          // Only show validation errors for non-empty fields
          if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
            errors.push(`Please enter a valid email address`);
          }
        }
      }
    });
    return errors;
  }

  handleInputForErrorClearing(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    const fieldContainer = input.closest(this.options.fieldSelector);
    if (!fieldContainer) return;

    // Clear error if field is empty or valid
    if (!input.value.trim() || this.isFieldValid(input)) {
      fieldContainer.classList.remove(this.options.errorClass);
      this.updateErrorOutput();
    }

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  handleFieldBlur(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    // Only validate non-empty fields on blur
    if (input.value.trim()) {
      this.validateField(input, false);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  // New helper method to clear field errors
  clearFieldError(field) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (fieldContainer && fieldContainer.classList.contains(this.options.errorClass)) {
      fieldContainer.classList.remove(this.options.errorClass);
    }
  }

  addValidator(fieldId, validatorFn, errorMessage) {
    this.customValidators.set(fieldId, { validatorFn, errorMessage });
  }

  validateField(field, silent = true) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (!fieldContainer) return true;

    // Don't show errors for empty fields (but they may still be invalid for form submission)
    if (!field.value.trim()) {
      fieldContainer.classList.remove(this.options.errorClass);
      return this.isFieldValid(field); // Return actual validity for button state
    }

    const isValid = this.isFieldValid(field);
    const shouldShowErrors = !silent && (!this.options.showErrorsOnSubmitOnly || this.hasSubmittedOnce);

    if (shouldShowErrors) {
      if (isValid) {
        fieldContainer.classList.remove(this.options.errorClass);
      } else {
        fieldContainer.classList.add(this.options.errorClass);
      }
    } else if (isValid) {
      fieldContainer.classList.remove(this.options.errorClass);
    }

    return isValid;
  }

  markSubmitted() {
    this.hasSubmittedOnce = true;
    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  isFieldValid(field) {
    // Check required fields
    // Check required fields
    if (field.hasAttribute('required')) {
      if (field.type === 'checkbox' && !field.checked) {
        return false;
      }
      if (field.type !== 'checkbox' && !field.value.trim()) {
        return false;
      }
    }


    // Check email format (only if field has value)
    if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
      return false;
    }

    // Check custom validators
    if (this.customValidators.has(field.id)) {
      const { validatorFn } = this.customValidators.get(field.id);
      const result = validatorFn(field.value, field);
      if (typeof result === 'string') {
        return false;
      }
      return !!result;
    }

    return true;
  }

  validateForm(silent = true) {
    const allFields = this.form.querySelectorAll('input, textarea, select');
    let isFormValid = true;

    allFields.forEach(field => {
      const isFieldValid = this.validateField(field, silent);
      if (!isFieldValid) {
        isFormValid = false;
      }
    });

    if (!silent) {
      this.updateErrorOutput();
    }

    return isFormValid;
  }

  updateButtonState() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
      return;
    }

    const isValid = this.validateForm(true);

    if (isValid) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
    } else {
      button.setAttribute('disabled', 'true');
      button.classList.add('disabled');
      button.setAttribute('aria-disabled', 'true');
    }
  }

  clearErrors() {
    const errorFields = this.form.querySelectorAll(`.${this.options.errorClass}`);
    errorFields.forEach(field => {
      field.classList.remove(this.options.errorClass);
    });

    if (this.options.errorOutputSelector) {
      this.outputErrors([]);
    }
  }

  showAllErrors() {
    return this.validateForm(false);
  }


  getFormData() {
    const formData = new FormData(this.form);
    return Object.fromEntries(formData.entries());
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  isValidFutureDate(dateString) {
    if (!dateString) return false;
    const selectedDate = new Date(dateString);
    const now = new Date();
    return selectedDate > now;
  }


  showInlineError(field, message) {
    const fieldContainer = field.closest(".field-container");
    if (!fieldContainer) return;

    // Remove any existing error
    const existing = fieldContainer.querySelector(".field__error");
    if (existing) existing.remove();

    // 🔧 Get translations
    const t = window?.theme?.translations || {};

    // Determine localized error message
    const fieldName = (field.name || "").toLowerCase();
    let errorText = message;

    if (!errorText) {
      if (fieldName.includes("first")) errorText = t.contact_form_error_first_name;
      else if (fieldName.includes("last")) errorText = t.contact_form_error_last_name;
      else if (field.type === "email") errorText = t.contact_form_error_email;
      else if (fieldName.includes("phone")) errorText = t.contact_form_error_phone;
      else if (fieldName.includes("subject")) errorText = t.contact_form_error_subject;
      else if (fieldName.includes("message") || field.tagName === "TEXTAREA")
        errorText = t.contact_form_error_message;
      else errorText = t.contact_form_error_default;
    }

    // Create error message element
    const errorEl = document.createElement("div");
    errorEl.className = "field__error u-p3";
    errorEl.textContent = errorText;

    // Insert after .field wrapper
    const fieldWrapper = fieldContainer.querySelector(".field");
    fieldWrapper.insertAdjacentElement("afterend", errorEl);

    // Add error class to the field wrapper
    fieldWrapper.classList.add(this.options.errorClass);
  }



}

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  connectedCallback() {
    this.initFormValidation();
  }

  initFormValidation() {
    const form = this.element.querySelector("form");
    if (!form) return;

    // Initialize the base validator
    this.validator = new FormValidator(form, {
      errorClass: "field--error",
      fieldSelector: ".field, .form-checkbox",
      buttonSelector: ".validate-button",
      validateOnBlur: true,
      validateOnInput: false,
      showErrorsOnSubmitOnly: false,
    });

    // 🔧 Attach inline-error behavior for blur events
    const inputs = form.querySelectorAll("input, textarea, select");
    inputs.forEach((input) => {
      input.addEventListener("blur", () => {
        const isValid = this.validator.validateField(input, false);
        if (!isValid) {
          this.validator.showInlineError(input);
        } else {
          const existing = input
            .closest(this.validator.options.fieldSelector)
            ?.querySelector(".field__error");
          if (existing) existing.remove();
        }
      });
    });

    // 🔧 Hook into submit to show inline errors across the form
    const button = form.querySelector(".validate-button");
    if (button) {
      button.addEventListener("click", async (e) => {
        console.log('🔴 BUTTON CLICKED - Starting validation...');
        
        this.validator.markSubmitted();
        const isValid = this.validator.validateForm(false);

        form.querySelectorAll("input, textarea, select").forEach((field) => {
          if (!this.validator.isFieldValid(field)) {
            this.validator.showInlineError(field);
          } else {
            const existing = field
              .closest(this.validator.options.fieldSelector)
              ?.querySelector(".field__error");
            if (existing) existing.remove();
          }
        });

        if (button.type === "submit" && !isValid) {
          console.log('❌ Validation failed - preventing submit');
          e.preventDefault();
          return;
        }
        
        // ✅ Validation passed - check for Klaviyo subscription
        console.log('✅ Validation passed - checking Klaviyo...');
        
        const marketingCheckbox = form.querySelector('input[name="contact[accepts_marketing]"]');
        const emailField = form.querySelector('input[type="email"]');
        const firstNameField = form.querySelector('input[name*="first"]');
        const lastNameField = form.querySelector('input[name*="last"]');
        const phoneField = form.querySelector('input[type="tel"], input[name*="phone"]');
        
        console.log('Marketing checkbox element:', marketingCheckbox);
        console.log('Marketing checkbox checked:', marketingCheckbox?.checked);
        console.log('Email value:', emailField?.value);
        
        // Get Klaviyo settings from contact-section element
        const contactSection = this.element;
        const klaviyoApiKey = contactSection?.getAttribute('data-klaviyo-api-key');
        const klaviyoListId = contactSection?.getAttribute('data-klaviyo-list-id');
        
        console.log('Klaviyo API Key:', klaviyoApiKey);
        console.log('Klaviyo List ID:', klaviyoListId);
        
        if (marketingCheckbox && marketingCheckbox.checked && emailField && emailField.value && klaviyoApiKey && klaviyoListId) {
          console.log('✅ All Klaviyo conditions met - subscribing...');
          
          // Prevent form submission until Klaviyo finishes
          e.preventDefault();
          e.stopPropagation();
          
          const email = emailField.value;
          const listId = klaviyoListId.trim();
          const apiKey = klaviyoApiKey.trim();
          
          // Prepare profile properties
          const profileAttributes = {
            email: email
          };
          
          if (firstNameField && firstNameField.value) {
            profileAttributes.first_name = firstNameField.value;
          }
          if (lastNameField && lastNameField.value) {
            profileAttributes.last_name = lastNameField.value;
          }
          if (phoneField && phoneField.value) {
            profileAttributes.phone_number = phoneField.value;
          }

          // Klaviyo client API endpoint
          const klaviyoUrl = `https://a.klaviyo.com/client/subscriptions/?company_id=${apiKey}`;
          
          const data = {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileAttributes
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          };

          try {
            console.log('📤 Sending to Klaviyo...', data);
            const response = await fetch(klaviyoUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json',
                'revision': '2024-06-15'
              },
              body: JSON.stringify({ data })
            });

            const responseText = await response.text();
            console.log('📥 Klaviyo response status:', response.status);
            
            if (response.ok) {
              console.log('✅ Successfully subscribed to Klaviyo - submitting form...');
              // Klaviyo subscription successful, now submit the contact form
              form.submit();
            } else {
              console.error('❌ Klaviyo subscription failed:', responseText);
              // Still submit the form even if Klaviyo fails (contact message is still important)
              form.submit();
            }
          } catch (error) {
            console.error('❌ Klaviyo subscription error:', error);
            // Still submit the form even if Klaviyo has an error
            form.submit();
          }
        } else {
          console.log('⚠️ Klaviyo conditions not met - skipping subscription');
        }
      });
    }
  }

  toggleButton() {
    if (this.validator) {
      this.validator.updateButtonState();
    }
  }
}

customElements.define("contact-section", ContactSection);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class FormValidator2 {
  constructor(formElement, options = {}) {
    this.form = formElement;
    this.options = {
      errorClass: 'field--error',
      fieldSelector: '.field',
      buttonSelector: null,
      validateOnBlur: true,
      validateOnInput: false,
      errorOutputSelector: null,
      showErrorsOnSubmitOnly: false,
      ...options
    };

    this.customValidators = new Map();
    this.hasSubmittedOnce = false;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupButtonListener();

    if (this.options.buttonSelector) {
      if (this.options.showErrorsOnSubmitOnly) {
        this.enableButton();
      } else {
        this.updateButtonState();
      }
    }
  }

  enableButton() {
    if (!this.options.buttonSelector) return;

    const button = this.form.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.removeAttribute('disabled');
    button.classList.remove('disabled');
    button.setAttribute('aria-disabled', 'false');
  }

  setupButtonListener() {
    if (!this.options.buttonSelector) return;

    const button = this.form.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.addEventListener('click', (e) => {
      this.markSubmitted();
      const isValid = this.showAllErrors();

      if (button.type === 'submit' && !isValid) {
        e.preventDefault();
      }
    });
  }

  outputErrors(errors) {
    if (!this.options.errorOutputSelector) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    const container = typeof this.options.errorOutputSelector === 'string'
      ? this.form.querySelector(this.options.errorOutputSelector)
      : this.options.errorOutputSelector;
    if (!container) return;

    container.innerHTML = '';
    if (errors.length > 0) {
      container.innerHTML = errors.join('<br>');
    }
  }

  setupEventListeners() {
    const inputs = this.form.querySelectorAll('input, textarea, select');

    inputs.forEach(input => {
      if (this.options.validateOnInput) {
        input.addEventListener('input', () => this.handleInputChange(input));
      } else {
        input.addEventListener('input', () => this.handleInputForErrorClearing(input));
      }

      if (this.options.validateOnBlur) {
        input.addEventListener('blur', () => this.handleFieldBlur(input));
      }

      input.addEventListener('change', () => this.handleInputChange(input));
    });
  }

  handleInputChange(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    // Always clear errors for empty fields
    if (!input.value.trim()) {
      this.clearFieldError(input);
    } else if (this.options.validateOnInput) {
      this.validateField(input, false);
    } else {
      this.handleInputForErrorClearing(input);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  updateErrorOutput() {
    if (!this.options.errorOutputSelector) return;
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    const errors = this.getAllErrors();
    this.outputErrors(errors);
  }

  // Updated to not include errors for empty fields
  getAllErrors() {
    const errors = [];
    this.form.querySelectorAll('input, textarea, select').forEach(field => {
      // Skip empty fields - don't show errors for them
      if (!field.value.trim()) {
        return;
      }

      if (!this.isFieldValid(field)) {
        if (this.customValidators.has(field.id)) {
          const { validatorFn } = this.customValidators.get(field.id);
          const result = validatorFn(field.value, field);
          if (typeof result === 'string') {
            errors.push(result);
          }
        } else if (field.validationMessage) {
          errors.push(field.validationMessage);
        } else {
          // Only show validation errors for non-empty fields
          if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
            errors.push(`Please enter a valid email address`);
          }
        }
      }
    });
    return errors;
  }

  handleInputForErrorClearing(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    // Always clear errors for empty fields
    if (!input.value.trim()) {
      this.clearFieldError(input);
    } else {
      const fieldContainer = input.closest(this.options.fieldSelector);
      if (fieldContainer && fieldContainer.classList.contains(this.options.errorClass)) {
        const isValid = this.isFieldValid(input);
        if (isValid) {
          fieldContainer.classList.remove(this.options.errorClass);
        }
      }
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  handleFieldBlur(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    // Always clear errors for empty fields
    if (!input.value.trim()) {
      this.clearFieldError(input);
    } else {
      // Only validate non-empty fields on blur
      this.validateField(input, false);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  // New helper method to clear field errors
  clearFieldError(field) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (fieldContainer && fieldContainer.classList.contains(this.options.errorClass)) {
      fieldContainer.classList.remove(this.options.errorClass);
    }
  }

  addValidator(fieldId, validatorFn, errorMessage) {
    this.customValidators.set(fieldId, { validatorFn, errorMessage });
  }

  validateField(field, silent = true) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (!fieldContainer) return true;

    // Don't show errors for empty fields (but they may still be invalid for form submission)
    if (!field.value.trim()) {
      fieldContainer.classList.remove(this.options.errorClass);
      return this.isFieldValid(field); // Return actual validity for button state
    }

    const isValid = this.isFieldValid(field);
    const shouldShowErrors = !silent && (!this.options.showErrorsOnSubmitOnly || this.hasSubmittedOnce);

    if (shouldShowErrors) {
      if (isValid) {
        fieldContainer.classList.remove(this.options.errorClass);
      } else {
        fieldContainer.classList.add(this.options.errorClass);
      }
    } else if (isValid) {
      fieldContainer.classList.remove(this.options.errorClass);
    }

    return isValid;
  }

  markSubmitted() {
    this.hasSubmittedOnce = true;
    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  isFieldValid(field) {
    // Check required fields
    if (field.hasAttribute('required') && !field.value.trim()) {
      return false;
    }

    // Check email format (only if field has value)
    if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
      return false;
    }

    // Check custom validators
    if (this.customValidators.has(field.id)) {
      const { validatorFn } = this.customValidators.get(field.id);
      const result = validatorFn(field.value, field);
      if (typeof result === 'string') {
        return false;
      }
      return !!result;
    }

    return true;
  }

  validateForm(silent = true) {
    const allFields = this.form.querySelectorAll('input, textarea, select');
    let isFormValid = true;

    allFields.forEach(field => {
      const isFieldValid = this.validateField(field, silent);
      if (!isFieldValid) {
        isFormValid = false;
      }
    });

    if (!silent) {
      this.updateErrorOutput();
    }

    return isFormValid;
  }

  updateButtonState() {
    if (!this.options.buttonSelector) return;

    const button = this.form.querySelector(this.options.buttonSelector);
    if (!button) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
      return;
    }

    const isValid = this.validateForm(true);

    if (isValid) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
    } else {
      button.setAttribute('disabled', 'true');
      button.classList.add('disabled');
      button.setAttribute('aria-disabled', 'true');
    }
  }

  clearErrors() {
    const errorFields = this.form.querySelectorAll(`.${this.options.errorClass}`);
    errorFields.forEach(field => {
      field.classList.remove(this.options.errorClass);
    });

    if (this.options.errorOutputSelector) {
      this.outputErrors([]);
    }
  }

  showAllErrors() {
    return this.validateForm(false);
  }

  getFormData() {
    const formData = new FormData(this.form);
    return Object.fromEntries(formData.entries());
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  isValidFutureDate(dateString) {
    if (!dateString) return false;
    const selectedDate = new Date(dateString);
    const now = new Date();
    return selectedDate > now;
  }
}

class NewsletterForm extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.listId = this.element.getAttribute('data-list-id');
    this.inputWrapper = this.element.querySelector(
      '.newsletter__email-input-wrapper--fill'
    );
    this.successWrapper = this.element.querySelector(
      '.newsletter__email-input-wrapper--success'
    );
    this.emailForm = this.element.querySelector('.newsletter__form');
  }

  connectedCallback() {
    this.initFormValidation();
    this.bindEvents();
  }

  initFormValidation() {
    if (!this.emailForm) return;

    this.validator = new FormValidator2(this.emailForm, {
      errorClass: 'field--error',
      fieldSelector: '.newsletter__email-input-wrapper',
      buttonSelector: '.newsletter__subscribe-button',
      validateOnBlur: true,
      validateOnInput: false,
      showErrorsOnSubmitOnly: false,
    });
  }

  bindEvents() {
    if (this.emailForm) {
      this.emailForm.addEventListener('submit', this.onSubmit.bind(this));
    }

    this.delegateElement.on(
      'click',
      "[data-action='clear-email']",
      this.onClear.bind(this)
    );
  }

  onClear() {
    this.emailForm.reset();
    this.emailForm.dispatchEvent(new Event('input'));

    if (this.validator) {
      this.validator.clearErrors();
    }
  }

  onSubmit(e) {
    e.preventDefault();

    const emailEl = this.element.querySelector('.newsletter__email-input');
    const email = emailEl.value.trim();

    if (!email || !this.listId) return;

    const body = new URLSearchParams({
      g: this.listId,
      email: email,
      $fields: '$source',
      $source: 'Inline_Subscribe',
    }).toString();

    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Cache-Control': 'no-cache',
      },
      body: body,
    })
      .then((r) => r.json())
      .then((json) => {
        if (json.success) {
          localStorage.setItem('popup-subscribed', 'true');
          this.showSuccessState();
          this.element.dispatchEvent(
            new CustomEvent('newsletter:success', { bubbles: true })
          );
        } else {
          console.error('Subscription failed:', json);
        }
      })
      .catch((err) => {
        console.error('Klaviyo subscription error:', err);
      });
  }

  showSuccessState() {
    this.inputWrapper.style.display = 'none';
    this.successWrapper.style.display = 'flex';
  }
}

customElements.define('newsletter-form', NewsletterForm);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (localKey !== "true") {
      if (this.options.scroll_amount > 0) {
        this.myScrollListener = scrollListener.addScrollListener(this, this.scrollListener);
      } else {
        this.openNewsletter();
      }
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
    setTimeout(() => {
      this.element.style.display = "block";
      this.element.offsetHeight;

      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", false);
      });

      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }

    this.element.addEventListener('transitionend', () => {
      this.element.style.display = "none";
    }, { once: true });

    setTimeout(() => { this.element.style.display = 'none'; }, 500);
  };
}

customElements.define("newsletter-popup", NewsletterPopup);

class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector('#accountDrawer'));
    this.bindEvents();

  }
  bindEvents() {

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));

    // Login, register and recover submit natively. Shopify's spam protection hooks the form's own
    // submit event to attach the CAPTCHA token, so posting these with fetch instead made every
    // request come back "Missing CAPTCHA token": no recovery email, and a failed login read as a
    // success. The buttons already carry type="submit", so the browser does the rest.
  }

  toggleRecovery(event) {
    event.preventDefault();

    const id = event.target.dataset.id;

    const titleParent = event.target.closest('[data-title]');
    const newTitle = titleParent ? titleParent.dataset.title : '';
    this.setDrawerTitle(newTitle);

    // Toggle visibility between login and recovery forms
    if (id === 'recover') {
      this.element.querySelector('#recover').setAttribute('aria-visible', 'true');
      this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'false');
    } else {
      this.element.querySelector('#recover').setAttribute('aria-visible', 'false');
      this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'true');
    }
  }

  // 🆕 Reusable drawer title setter
  setDrawerTitle(title) {
    const titleElement = this.element.querySelector('.acc-drawer__title');
    if (titleElement && title) {
      titleElement.textContent = title;
    }
  }

  toggleTab(event) {
    event.preventDefault();
    const id = event.target.dataset.id; // "login" or "register"

    // 1. Update active classes on tabs
    const allTabs = this.element.querySelectorAll('.accountDrawer--Tab');
    allTabs.forEach(tab => tab.setAttribute('aria-expanded', 'false'));
    event.target.setAttribute('aria-expanded', 'true');

    // 2. Toggle which form is visible
    const allContents = this.element.querySelectorAll('.accountContent');
    allContents.forEach(c => c.setAttribute('aria-visible', 'false'));
    const target = this.element.querySelector(`#${id}`);
    if (target) target.setAttribute('aria-visible', 'true');

    // 3. Update titles/subtitles visibility
    const titles = this.element.querySelectorAll('[data-auth]');
    titles.forEach(el => {
      el.style.display = el.dataset.auth === id ? 'flex' : 'none';
    });

    // 4. Show recovery link only on login tab
    const recoveryWrapper = this.element.querySelector('.recoveryWrapper');
    if (recoveryWrapper)
      recoveryWrapper.style.display = id === 'login' ? 'flex' : 'none';
  }

  toggleRecovery(event) {
    event.preventDefault();
    const id = event.target.dataset.id; // recoverFlex or recoverLogin
    const recover = this.element.querySelector('#recoverFlex');
    const loginFlex = this.element.querySelector('#loginFlex');

    if (id === 'recoverFlex') {
      recover.setAttribute('aria-visible', 'true');
      loginFlex.setAttribute('aria-visible', 'false');
    } else {
      recover.setAttribute('aria-visible', 'false');
      loginFlex.setAttribute('aria-visible', 'true');
    }
  }

}

customElements.define("account-handler", AccountHandler);



let alreadyExits = false;

class LocalizationSelectors extends HTMLElement {
  connectedCallback() {
    // Don't re-init Popup; just ensure it's available.
    if (!window.globalPopup) {
      window.globalPopup = new Popup();
    }
  }
}
customElements.define('localization-selectors', LocalizationSelectors);


class SwiperInit extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiper = null;
    this.initializationMode = this.getInitializationMode();
    this.intersectionObserver = null;
    this.isDynamic = this.element.hasAttribute('data-swiper-dynamic');
    this.isDynamicOnce = this.element.hasAttribute('data-swiper-dynamic-once');
    this.isHorizontalFadeDesktop = this.element.hasAttribute("data-swiper-fade-horizontal-desktop");
    this.isHorizontalFadeMobile = this.element.hasAttribute("data-swiper-fade-horizontal-mobile");
    this.isHorizontalFade = this.element.hasAttribute("data-swiper-fade-horizontal");
    this.hasBeenInitialized = false; // Track if dynamic-once has been initialized

    // Bind methods
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  getInitializationMode() {
    // Check data attributes to determine mode
    if (this.element.hasAttribute('data-swiper-mobile')) {
      return 'mobile';
    } else if (this.element.hasAttribute('data-swiper-desktop')) {
      return 'desktop';
    } else if (this.element.hasAttribute('data-swiper-tablet')) {
      return 'tablet';
    } else {
      return 'universal';
    }
  }

  connectedCallback() {
    // Listen to responsive system breakpoint changes
    document.addEventListener('breakpoint:changed', this.handleBreakpointChange);

    // Set up intersection observer for dynamic swipers
    if (this.isDynamic || this.isDynamicOnce) {
      this.setupIntersectionObserver();
    } else {
      // Auto-initialize if not dynamic and not disabled
      if (!this.element.hasAttribute('data-swiper-manual')) {
        this.initSwiper();
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('breakpoint:changed', this.handleBreakpointChange);
    this.cleanupIntersectionObserver();
    this.destroy();
  }

  setupIntersectionObserver() {
    // Get threshold from attribute or use default
    const threshold = parseFloat(this.element.getAttribute('data-swiper-dynamic-threshold')) || 0.1;

    // Get root margin from attribute or use default
    const rootMargin = this.element.getAttribute('data-swiper-dynamic-margin') || '50px';

    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
      threshold: threshold,
      rootMargin: rootMargin
    });

    this.intersectionObserver.observe(this.element);

    
  }

  cleanupIntersectionObserver() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.target === this.element) {
        if (entry.isIntersecting) {
          // Element is in view - initialize if should be active
          if (this.shouldInitialize() && !this.swiper) {
           
            this.initSwiper();
          }
        } else {
          // Element is out of view
          if (this.isDynamic && this.swiper) {
            // Dynamic mode: destroy when out of view
            this.destroy();
          }
          // Dynamic-once mode: keep swiper active once initialized
        }
      }
    });
  }

  handleBreakpointChange(event) {
    const { currentBreakpoint } = event.detail;

    // Check if we should be active on this breakpoint
    const shouldBeActive = this.shouldInitialize(currentBreakpoint);
    const currentlyActive = !!this.swiper;

    // For dynamic swipers, only initialize if also in view
    if (this.isDynamic || this.isDynamicOnce) {
      // Let the intersection observer handle initialization
      // Just destroy if shouldn't be active
      if (!shouldBeActive && currentlyActive) {
        this.destroy();
      }
    } else {
      // Normal behavior for non-dynamic swipers
      if (shouldBeActive && !currentlyActive) {
        this.initSwiper();
      } else if (!shouldBeActive && currentlyActive) {
        this.destroy();
      } else if (shouldBeActive && currentlyActive) {
        this.initSwiper();
      }
    }
  }

  initHorizontalFadeOnSwiper() {
    const swiper = this.element.getSwiper();
    const swiperInstance = swiper.swiperElement;
    if (!swiper) return;

    // Add "content-fade" class here
    this.element.classList.add('content-fade');
    const fadeContainer = this.element;

    const update = () => this.updateHorizontalFadeClasses(swiperInstance, fadeContainer);

    // Initial update
    update();

    // Listen to swiper events
    swiperInstance.on('slideChange', update);
    swiperInstance.on('resize', update);
    swiperInstance.on('progress', update);
    swiperInstance.on('touchMove', update);

    window.addEventListener('resize', update);
  }

  updateHorizontalFadeClasses(swiperInstance, fadeContainer) {
    const c = fadeContainer.classList;
    c.remove('fade-left', 'fade-right', 'fade-both-horizontal');

    const atStart = swiperInstance.isBeginning;
    const atEnd = swiperInstance.isEnd;

    if (!atStart && !atEnd) {
      c.add('fade-both-horizontal');
    } else if (!atStart) {
      c.add('fade-left');
    } else if (!atEnd) {
      c.add('fade-right');
    }
  }

  shouldInitialize(breakpoint = null) {
    const currentBreakpoint = breakpoint || responsive.getCurrentBreakpoint();

    switch (this.initializationMode) {
      case 'mobile':
        return ['phone', 'pocket'].includes(currentBreakpoint);
      case 'desktop':
        return ['desktop', 'lap_and_up', 'desktop_wide'].includes(currentBreakpoint);
      case 'tablet':
        return ['tablet', 'tablet_and_up'].includes(currentBreakpoint);
      case 'universal':
        return true;
      default:
        return true;
    }
  }

  initSwiper() {
    // Don't initialize if we shouldn't be active
    if (!this.shouldInitialize()) {
      return;
    }

    // Destroy existing swiper
    this.destroy();

    try {
      // Get thumb element if specified
      const thumbSelector = this.element.getAttribute('data-swiper-thumb');
      const thumbElement = thumbSelector ? document.querySelector(thumbSelector) : null;

      // Use existing RevolutionSwiper class as-is
      this.swiper = new RevolutionSwiper(this.element, thumbElement);

      // Mark as initialized for dynamic-once mode
      if (this.isDynamicOnce) {
        this.hasBeenInitialized = true;
      }

      if (this.isHorizontalFadeDesktop && responsive.matchesBreakpoint('lap_and_up')) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      const currentBreakpoint = responsive.getCurrentBreakpoint();
      if (this.isHorizontalFadeMobile && (currentBreakpoint === 'phone' || currentBreakpoint === 'pocket')) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      if (this.isHorizontalFade) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      // Dispatch initialization event
      this.element.dispatchEvent(new CustomEvent('swiper:initialized', {
        bubbles: true,
        detail: {
          breakpoint: responsive.getCurrentBreakpoint(),
          mode: this.initializationMode,
          isDynamic: this.isDynamic,
          isDynamicOnce: this.isDynamicOnce,
          swiper: this.swiper
        }
      }));

  
    } catch (error) {
      console.error('SwiperInit: Failed to initialize swiper', error);
    }
  }

  destroy() {
    if (this.swiper && this.swiper.swiperElement) {
      this.swiper.swiperElement.destroy(true, true);
      this.swiper = null;

      this.element.dispatchEvent(new CustomEvent('swiper:destroyed', {
        bubbles: true,
        detail: {
          breakpoint: responsive.getCurrentBreakpoint(),
          mode: this.initializationMode,
          isDynamic: this.isDynamic,
          isDynamicOnce: this.isDynamicOnce
        }
      }));
    }
  }

  // Public API methods
  selectSlide(index) {
    if (this.swiper && this.swiper.selectCell) {
      this.swiper.selectCell(index);
    } else {
      // Wait for swiper to initialize, then select
      this.element.addEventListener('swiper:initialized', () => {
        if (this.swiper && this.swiper.selectCell) {
          this.swiper.selectCell(index);
        }
      }, { once: true });
    }
  }

  resize() {
    if (this.swiper) {
      this.swiper.resize();
    }
  }

  getSwiper() {
    return this.swiper;
  }

  getCurrentBreakpoint() {
    return responsive.getCurrentBreakpoint();
  }

  reinitialize() {
    this.initSwiper();
  }

  isDynamicSwiper() {
    return this.isDynamic || this.isDynamicOnce;
  }

  getDynamicMode() {
    if (this.isDynamic) return 'dynamic';
    if (this.isDynamicOnce) return 'dynamic-once';
    return 'static';
  }

  // Static method to initialize all swipers
  static initializeAll() {
    document.querySelectorAll('swiper-init').forEach(element => {
      element.initSwiper();
    });
  }
}
customElements.define("swiper-init", SwiperInit);


class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.animationType = this.element.getAttribute("data-animation-type") || "fade";
    this.blocks = Array.from(
      this.element.querySelectorAll(".announcement-bar__block")
    );
    this.currentBlockIndex = 0;
    this.transitionSpeed =
      parseInt(this.element.getAttribute("data-settings")) * 1000;
    this.announcementBar = document.querySelector(".announcement-bar");

    document.documentElement.style.setProperty(
      "--announcement-fixed-height",
      this.element.clientHeight + "px"
    );

    if (this.animationType === "fade") {
      this.initBlocks();

      if (
        typeof this.transitionSpeed === "number" &&
        !isNaN(this.transitionSpeed)
      ) {
        if (this.blocks.length > 1) {
          this.startAnimating();
        }
      }
    } else if (this.animationType === "marquee") {
      this.initMarquee();
    }

    this.updateVisibleHeight();
    this.updateVisibleHeightListener = this.updateVisibleHeight.bind(this);
    scrollListener.addScrollListener(this, this.updateVisibleHeightListener);
  }

  initBlocks() {
    this.blocks.forEach((block, index) => {
      if (index == 0) {
        block.style.opacity = 1;
        block.style.display = "flex";
      } else {
        block.style.opacity = 0;
        block.style.display = "none";
      }
    });
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcement-bar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }

  startAnimating() {
    setInterval(() => {
      this.showNextBlock();
    }, this.transitionSpeed);
  }

  showNextBlock() {
    const currentBlock = this.blocks[this.currentBlockIndex];
    const nextBlockIndex = (this.currentBlockIndex + 1) % this.blocks.length;
    const nextBlock = this.blocks[nextBlockIndex];

    currentBlock.style.position = 'absolute';

    currentBlock.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 500,
      fill: "forwards",
      easing: "ease-out",
    }).onfinish = () => {
      currentBlock.style.display = "none";
      currentBlock.style.position = 'relative';

      nextBlock.style.display = "flex";
      nextBlock.animate(
        [
          { opacity: 0, transform: "translateY(10px)" },
          { opacity: 0.2, transform: "translateY(5px)" },
          { opacity: 1, transform: "translateY(0)" },
        ],
        {
          duration: 500,
          fill: "forwards",
          easing: "ease-in-out",
        }
      );
    };
    this.currentBlockIndex = nextBlockIndex;
  }

  initMarquee() {
    this.marquee = this.element.querySelector(".announcement-bar__marquee");
    this.marqueeTrack = this.element.querySelector(
      ".announcement-bar__marquee-track"
    );

    if (!this.marquee || !this.marqueeTrack) return;

    if (!this.marqueeTrack.querySelector(".announcement-bar__marquee-group")) {
      return;
    }

    const speedSetting = parseFloat(
      this.marqueeTrack.getAttribute("data-marquee-speed")
    );
    // Pixels per second. Keeps the visual speed constant regardless of how
    // many items the merchant adds to the bar.
    this.marqueePxPerSecond =
      !isNaN(speedSetting) && speedSetting > 0 ? speedSetting : 80;

    this.buildMarquee();

    // Re-measure when anything that affects width settles or changes.
    this.buildMarqueeBound = this.buildMarquee.bind(this);
    this.marqueeResizeHandler = this.debounce(this.buildMarqueeBound, 200);

    window.addEventListener("resize", this.marqueeResizeHandler);
    window.addEventListener("load", this.buildMarqueeBound);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.buildMarqueeBound);
    }
  }

  buildMarquee() {
    const track = this.marqueeTrack;
    if (!track) return;

    // Reset to the single original group before measuring/cloning so repeated
    // calls (resize, fonts, load) never accumulate stale copies.
    const groups = track.querySelectorAll(".announcement-bar__marquee-group");
    for (let i = groups.length - 1; i >= 1; i--) {
      groups[i].remove();
    }

    track.classList.remove("is-animating");
    track.style.removeProperty("--marquee-distance");

    const original = track.querySelector(".announcement-bar__marquee-group");
    if (!original) return;

    const groupWidth = original.getBoundingClientRect().width;
    const containerWidth = this.marquee.getBoundingClientRect().width;

    if (!groupWidth || !containerWidth) return;

    // Enough copies that the strip always covers the bar while it shifts by
    // exactly one group width, so the loop is seamless and never leaves a gap,
    // even with a single short item.
    const copies = Math.max(2, Math.ceil(containerWidth / groupWidth) + 1);
    for (let i = 1; i < copies; i++) {
      const clone = original.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
    }

    // Distance travelled per loop equals one group width, and the duration
    // scales with it, so the speed in pixels/second stays constant.
    const duration = groupWidth / this.marqueePxPerSecond;
    track.style.setProperty("--marquee-distance", groupWidth + "px");
    track.style.setProperty("--marquee-speed", duration + "s");

    // Force a reflow so the animation restarts cleanly with the new values.
    void track.offsetWidth;
    track.classList.add("is-animating");
  }

  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("announcement-bar", AnimatedAnnouncementBar);




class CollectionItem extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.handleCollectionItemLink();
    this.loadRecommendations();
  }

  handleCollectionItemLink() {
    const collectionItemDiv = this.element.querySelector('.pc-collection-item');
    if (!collectionItemDiv) return;

    const hasButton = collectionItemDiv.querySelector('.Button, button');
    if (hasButton) return;

    const dataUrl = collectionItemDiv.getAttribute('data-url');
    if (!dataUrl) return;

    const anchorElement = document.createElement('a');
    anchorElement.href = dataUrl;
    Array.from(collectionItemDiv.attributes).forEach(attr => {
      if (attr.name !== 'data-url' && attr.name !== 'data-recommendations-url') {
        anchorElement.setAttribute(attr.name, attr.value);
      }
    });
    anchorElement.innerHTML = collectionItemDiv.innerHTML;

    collectionItemDiv.parentNode.replaceChild(anchorElement, collectionItemDiv);
  }

  loadRecommendations() {
    const collectionItemDiv = this.element.querySelector('.pc-collection-item');
    if (!collectionItemDiv) return;

    const recUrl = collectionItemDiv.getAttribute('data-recommendations-url');
    const recContainer = collectionItemDiv.querySelector('.pc-collection-item__recommendations');
    if (!recUrl || !recContainer) return;

    fetch(recUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // grab only the slides from helper-recommendations
        const slides = doc.querySelectorAll('.swiper-slide');
        if (slides.length) {
          recContainer.innerHTML = '';
          slides.forEach(slide => {
            recContainer.appendChild(slide);
          });
        }
      })
      .catch(err => console.error('Recommendation fetch error:', err));
  }
}

customElements.define('pc-collection-item', CollectionItem);

class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    new AddToCart(this);
  }

  connectedCallback() {
    this.loadRecommendations();

    // Keep same pattern as your existing lazy CSS re-apply
    document.addEventListener('shopify:section:load', () => {
      this.applyGridDisplay();
    });
    document.addEventListener('DOMContentLoaded', () => {
      this.applyGridDisplay();
    });
  }

  getLayout() {
    return this.element.getAttribute('data-layout') || 'swiper';
  }

  applyGridDisplay() {
    if (this.getLayout() !== 'grid') return;

    // We don't touch swiper init. We only neutralize swiper inline styles
    // so your CSS grid overrides can take full control.
    const swiperEl = this.element.querySelector('.swiper');
    const wrapper = this.element.querySelector('.swiper-wrapper');
    const slides = this.element.querySelectorAll('.swiper-slide');

    if (swiperEl) {
      swiperEl.style.overflow = 'visible';
    }

    if (wrapper) {
      // remove Swiper-applied inline layout/transform so grid can work
      wrapper.style.transform = '';
      wrapper.style.transitionDuration = '';
      wrapper.style.height = 'auto';
    }

    if (slides.length) {
      slides.forEach(slide => {
        slide.style.width = '';
        slide.style.marginRight = '';
        slide.style.transform = '';
      });
    }

    // Hide controls in case theme JS/markup left them visible
    const prev = this.element.querySelector('.swiper-button-prev');
    const next = this.element.querySelector('.swiper-button-next');
    const pag = this.element.querySelector('.swiper-pagination');
    if (prev) prev.style.display = 'none';
    if (next) next.style.display = 'none';
    if (pag) pag.style.display = 'none';
  }

  loadRecommendations() {
    const collectionItemDiv = this.element.querySelector('.pc-collection-item');
    if (!collectionItemDiv) return;

    const recUrl = collectionItemDiv.getAttribute('data-recommendations-url');
    if (!recUrl) return;

    fetch(recUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Try to find product cards in the returned HTML
        const productCards = doc.querySelectorAll('.product-card, .ProductCard');

        const recContainer = collectionItemDiv.querySelector('.pc-collection-item__recommendations');
        if (recContainer && productCards.length > 0) {
          recContainer.innerHTML = '';
          productCards.forEach(card => {
            recContainer.appendChild(card.cloneNode(true));
          });

          this.applyGridDisplay();
        } else {
          console.warn('No recommendations found in response:', recUrl);
        }
      })
      .catch(err => console.error('Recommendation fetch error:', err));
  }
}

customElements.define('featured-collection', FeaturedCollection);



class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.handleColorSwatch();

  }


  connectedCallback() {
    // Make sure delegateElement is defined
    if (!this.delegateElement) this.delegateElement = new Delegate(this.element);

    // Handle color swatch clicks
    this.delegateElement.on(
      "click",
      '[data-action="color-swatch-select"]',
      (e) => this.onColorSwatchClick(e)
    );

    // Keep your existing handlers
    this.delegateElement.on(
      "click",
      '[data-action="selectbox-select"]',
      this.onProductCardChange.bind(this)
    );

    this.delegateElement.on(
      "keydown",
      '[data-action="selectbox-select"]',
      this.checkTheBox.bind(this)
    );

    // Preserve your IntersectionObserver setup etc...
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.handleColorSwatch(entry);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: "-100px 0px 200px 0px",
    });

    this.observer.observe(this);
    responsive.addResizeListener(this, this.handleColorSwatch.bind(this));
    this.initMobileGallery();
  }

  initMobileGallery() {
    if (!responsive.matchesBreakpoint('pocket')) return;
    const gallery = this.element.querySelector('[data-gallery]');
    const container = gallery?.querySelector('.pc-gallery');
    if (!gallery || !container || container.swiperInstance) return;

    this.bindGalleryTouchLock(gallery);

    container.swiperInstance = new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 0,
      nested: true,
      watchOverflow: true,
      wrapperClass: 'pc-gallery-wrapper',
      slideClass: 'pc-gallery-slide',
      threshold: 8,
      touchAngle: 25,
      touchMoveStopPropagation: true,
      touchReleaseOnEdges: false,
      resistance: true,
      resistanceRatio: 0.85,
      passiveListeners: false,
      // Let the browser handle vertical scrolling (touch-action: pan-y on the
      // gallery). Without this Swiper preventDefaults touchstart and blocks the
      // page from scrolling up/down while the finger is over a product card.
      touchStartPreventDefault: false,
      pagination: {
        el: gallery.querySelector('.product-card__dots'),
        clickable: true,
        type: 'bullets',
      },
    });
  }

  bindGalleryTouchLock(gallery) {
    if (gallery.dataset.touchLockBound === 'true') return;
    gallery.dataset.touchLockBound = 'true';

    let startX = 0;
    let startY = 0;
    let lockAxis = null;

    gallery.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      lockAxis = null;
    }, { passive: true });

    gallery.addEventListener('touchmove', (e) => {
      if (e.touches.length !== 1) return;

      const deltaX = Math.abs(e.touches[0].clientX - startX);
      const deltaY = Math.abs(e.touches[0].clientY - startY);

      // Decide the gesture axis once, biased towards letting the page scroll.
      // Anything vertical-ish locks to 'y' (never preventDefault) so up/down
      // scrolling keeps working; only a clearly horizontal drag swipes the gallery.
      if (lockAxis === null) {
        if (deltaY > 6 && deltaY >= deltaX) {
          lockAxis = 'y';
        } else if (deltaX > 8 && deltaX > deltaY) {
          lockAxis = 'x';
        }
      }

      // Only block native scrolling while actually swiping the gallery.
      if (lockAxis === 'x') {
        e.preventDefault();
      }
    }, { passive: false, capture: true });

    const resetLock = () => {
      lockAxis = null;
    };

    gallery.addEventListener('touchend', resetLock, { passive: true });
    gallery.addEventListener('touchcancel', resetLock, { passive: true });
  }


  checkTheBox(e) {

    if (e.key === "Enter") {
      e.preventDefault();

      const inputElement = e.target.querySelector("input");
      inputElement.checked = true;

      this.onProductCardChange(e, inputElement);
    }
  }

  onColorSwatchClick(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    const target = e.delegateTarget || e.target.closest('[data-action="color-swatch-select"]');
    if (!target) return;

    const productId = target.dataset.productId;
    if (!productId) {
      console.warn("No productId found on swatch:", target);
      return;
    }

    // ✅ Prevent reloading the already active swatch
    if (target.classList.contains("ColorSwatch--active")) {
      console.debug("Swatch already active, skipping reload.");
      return;
    }

    const url = `${window.routes.localeRootUrl}/search?view=product-card&q=id:${productId}`;
    console.debug("Fetching product card:", url);
    this.replaceProductCard(url, productId);
  }




  onProductCardChange(e, targetElement) {
    e.preventDefault();

    let target = targetElement || e.target;
    const productId = target.dataset.id;
    if (!productId) return;

    // ✅ Prevent reloading same variant if already active
    if (target.classList.contains("is-active") || target.querySelector("input:checked")) {
      console.debug("Product already selected, skipping reload.");
      return;
    }

    const url = `${window.routes.localeRootUrl}/search?view=product-card&q=id:${productId}`;
    this.replaceProductCard(url, productId);
  }


  async replaceProductCard(url, productId) {
    const loader = this.element.querySelector(".product-card__loader");

    try {
      // ✅ Show loader
      if (loader) loader.classList.add("is-visible");

      const response = await fetch(url);
      const responseText = await response.text();
      const htmlDocument = new DOMParser().parseFromString(responseText, "text/html");
      const newProductCard = htmlDocument.querySelector(`#product-card__${productId}`);

      if (!newProductCard) throw new Error("Product card not found in fetched HTML.");

      await new Promise(resolve => setTimeout(resolve, 400));

      // ✅ Replace content
      this.element.innerHTML = newProductCard.innerHTML;
    } catch (error) {
      console.error("Error fetching product:", error);
    } finally {
      // ✅ Hide loader
      if (loader) loader.classList.remove("is-visible");

      this.handleColorSwatch();
      this.initMobileGallery();
    }
  }


  handleColorSwatch() {
    this.swatchWrapper = this.element.querySelector(".product-card__color-selector");
    this.swatchMoreLabel = this.element.querySelector(".product-card__more-label");
    this.swatches = this.element.querySelectorAll(".product-card__selectbox");

    if (!this.swatchWrapper || this.swatches.length === 0 || !this.swatchMoreLabel) return;

    this.totalSwatches = this.swatches.length;
    this.visibleSwatchCount = this.totalSwatches;

    this.swatchWidth = 28;
    this.moreLabelWidth = 28;

    this.availableWidth = this.swatchWrapper.offsetWidth;
    if (!this.availableWidth) return;

    const remainingWidth = this.availableWidth - this.moreLabelWidth - 68;
    this.maxVisibleSwatches = Math.floor(remainingWidth / this.swatchWidth);

    this.maxVisibleSwatches = Math.min(this.totalSwatches, Math.max(1, this.maxVisibleSwatches));

    this.swatches.forEach(swatch => {
      swatch.style.display = "flex";
    });

    if (this.totalSwatches <= this.maxVisibleSwatches) {
      this.swatchMoreLabel.style.display = 'none';
      return;
    }

    let hiddenCount = 0;
    for (let i = this.totalSwatches - 1; i >= this.maxVisibleSwatches; i--) {
      this.swatches[i].style.display = 'none';
      hiddenCount++;
    }

    this.swatchMoreLabel.style.display = 'flex';
    const labelText = this.swatchMoreLabel.querySelector('.product-card__label-text');
    if (labelText) {
      labelText.innerText = '+' + hiddenCount;
    }

    this.visibleSwatchCount = this.totalSwatches - hiddenCount;
  }
}
customElements.define("product-card", ProductCard);

class RecommendedCollection extends HTMLElement {
  connectedCallback() {
    if (this._mounted) return;
    this._mounted = true;

    // Data
    this.productId = this.dataset.productId;
    this.intent = (this.dataset.intent || "complementary").toLowerCase(); // related | complementary
    this.limit = parseInt(this.dataset.limit || "8", 10);
    this.sectionId = this.dataset.sectionId || "helper-recommendations-section";
    this.blockId = this.dataset.blockId || "";
    this.source = (this.dataset.source || "search_discovery").toLowerCase(); // search_discovery | metafield
    this.slidesDesktop = parseInt(this.dataset.slidesDesktop || "4", 10); // 3 | 4

    // DOM refs
    this.wrapper = this.querySelector("#swiper-wrapper-" + this.blockId);
    this.swiperHost = this.querySelector("swiper-init");
    this.carousel = this.querySelector(".featured-collection__swiper");
    this.nav = this.querySelector(".pc__swiper-navigation");
    this.gridWrapper = this.querySelector("#grid-wrapper-" + this.blockId);

    if (!this.wrapper) return;

    // Prevent flash only for SD mode
    if (this.source !== "metafield") {
      this.prepareFrame();
    }

    this.revealOuterAnimatedContainer();

    if (this.source === "metafield") {
      this.handleMetafieldMode();
    } else {
      this.fetchAndRender();
    }
  }

  getLayout() {
    return (this.dataset.layout || "swiper").toLowerCase();
  }

  // Sync desktop grid with whatever is inside swiper wrapper
  syncGridFromSwiper() {
    if (!this.gridWrapper) return;

    const slides = this.wrapper.querySelectorAll(".swiper-slide");
    this.gridWrapper.innerHTML = "";

    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.remove("swiper-slide");
      this.gridWrapper.appendChild(clone);
    });
  }

  prepareFrame() {
    this.wrapper.innerHTML = "";
    this.classList.add("is-loading");
    if (this.carousel) this.carousel.style.visibility = "hidden";
    if (this.nav) this.nav.style.visibility = "hidden";
    if (this.gridWrapper) this.gridWrapper.style.visibility = "hidden";
  }

  revealFrame() {
    if (this.carousel) this.carousel.style.visibility = "";
    if (this.nav) this.nav.style.visibility = "";
    if (this.gridWrapper) this.gridWrapper.style.visibility = "";
    this.classList.remove("is-loading");
  }

  revealOuterAnimatedContainer() {
    const outer = this.closest(".animatedContent") || this.querySelector(".animatedContent");
    if (!outer) return;

    if (window.initAnimations || (window.Theme && window.Theme.Animations && window.Theme.Animations.init)) {
      return;
    }

    const io = new IntersectionObserver((entries, obs) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          outer.classList.add("is-visible");
          obs.disconnect();
          break;
        }
      }
    }, { threshold: 0.15 });

    io.observe(outer);
  }

  handleMetafieldMode() {
    const slides = this.wrapper.querySelectorAll(".swiper-slide");

    if (!slides.length) {
      const recSection = this.closest(".recommendations-collection");
      if (recSection) {
        recSection.classList.add("d-none");
        recSection.style.display = "none";
      }
      return;
    }

    this.updateNavVisibility(slides.length);
    this.initOrRevealAnimationsInside();

    if (this.swiperHost?.swiper?.update) {
      this.swiperHost.swiper.update();
    } else if (this.swiperHost) {
      this.swiperHost.dispatchEvent(new CustomEvent("swiper:refresh", { bubbles: true }));
    }

    if (this.getLayout() === "grid") {
      this.syncGridFromSwiper();
    }
  }

  buildUrl() {
    const params = new URLSearchParams({
      section_id: this.sectionId,
      product_id: String(this.productId),
      limit: String(this.limit),
      intent: this.intent
    });
    // Without the locale root Shopify answers in the default market: English labels on the cards and
    // product links that drop the shopper out of the market they were browsing.
    const localeRoot = window.routes?.localeRootUrl || "";
    return `${localeRoot}/recommendations/products?` + params.toString();
  }

  async fetchAndRender() {
    if (!this.productId) return;

    try {
      const html = await fetch(this.buildUrl(), { credentials: "same-origin" }).then(r => r.text());
      const tmp = document.createElement("div");
      tmp.innerHTML = html;

      const intentEcho = tmp.querySelector("[data-recommendations-intent]");
      const resolvedIntent = intentEcho?.getAttribute("data-recommendations-intent") || this.intent;
      this.dataset.resolvedIntent = resolvedIntent;

      let slides = tmp.querySelectorAll(".swiper-slide");

      if (!slides.length) {
        const cards = tmp.querySelectorAll("[data-product-id], product-card, .product-card, .featured-collection__cell");
        if (cards.length) {
          const created = [];
          cards.forEach(card => {
            if (!card.classList.contains("animatedContent")) card.classList.add("animatedContent");
            const slide = document.createElement("div");
            slide.className = "swiper-slide featured-collection__cell";
            slide.appendChild(card);
            created.push(slide);
          });
          slides = created;
        }
      }

      this.wrapper.innerHTML = "";

      if (!slides.length) {
        const recSection = this.closest(".recommendations-collection");
        if (recSection) {
          recSection.classList.add("d-none");
          recSection.style.display = "none";
        }
        console.warn("[RecommendedCollection] No recommendations found for product:", this.productId);
        return;
      }

      slides.forEach(s => this.wrapper.appendChild(s));

      this.updateNavVisibility(slides.length);
      this.initOrRevealAnimationsInside();

      if (this.swiperHost?.swiper?.update) {
        this.swiperHost.swiper.update();
      } else if (this.swiperHost) {
        this.swiperHost.dispatchEvent(new CustomEvent("swiper:refresh", { bubbles: true }));
      }

      if (this.getLayout() === "grid") {
        this.syncGridFromSwiper();
      }
    } catch (e) {
      console.error("[RecommendedCollection] fetch failed:", e);
      const recSection = this.closest(".recommendations-collection");
      if (recSection) {
        recSection.classList.add("d-none");
        recSection.style.display = "none";
      }
    } finally {
      this.revealFrame();
    }
  }

  updateNavVisibility(slideCount) {
    const isDesktop = window.matchMedia("(min-width: 1025px)").matches;

    if (!this.nav) return;

    if (isDesktop) {
      // Hide when slides are not more than visible desktop slides
      this.nav.style.display = slideCount <= this.slidesDesktop ? "none" : "";
    } else {
      // Mobile logic unchanged
      this.nav.style.display = slideCount <= 1 ? "none" : "";
    }
  }

  initOrRevealAnimationsInside() {
    if (typeof window.initAnimations === "function") {
      window.initAnimations(this);
      return;
    }
    if (window.Theme?.Animations?.init) {
      try { window.Theme.Animations.init(this); } catch (_) {}
      return;
    }

    const targets = this.wrapper.querySelectorAll(".animatedContent");
    if (!targets.length) return;

    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.2 });

    targets.forEach(t => io.observe(t));
  }
}

customElements.define("recommended-collection", RecommendedCollection);

class connectedProducts extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.header = this.element.querySelector('.product-info__connected-header');
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    if (this.element.querySelector('.swiper')) {
      new RevolutionSwiper(this.element.querySelector('.swiper'));
    }

    this.delegateElement.on('mouseover', '[data-action="hover-item"]', this.hoverItem.bind(this));
    this.delegateElement.on('mouseout', '[data-action="hover-item"]', this.hoverItem.bind(this));
    this.delegateElement.on('click', '[data-action="hover-item"]', this.clickItem.bind(this));
  }

  clickItem(event) {
    if (event.target.closest('.ColorSwatch')) return;

    const link = event.target.closest('[data-action="hover-item"]')?.querySelector('a');
    if (link) link.click();
  }

  hoverItem(event) {
    let name = event.target.getAttribute('data-color');
    if (event.type === 'mouseout') {
      name = this.element.dataset.colorOriginal;
    }

    if (name && this.header) {
      this.header.innerText = name;
    }
  }
}

customElements.define("connected-products", connectedProducts);

class CollectionShowcase extends HTMLElement {
  constructor() {
    super();

    this._onDesktopSwiperEvent = this._onDesktopSwiperEvent.bind(this);
    this.checkDesktopNavigation = this.checkDesktopNavigation.bind(this);
  }

  connectedCallback() {
    this.desktopSwiperEl = this.querySelector('[data-swiper-desktop]');

    // IMPORTANT:
    // This section uses <swiper-init>. The global SwiperInit/RevolutionSwiper already
    // initializes Swiper on those elements.
    // If we call `new Swiper(...)` here too, it becomes a double-init and often causes
    // iOS/mobile to jump back to the first slide after a few swipes.
    // So this class only manages UI (desktop nav visibility).

    if (this.desktopSwiperEl) {
      this.desktopSwiperEl.addEventListener('swiper:initialized', this._onDesktopSwiperEvent);
      this.desktopSwiperEl.addEventListener('swiper:slide-changed', this._onDesktopSwiperEvent);
      this.desktopSwiperEl.addEventListener('swiper:destroyed', this._onDesktopSwiperEvent);
    }

    this.checkDesktopNavigation();
    requestAnimationFrame(() => this.checkDesktopNavigation());
  }

  disconnectedCallback() {
    if (this.desktopSwiperEl) {
      this.desktopSwiperEl.removeEventListener('swiper:initialized', this._onDesktopSwiperEvent);
      this.desktopSwiperEl.removeEventListener('swiper:slide-changed', this._onDesktopSwiperEvent);
      this.desktopSwiperEl.removeEventListener('swiper:destroyed', this._onDesktopSwiperEvent);
    }
  }

  _onDesktopSwiperEvent() {
    // Run now + next frame so Swiper has time to apply disabled classes.
    this.checkDesktopNavigation();
    requestAnimationFrame(() => this.checkDesktopNavigation());
  }

  // ✅ Hide desktop navigation when both arrows are disabled
  checkDesktopNavigation() {
    if (!this.desktopSwiperEl) return;

    // navigation is inside the desktop swiper-init element
    const nav = this.desktopSwiperEl.querySelector('.collection-showcase--navigation');
    if (!nav) return;

    const disabledArrows = nav.querySelectorAll('.product-slider-arrow.swiper-button-disabled');
    const bothDisabled = disabledArrows.length === 2;

    nav.style.display = bothDisabled ? 'none' : '';
  }
}

customElements.define('collection-showcase', CollectionShowcase);

class CompareDrawer extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.style.display = "none";
  }

  connectedCallback() {
    this.overlay = this.parentElement.querySelector(".pageOverlayCompare");

    if (!this.overlay) {
      console.error("❌ .pageOverlayCompare not found in DOM");
      return;
    }

    this.overlay.addEventListener("click", () => this.closeDrawer());

    document.addEventListener("click", (e) => {
      const btn = e.target.closest('[data-toggle-id="compareDrawer"]');
      if (!btn) return;
      e.preventDefault();
      this.toggleDrawer();
    });

    // NEW: close when any popup requests drawers to close
    document.body.addEventListener('popup:close-drawer', () => this.closeDrawer());

    // NEW: close when any other drawer is being opened/toggled
    document.addEventListener("click", (e) => {
      const otherBtn = e.target.closest('[data-action="open-drawer"], [data-action="toggle-drawer"]');
      if (otherBtn && otherBtn.getAttribute('data-toggle-id') !== 'compareDrawer') {
        this.closeDrawer();
      }
    }, true); // capture to close before the other drawer starts opening

    // Hide completely when transition finishes closing
    this.addEventListener("transitionend", (e) => {
      if (!this.isOpen && e.propertyName === "transform") {
        this.style.display = "none";
      }
    });
    // When SearchBar opens, it emits 'drawer:close-other' -> close Compare
    document.body.addEventListener('drawer:close-other', () => this.closeDrawer());

    // Re-measure the descriptions when the columns change width, otherwise the height set for the
    // old width keeps the tables misaligned. Only worth doing while the drawer is actually open.
    this.onResize = () => {
      if (!this.isOpen) return;
      // timeout: wait for the resize to settle so we measure the final width, not every frame of it
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.refreshSwipers(), 150);
    };
    window.addEventListener("resize", this.onResize);

    // Web fonts land after first paint and change how many lines a description takes.
    document.fonts?.ready.then(() => {
      if (this.isConnected && this.isOpen) this.equalizeDescriptions();
    });
  }

  disconnectedCallback() {
    if (this.onResize) window.removeEventListener("resize", this.onResize);
    clearTimeout(this.resizeTimer);
    clearTimeout(this.settleTimer);
  }

  toggleDrawer() {
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    if (this.isOpen) return;

    if (window.Drawer && Drawer.active) Drawer.active.closeDrawer();

    // Close all popups (mirrors Drawer.openDrawer behavior)
    if (window.globalPopup) window.globalPopup.closeAllPopups?.();

    // Signal the ecosystem the same way popups do (Drawers listen to this)
    document.body.dispatchEvent(new CustomEvent('popup:close-drawer', { bubbles: true }));

    this.isOpen = true;


    // Tell SearchBar to close (it listens on document.body via Delegate)
    document.body.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));


    this.style.display = "block";
    this.offsetHeight; // force reflow

    this.setAttribute("aria-expanded", "true");
    this.classList.add("is-open");
    this.overlay.classList.add("is-visible");
    document.body.style.overflow = "hidden";

    const headerHeight =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue("--header-dynamic-height")
      ) || 0;
    const announcementHeight =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue("--announcement-dynamic-height")
      ) || 0;
    const offset = headerHeight + announcementHeight;
    this.style.top = `${offset}px`;
    this.style.height = `calc(100vh - ${offset}px)`;

    // 🚀 Trigger Swiper refresh *immediately* when transition starts
    this.addEventListener(
      "transitionstart",
      (e) => {
        if (e.propertyName === "transform" && this.isOpen) {
          requestAnimationFrame(() => this.refreshSwipers());
        }
      },
      { once: true }
    );

    // transitionstart is not a reliable trigger on its own: Firefox does not always deliver it for
    // this panel, and it never fires at all when transitions are disabled. Without a second trigger
    // the columns are never measured and the tables stay out of line. Measuring again is cheap and
    // harmless because equalizeDescriptions() clears its own values before it measures.
    requestAnimationFrame(() => {
      if (this.isOpen) this.refreshSwipers();
    });

    // Web fonts land after first paint and change how many lines a description takes.
    document.fonts?.ready.then(() => {
      if (this.isOpen) this.refreshSwipers();
    });

    // timeout: measure once more after the panel has finished sliding in, so late layout work
    // (images settling, a font swap) cannot leave a stale height behind
    clearTimeout(this.settleTimer);
    this.settleTimer = setTimeout(() => {
      if (this.isOpen) this.refreshSwipers();
    }, 400);
  }

  refreshSwipers() {
    // Equalise first. The heights we set here make the columns taller, and Swiper writes a fixed
    // height onto the wrapper from whatever it measures. Measuring before the heights are applied
    // leaves the wrapper too short, the content overflows it, and the drawer cannot scroll far
    // enough to reach the last rows.
    this.equalizeDescriptions();

    this.querySelectorAll(".swiper").forEach((el) => {
      const wrapper = el.querySelector(".swiper-wrapper");
      if (wrapper) wrapper.style.height = "100%";

      const s = el.swiper?.swiperElement;
      if (s) {
        s.updateSize();
        s.updateSlides();
        s.updateAutoHeight();
        s.update();
      } else if (typeof el.initializeSwiper === "function") {
        el.initializeSwiper();
      }
    });
  }

  // Each product column is its own swiper slide, so there is no shared grid to line the columns up.
  // The markup already renders the same rows in every column (the union of all the products' spec
  // labels), which fixes the row count. Two things still knock the columns out of line: the
  // description varies in line count, and a long value like the adjustable handle height wraps onto
  // a different number of lines from one product to the next. So measure the tallest description and
  // the tallest version of each row, and give every column those heights.
  equalizeDescriptions() {
    const columns = Array.from(this.querySelectorAll(".pdp-compare__bottom-content"));
    if (columns.length < 2) return;

    const tallestOf = (elements) =>
      elements.reduce((max, el) => Math.max(max, el.getBoundingClientRect().height), 0);

    // Clear previous values first, otherwise we would measure the heights we set last time.
    const cards = columns
      .map((col) => col.closest(".swiper-slide")?.querySelector("product-card"))
      .filter(Boolean);
    const descriptions = columns
      .map((col) => col.querySelector(".ProductDescription"))
      .filter(Boolean);
    const allRows = columns.flatMap((col) =>
      Array.from(col.querySelectorAll(".ProductSpecs > li"))
    );
    [...cards, ...descriptions, ...allRows].forEach((el) => {
      el.style.minHeight = "";
    });

    // The card sits above the description, so anything that makes one card taller than another -
    // gallery dots on a product with several images, a title that wraps - offsets every row below it.
    const tallestCard = tallestOf(cards);
    if (tallestCard) {
      cards.forEach((el) => {
        el.style.minHeight = `${Math.ceil(tallestCard)}px`;
      });
    }

    const tallestDescription = tallestOf(descriptions);
    if (tallestDescription) {
      descriptions.forEach((el) => {
        el.style.minHeight = `${Math.ceil(tallestDescription)}px`;
      });
    }

    // Rows are matched by position, which is safe because every column renders the same label list.
    const groupsPerColumn = columns.map((col) =>
      Array.from(col.querySelectorAll(".ProductMetafield"))
    );
    const groupCount = Math.max(...groupsPerColumn.map((groups) => groups.length));

    for (let groupIndex = 0; groupIndex < groupCount; groupIndex++) {
      const rowsPerColumn = groupsPerColumn.map((groups) =>
        Array.from(groups[groupIndex]?.querySelectorAll(".ProductSpecs > li") || [])
      );
      const rowCount = Math.max(...rowsPerColumn.map((rows) => rows.length));

      for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
        const row = rowsPerColumn.map((rows) => rows[rowIndex]).filter(Boolean);
        const tallestRow = tallestOf(row);
        if (!tallestRow) continue;
        row.forEach((el) => {
          el.style.minHeight = `${Math.ceil(tallestRow)}px`;
        });
      }
    }
  }

  closeDrawer() {
    if (!this.isOpen) return;
    clearTimeout(this.settleTimer);
    this.isOpen = false;
    this.setAttribute("aria-expanded", "false");
    this.classList.remove("is-open");
    this.overlay.classList.remove("is-visible");
    document.body.style.overflow = "";
  }
}

customElements.define("compare-drawer", CompareDrawer);


class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.searchInput = this.element.querySelector(
      '.faq__search-wrapper .faq_search-bar--input'
    );
    this.termsBlocks = document.querySelectorAll('.faq__block');
    this.noResultsElement = document.querySelector('#faq__results--none');
    this.termsBlocks = Array.from(this.element.querySelectorAll('.faq__block'));
    this.paginationContainer = this.element.querySelector(
      '.faq__pagination-pages'
    );
    this.pagination = this.element.querySelector('.faq__pagination');
    this.prevArrow = this.element.querySelector('.faq__pagination__prev');
    this.nextArrow = this.element.querySelector('.faq__pagination__next');
    this.clearSearchButton = this.element.querySelector(
      '[data-action="clear-search"]'
    );

    this.currentPage = 1;
    this.itemsPerPage = 18;
    this.bindEvents();
    this.initializeTabs();
    this.updatePagination();
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);
    this.delegateElement.on(
      'click',
      '[data-action="handle-tab-click"]',
      this.handleTabClick.bind(this)
    );
    this.delegateElement.on(
      'click',
      '[data-action="fill-search"]',
      this.fillSearch.bind(this)
    );
    this.delegateElement.on(
      'keyup',
      '[data-action="search-string"]',
      this.onInputListener
    );
    this.delegateElement.on(
      'click',
      '[data-action="switch-page"',
      this.handlePageClick.bind(this)
    );
    this.delegateElement.on(
      'click',
      '[data-action="clear-search"]',
      this.clearSearch.bind(this)
    );
  }

  initializeTabs() {
    const firstTab = this.element.querySelector('.linklist--tab');
    const firstBlock = this.element.querySelector('.faq__block');

    if (
      this.element.querySelector('.faq__block[aria-hidden="true"]') &&
      firstTab &&
      firstBlock
    ) {
      firstBlock.setAttribute('aria-hidden', 'false');
    }

    const swiperContainer = this.element.querySelector(
      '.faq__link-list .swiper'
    );
    const desktopContainer = this.element.querySelector(
      '.faq__link-list .faq-link-list-items-desktop'
    );

    if (swiperContainer) this.setFirstTabAsActive(swiperContainer);
    if (desktopContainer) this.setFirstTabAsActive(desktopContainer);
  }

  setFirstTabAsActive(container) {
    let activeTab = null;
    const tabs = container.querySelectorAll('.linklist--tab');
    const hasActive = Array.from(tabs).some((tab) =>
      tab.classList.contains('is-active')
    );
    if (!hasActive && tabs.length > 0) {
      tabs[0].classList.add('is-active');
      activeTab = tabs[0];
    }

    if (activeTab) this.showOnlySelectGroup(this.resolveGroupId(activeTab));
  }

  // Liquid's handleize, reimplemented so a tab label can be matched against the id a group was
  // given by that same filter. Lowercases, strips accents, and turns anything else into dashes.
  handleizeText(value) {
    return (value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // The tabs come from a menu, whose link targets stay in the source language, while a group's id is
  // built from its title, which does get translated. On a translated storefront the two no longer
  // match, the lookup fails and every group ends up hidden. So fall back to matching the tab's own
  // label against the group id, since both are translated together.
  resolveGroupId(tab) {
    const fromHref = (tab.getAttribute('href') || '').split('#')[1] || '';
    if (fromHref && this.element.querySelector(`[id="${fromHref}"]`)) return fromHref;

    const fromLabel = this.handleizeText(tab.textContent);
    if (fromLabel && this.element.querySelector(`[id="${fromLabel}"]`)) return fromLabel;

    return '';
  }

  showOnlySelectGroup(targetId) {
    const faqBlocks = this.element.querySelectorAll('.faq__block');

    // Nothing matched. Showing every group is wrong but readable, hiding all of them leaves the page
    // blank, which is what the translated storefront was doing.
    if (!targetId) {
      faqBlocks.forEach((block) => {
        block.style.display = 'block';
        block.setAttribute('aria-hidden', 'false');
      });
      return;
    }

    faqBlocks.forEach((block) => {
      if (block.id !== targetId) {
        block.style.display = 'none';
        block.setAttribute('aria-hidden', 'true');
      } else {
        block.style.display = 'block';
        block.setAttribute('aria-hidden', 'false');
      }
    });
  }

  updatePagination() {
    const visibleContents = Array.from(
      this.element.querySelectorAll(
        '.faq__block[aria-hidden="false"] .faq-section_content'
      )
    ).filter((content) => !content.classList.contains('is-hidden'));

    const totalPages = Math.ceil(visibleContents.length / this.itemsPerPage);

    if (totalPages <= 1) {
      this.pagination.style.display = 'none';
      return;
    }
    else this.pagination.style.display = 'flex';

    this.paginationContainer.innerHTML = '';
    for (let i = 1; i <= totalPages; i++) {
      const button = document.createElement('button');
      button.textContent = i < 10 ? `0${i}` : i;
      button.dataset.page = i;
      button.dataset.action = 'switch-page';
      button.classList.add('faq__pagination-page');
      if (i === this.currentPage) {
        button.classList.add('is-active');
      }
      this.paginationContainer.appendChild(button);
    }

    this.prevArrow.disabled = this.currentPage === 1;
    this.nextArrow.disabled = this.currentPage === totalPages;

    this.showPage(visibleContents, this.currentPage);
  }

  clearSearch() {
    this.searchInput.value = '';

    this.resetBlockVisibility();

    this.noResultsElement.setAttribute('aria-hidden', 'true');

    this.clearSearchButton.setAttribute('aria-hidden', 'true');
    this.clearSearchButton.style.display = 'none';
  }

  showPage(blocks, page) {
    const start = (page - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;

    blocks.forEach((block, index) => {
      if (index >= start && index < end) {
        block.style.display = '';
        block.setAttribute('aria-hidden', 'false');
      } else {
        block.style.display = 'none';
        block.setAttribute('aria-hidden', 'true');
      }
    });
  }

  handlePageClick(event) {
    const target = event.target.closest('[data-action="switch-page"]');
    if (!target) return;

    const action = target.dataset.page;

    if (action === 'prev' && this.currentPage > 1) {
      this.currentPage -= 1;
    } else if (
      action === 'next' &&
      this.currentPage <
      Math.ceil(
        this.element.querySelectorAll(
          '.faq__block[aria-hidden="false"] .faq-section_content'
        ).length / this.itemsPerPage
      )
    ) {
      this.currentPage += 1;
    } else if (!isNaN(parseInt(action, 10))) {
      this.currentPage = parseInt(action, 10);
    }

    this.updatePagination(); // Refresh pagination to show the selected page
  }

  fillSearch(e) {
    e.preventDefault();

    const searchTerm = e.target.textContent.trim();

    this.searchInput.value = searchTerm;

    this.handleSearch();
  }

  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();

    const noResultsContainer = this.querySelector('.faq__no-results__terms');
    let hasMatch = false;

    this.termsBlocks.forEach((block) => {
      if (block.getAttribute('aria-hidden') === 'true') return;
      const questions = block.querySelectorAll('.faq-section_content');
      let blockMatch = false;

      questions.forEach((questionWrapper) => {
        const questionText = questionWrapper.textContent.toLowerCase();
        if (questionText.includes(searchTerm)) {
          questionWrapper.setAttribute('aria-hidden', 'false');
          questionWrapper.classList.remove('is-hidden');
          blockMatch = true;
        } else {
          questionWrapper.setAttribute('aria-hidden', 'true');
          questionWrapper.classList.add('is-hidden');
        }
      });

      this.updatePagination();
      this.toggleBlockVisibility(block, blockMatch);

      if (blockMatch) hasMatch = true;
    });

    if (searchTerm == '') {
      this.clearSearchButton.style.display = 'none';
      this.clearSearchButton.setAttribute('aria-hidden', 'true');
    } else {
      this.clearSearchButton.style.display = 'block';
      this.clearSearchButton.setAttribute('aria-hidden', 'false');
    }

    if (searchTerm === '' || !hasMatch) {
      this.resetBlockVisibility();
      this.noResultsElement.setAttribute(
        'aria-hidden',
        searchTerm === '' || hasMatch ? 'true' : 'false'
      );
      if (searchTerm === '' || hasMatch) this.updatePagination();
      if (noResultsContainer)
        noResultsContainer.textContent = `"${searchTerm}"`;
    } else {
      this.noResultsElement.setAttribute('aria-hidden', 'true');
    }
  }

  toggleBlockVisibility(block, show) {
    block.classList.toggle('is-hidden', !show);
  }

  resetBlockVisibility() {
    this.termsBlocks.forEach((block) => {
      block
        .querySelectorAll('.faq-section_content')
        .forEach((content) => {
          content.setAttribute('aria-hidden', 'false');
          content.style.display = 'block';
        });
    });
    this.termsBlocks.forEach((block) => {
      block.classList.remove('is-hidden');
    });

    this.element.querySelectorAll('.faq-section_content.is-hidden').forEach((el) => {
      el.classList.remove('is-hidden');
    });

    this.updatePagination();
  }

  handleTabClick(event, target) {
    event.preventDefault();
    this.noResultsElement.setAttribute('aria-hidden', 'true');

    const targetId = this.resolveGroupId(target);

    const newUrl = `${window.location.pathname}#${target.getAttribute('href').split('#')[1] || ''}`;
    history.pushState(null, null, newUrl);

    if (!target.classList.contains('is-active')) {
      this.element
        .querySelectorAll('.linklist--tab')
        .forEach((tab) => tab.classList.remove('is-active'));
      target.classList.add('is-active');
    }

    this.showOnlySelectGroup(targetId);
    this.currentPage = 1;
    this.updatePagination();
    if (this.searchInput.value != '') this.handleSearch();
  }
}

customElements.define('faq-section', FAQSection);






class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);

    this.element.querySelectorAll('.RevolutionSelectbox')
      .forEach(box => new RevolutionSelectbox(box));

    this.element.addEventListener('change', (e) => {
      const target = e.target;
      if (target && target.matches('input[name="country_code"]')) {
        this.updateLanguageVisibility(target.value);
      }
    });

    this.observeModalVisibility();

    const initialCountry = this.element.querySelector('input[name="country_code"]:checked')?.value;
    if (initialCountry) {
      this.updateLanguageVisibility(initialCountry);
    }

    this.delegateBody = new Delegate(document.body);
    this.delegateBody.on(
      'click',
      '[data-action="open-drawer"], [data-action="toggle-drawer"], .DrawerToggle, [data-drawer-open], [data-toggle-id]:not([data-toggle-id="modal-country"]), [data-action="toggle-popup"]:not([aria-controls="modal-country"])',
      (event) => {
        const modal = document.getElementById('modal-country');
        if (modal && modal.getAttribute('aria-hidden') === 'false' && window.globalPopup?.closePopup) {
          window.globalPopup.closePopup(modal);
        }
      }
    );
  }

  updateLanguageVisibility(selectedCountry) {
    const lists = this.element.querySelectorAll('.country-languages [data-country]');
    lists.forEach((list) => {
      const match = list.dataset.country === selectedCountry;
      list.style.display = match ? 'block' : 'none';

      if (match) {
        const radios = list.querySelectorAll('input[name="language_code"]');
        if (radios.length) {
          const hasChecked = [...radios].some(r => r.checked);
          if (!hasChecked) radios[0].checked = true;
        }
        list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }


  observeModalVisibility() {
    const modal = document.getElementById('modal-country');
    if (!modal) return;

    const observer = new MutationObserver(() => {
      const isOpen = modal.getAttribute('aria-hidden') === 'false';
      if (isOpen) {
        IOSScrollLock.lock();
      } else {
        IOSScrollLock.unlock();
      }
    });

    observer.observe(modal, { attributes: true, attributeFilter: ['aria-hidden'] });
  }
}

customElements.define('localization-modal', LocalizationModal);






class SectionUSP extends HTMLElement {
  connectedCallback() {
    // Remove slides with empty text before any swiper/numbering logic
    this.removeMarkedSlidesAndSyncSwiper();

    if (this.hasAttribute("data-enable-number")) {
      this.numberSlidesManually();
    }

    this._lastBreakpoint = responsive.getCurrentBreakpoint();
    this._resizeHandler = () => {
      const bp = responsive.getCurrentBreakpoint();
      if (bp !== this._lastBreakpoint) {
        this._lastBreakpoint = bp;
        document.dispatchEvent(new CustomEvent("breakpoint:changed", {
          detail: { currentBreakpoint: bp }
        }));
      }
    };
    window.addEventListener("resize", this._resizeHandler);

    // Apply transformations
    this.processSlides();
  }

  disconnectedCallback() {
    if (this._resizeHandler) {
      window.removeEventListener("resize", this._resizeHandler);
    }
  }

  numberSlidesManually() {
    const slides = this.querySelectorAll(".swiper-slide");
    slides.forEach((slide, i) => {
      const numEl = slide.querySelector(".usp-number__current");
      if (numEl) numEl.textContent = i + 1;
    });
  }

  removeMarkedSlidesAndSyncSwiper() {
    const markers = this.querySelectorAll('[data-hide-slide="true"]');
    if (!markers.length) return;

    const slidesToRemove = new Set();
    markers.forEach((marker) => {
      const slide = marker.closest('.swiper-slide');
      if (slide) slidesToRemove.add(slide);
    });

    if (!slidesToRemove.size) return;

    slidesToRemove.forEach((slide) => slide.remove());

    const updateNow = () => {
      const swiperHost = this.querySelector('swiper-init');
      const swiperInstance = swiperHost?.swiper?.swiperElement;
      if (!swiperInstance || typeof swiperInstance.update !== 'function') return false;

      swiperInstance.update();
      swiperInstance.updateSize?.();
      swiperInstance.updateSlides?.();
      swiperInstance.updateProgress?.();
      swiperInstance.updateSlidesClasses?.();

      const slideCount = swiperInstance.slides?.length || 0;
      if (slideCount) {
        const safeIndex = Math.min(swiperInstance.activeIndex || 0, slideCount - 1);
        swiperInstance.slideTo?.(safeIndex);
      }

      return true;
    };

    // If swiper isn't initialized yet, wait for the init event.
    if (!updateNow()) {
      this.addEventListener('swiper:initialized', () => {
        updateNow();
        if (this.hasAttribute('data-enable-number')) {
          this.numberSlidesManually();
        }
      }, { once: true });
    }
  }

  processSlides() {
    const slides = this.querySelectorAll(".swiper-slide");
    slides.forEach(slide => {
      const wrapper = slide.querySelector(".section-usp__link");
      if (!wrapper) return;

      const dataLink = wrapper.dataset.link;
      if (!dataLink) return;

      const videoBlock = wrapper.querySelector("video-block");

      if (videoBlock) {
        // --- Case: slide has video ---
        const afterNodes = [];
        let node = videoBlock.nextSibling;
        while (node) {
          afterNodes.push(node);
          node = node.nextSibling;
        }

        if (afterNodes.length) {
          const link = document.createElement("a");
          link.href = dataLink;
          afterNodes.forEach(n => link.appendChild(n));
          wrapper.appendChild(link);
        }

      } else {
        // --- Case: slide is image ---
        const a = document.createElement("a");
        a.href = dataLink;
        a.className = wrapper.className;
        [...wrapper.attributes].forEach(attr => {
          if (attr.name !== "class" && attr.name !== "data-link") {
            a.setAttribute(attr.name, attr.value);
          }
        });
        a.innerHTML = wrapper.innerHTML;
        wrapper.replaceWith(a);
      }
    });
  }
}

customElements.define("section-usp", SectionUSP);


class IOSScrollLock {
  static _preventScroll = null;
  static _preventGesture = null;
  static _lockCount = 0;

  static lock() {
    if (this._lockCount === 0) {
      this._preventScroll = (e) => {
        if (e.target.closest('.Drawer--wrapper') || e.target.closest('[data-scrollable]')) return;
        e.preventDefault();
      };
      document.addEventListener('touchmove', this._preventScroll, { passive: false, capture: true });

      this._preventGesture = (e) => e.preventDefault();
      document.addEventListener('gesturestart', this._preventGesture);
    }
    this._lockCount++;
  }

  static unlock() {
    if (this._lockCount < 0) return;
    this._lockCount--;

    if (this._lockCount === 0) {
      if (this._preventScroll) {
        document.removeEventListener('touchmove', this._preventScroll, { passive: false, capture: true });
        this._preventScroll = null;
      }

      if (this._preventGesture) {
        document.removeEventListener('gesturestart', this._preventGesture);
        this._preventGesture = null;
      }
    }
  }
}

class QuoteSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.progressBar = this.element.querySelector(".quote-section--progress");

    this.setSwipers();
  }

  setSwipers() {
    const mainSwiperClass = this.element.querySelector(".swiper-main");
    const logoSwiperClass = this.element.querySelector(".swiper-logo");

    if (!mainSwiperClass || !logoSwiperClass) return;

    this.mainSwiper = mainSwiperClass.swiper.swiperElement;
    this.logoSwiper = logoSwiperClass.swiper.swiperElement;
  }

  connectedCallback() {
    if (!this.logoSwiper) return;

    // Reset autoplay every time a slide change happens
    this.logoSwiper.on("slideChange", () => {
      this.handleSlideChange();
      this.restartAutoplay(); // <- reset timer to 0
    });

    this.logoSwiper.on("slideChangeTransitionEnd", this.startAnimation.bind(this));

    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    this.mainSwiper?.destroy();
    this.logoSwiper?.destroy();
  }

  handleSlideChange() {
    const logoSwiperEl = this.logoSwiper.el;

    requestAnimationFrame(() => {
      const activeLogoSlide = logoSwiperEl.querySelector(".swiper-logo .swiper-slide-active");
      const id = activeLogoSlide.dataset.blockId;
      const logoIndex = activeLogoSlide.dataset.swiperSlideIndex;

      const newMainSlide =
        this.element.querySelector(`.swiper-main .swiper-slide[data-block-id="${id}"][data-swiper-slide-index="${logoIndex}"]`) ||
        this.element.querySelector(`.swiper-main .swiper-slide[data-block-id="${id}"]`);

      const index = newMainSlide.dataset.swiperSlideIndex;
      this.mainSwiper.slideTo(index);
    })
  }

  startAutoplay() {
    if (!this.logoSwiper) return;

    const delay = Number(this.element.dataset.delay) || 3000;

    this.startAnimation();
    this.stopAutoplay();

    this._autoplayId = setInterval(() => {
      this.progressBar.classList.remove("in-progress");
      this.logoSwiper.slideNext();
    }, delay);
  }

  stopAutoplay() {
    if (!this._autoplayId) return;

    this.progressBar.classList.remove("in-progress");
    clearInterval(this._autoplayId);
    this._autoplayId = null;
  }

  restartAutoplay() {
    this.startAutoplay();
  }

  startAnimation() {
    this.progressBar.classList.add("in-progress");
  }
}


customElements.define('quote-section', QuoteSection);









class SectionCompare extends HTMLElement {
  constructor() {
    super();
    this.delegate = new Delegate(this);
    this.bindEvents();
    this.responsive = new Responsive(false, true);
    this.updateSwiper = this.updateSwiper.bind(this);
  }

  connectedCallback() {
    this.swiperEl = this.querySelector("swiper-init");

    if (this.swiperEl) {
      this.updateSwiper();

      this.resizeListener = this.responsive.addResizeListener(this, this.updateSwiper);
      window.addEventListener("resize", this.updateSwiper);
    }
  }

  disconnectedCallback() {
    if (this.resizeListener) this.resizeListener.removeResizeListener();
    window.removeEventListener("resize", this.updateSwiper);
    this.destroySwiper();
  }

  updateSwiper() {
    if (!this.swiperEl) return;

    const breakpoint = this.responsive.getCurrentBreakpoint();
    const isMobile = ["phone", "pocket", "tablet"].includes(breakpoint);
    const isDesktop = ["desktop", "lap_and_up", "desktop_wide"].includes(breakpoint);

    if (isMobile && !this.swiperEl.swiper) {
      console.log("📱 SectionCompare: init mobile swiper");
      this.swiperEl.initSwiper();
    }

    if (isDesktop && this.swiperEl.swiper) {
      console.log("🧹 SectionCompare: destroy desktop swiper");
      this.destroySwiper();
    }
  }

  destroySwiper() {
    if (this.swiperEl && this.swiperEl.swiper) {
      this.swiperEl.destroy();

      const wrapper = this.swiperEl.querySelector(".swiper-wrapper");
      if (wrapper) {
        wrapper.style.transform = "";
        wrapper.style.transition = "";
      }
    }
  }

  bindEvents() {
    this.delegate.on('click', '[data-action="open-compare-zoom"]', (e) => {
      e.preventDefault();
      const img = e.target.closest('[data-action="open-compare-zoom"]');
      if (!img) return;

      const isCompare = this.closest('section-compare') || img.closest('section-compare');

      this.ensurePhotoSwipeLoaded().then(() => {
        const zoom = new RevolutionImageZoom(document.body, null);
        const items = zoom.createPhotoSwipeItemsFromImages([img]);
        zoom.createPhotoSwipeInstance(items, 0);

        if (isCompare) {
          const pswp = document.querySelector('.pswp');
          pswp?.classList.add('compare-mode');

          zoom.photoSwipeInstance.listen('close', () => {
            pswp?.classList.remove('compare-mode');
          });
        }
      });
    });

    setTimeout(() => {
      const pswpUI = document.querySelector(".pswp__ui");
      if (!pswpUI) return;

      pswpUI
        .querySelectorAll(".pswp__button--next, .pswp__button--prev")
        .forEach((btn) => (btn.style.display = "none"));

      const closeBtn = pswpUI.querySelector(".pswp__button--close");
      if (closeBtn) {
        closeBtn.style.position = "absolute";
        closeBtn.style.top = "1rem";
        closeBtn.style.right = "1rem";
        closeBtn.style.left = "unset";
        closeBtn.style.margin = 0;
        closeBtn.style.zIndex = "9999";
        closeBtn.style.display = "block";
      }

      const pswpImg = document.querySelector(".pswp__img");
      if (pswpImg) {
        pswpImg.style.objectFit = "contain";
        pswpImg.style.maxHeight = "100vh";
        pswpImg.style.margin = "auto";
        pswpImg.style.display = "block";
      }

      pswpUI.classList.remove("pswp__ui--hidden");
    }, 200);
  }

  ensurePhotoSwipeLoaded() {
    return new Promise((resolve, reject) => {
      if (window.PhotoSwipe) {
        resolve();
      } else {
        loadScript(window.theme.pswpScript, resolve);
      }
    });
  }
}

customElements.define("section-compare", SectionCompare);

class SectionCustomCompare extends HTMLElement {
  constructor() {
    super();
    this.delegate = new Delegate(this);
    this.bindEvents(); // even if empty now, keep structure
    this.responsive = new Responsive(false, true);
    this.updateSwiper = this.updateSwiper.bind(this);
  }

  connectedCallback() {
    this.swiperEl = this.querySelector("swiper-init");

    if (this.swiperEl) {
      this.updateSwiper();

      // REMOVE window resize — only use your responsive helper
      this.resizeListener = this.responsive.addResizeListener(this, this.updateSwiper);
    }
  }

  disconnectedCallback() {
    if (this.resizeListener) this.resizeListener.removeResizeListener();
    this.destroySwiper();
  }

  updateSwiper() {
    if (!this.swiperEl) return;

    const breakpoint = this.responsive.getCurrentBreakpoint();
    const isMobile = ["phone", "pocket", "tablet"].includes(breakpoint);
    const isDesktop = ["desktop", "lap_and_up", "desktop_wide"].includes(breakpoint);

    // ----- MOBILE -----
    if (isMobile) {
      // ADD CLASS FIRST — critical
      this.classList.add("swiper-active");

      // init only if NOT already active
      if (!this.swiperEl.swiper) {
        this.swiperEl.initSwiper();
      }
      return;
    }

    // ----- DESKTOP -----
    if (isDesktop) {
      if (this.swiperEl.swiper) {
        this.destroySwiper();
      }
      this.classList.remove("swiper-active");
    }
  }


  destroySwiper() {
    if (this.swiperEl && this.swiperEl.swiper) {
      this.swiperEl.destroy();

      const wrapper = this.swiperEl.querySelector(".swiper-wrapper");
      if (wrapper) {
        wrapper.style.transform = "";
        wrapper.style.transition = "";
      }
    }
  }

  bindEvents() {
    // No photoswipe logic here anymore, left intentionally empty for structure
  }
}

customElements.define("section-custom-compare", SectionCustomCompare);


class GlobalFooterHeight {
  constructor() {
    this.root = document.documentElement;
    this.update = this.update.bind(this);

    addEventListener('scroll', this.update, { passive: true });
    addEventListener('resize', this.update);

    this.loop();
  }

  update() {
    const footer = document.querySelector('.footer-wrapper');
    const h = footer ? footer.offsetHeight : 0;

    this.root.style.setProperty('--footer-dynamic-height', `${h}px`);
  }

  loop() {
    this.update();
    requestAnimationFrame(this.loop.bind(this));
  }
}

new GlobalFooterHeight();


// Top offset class used in drawers
class GlobalTopOffset {
  constructor() {
    this.root = document.documentElement;
    this.update = this.update.bind(this);
    addEventListener('scroll', this.update, { passive: true });
    addEventListener('resize', this.update);
    this.loop();
  }

  height(el) {
    if (!el) return 0;
    const r = el.getBoundingClientRect();
    return Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
  }

  update() {
    const h = this.height(document.querySelector('#header'));
    const a = this.height(document.querySelector('.announcement-bar'));
    this.root.style.setProperty('--global-top-offset', `${h + a}px`);
  }

  loop() {
    this.update();
    requestAnimationFrame(this.loop.bind(this));
  }
}

new GlobalTopOffset();

class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.toggleButtons = this.element.querySelector('.main-search__toggle-buttons');
    this.searchTypes = [
      { id: 'collection__main-grid-products', type: 'product' },
      { id: 'collection__main-grid-articles', type: 'article' },
    ];
  }

  connectedCallback() {
    const url = new URL(window.location.href);
    if (url.pathname.startsWith('/search') && !url.searchParams.has('type')) {
      url.searchParams.set('type', 'product');
      window.location.replace(url.toString());
    }

    this.filterBar = this.element.querySelector('.collection__header');
    this.loadType = this.element.dataset.load;
    new AddToCart(this.element);
    this.delegateElement = new Delegate(this.element);

    this.filterMobileButton = document.querySelector('.collection__filter-bar-button.not_desktop');
    this.filtersEnabledEl = document.querySelector('.collection__nav-filter-bar');
    this.scrollBound = false;

    if (this.filtersEnabledEl) {
      this.filtersEnabled = this.filtersEnabledEl.getAttribute('data-filter-enabled');
      if (this.filtersEnabled === 'true') this.checkGridHeigth();
      else if (this.filterMobileButton) this.filterMobileButton.style.display = 'none';
    }

    this.toggleProductsBtn = this.element.querySelector('[data-action="toggle-products"]');
    this.toggleArticlesBtn = this.element.querySelector('[data-action="toggle-articles"]');

    this.bindEvents();
    this.prefetchGrids();
    this.setInitialGridVisibility();
    this.updateSearchTotals();
  }

  /** Simplifies building a filtered URL that only includes safe params */
  getFilteredSearchUrl(typeOverride = null) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const filtered = new URLSearchParams();

    const keep = ['q', 'type', 'sort_by'];
    keep.forEach((key) => {
      if (params.has(key)) filtered.set(key, params.get(key));
    });

    if (typeOverride) filtered.set('type', typeOverride);
    filtered.set('page', '1');

    url.search = filtered.toString();
    return url.toString();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const productBtn = e.target.closest('[data-action="toggle-products"]');
      const articleBtn = e.target.closest('[data-action="toggle-articles"]');

      if (productBtn) {
        e.preventDefault();
        this.showProducts(e);
      } else if (articleBtn) {
        e.preventDefault();
        this.showArticles(e);
      }
    });

    this.delegateElement.on('click', '[data-action="toggle-collection"]', this.toggleGrid.bind(this));
    window.addEventListener('popstate', this.toggleGridBasedOnUrl.bind(this));

    if (this.scrollBound) return;
    this.onScrollListener = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollListener);
    this.scrollBound = true;
  }

  async prefetchGrids() {
    // The "no results" template renders neither the toggle buttons, the grids, nor the
    // total counters, so there is nothing to prefetch. Bailing out here also avoids a
    // wasted fetch and the TypeError thrown when reading the (absent) counter nodes.
    if (!this.toggleButtons) return;

    const url = new URL(window.location.href);
    const params = url.searchParams;
    const currentType = params.get('type') || 'product';
    const currentPage = params.get('page') || 0;

    let productHtml, articleHtml;

    if (currentType === 'product' || (currentPage > 1 && !document.querySelector('.active-filters__item'))) {
      const articleUrl = this.getFilteredSearchUrl('article');
      articleHtml = await fetch(articleUrl).then((res) => res.text());
      productHtml = document.documentElement.innerHTML;
    }

    if (currentType === 'article' || currentPage > 1) {
      const productUrl = this.getFilteredSearchUrl('product');
      productHtml = await fetch(productUrl).then((res) => res.text());
      if (!articleHtml) articleHtml = document.documentElement.innerHTML;
    }

    const productDoc = new DOMParser().parseFromString(productHtml, 'text/html');
    const articleDoc = new DOMParser().parseFromString(articleHtml, 'text/html');

    const productGrid = productDoc.querySelector('#collection__main-grid-products');
    if (productGrid && currentType === 'article') {
      const target = document.querySelector('#collection__main-grid-products');
      if (target) target.innerHTML = productGrid.innerHTML;
    }

    const productFilters = productDoc.querySelector('.block-filters-bar');

    const targetFilters = document.querySelector('.block-filters-bar');


    if (productFilters && targetFilters && currentType === 'article') {
      targetFilters.innerHTML = productFilters.innerHTML;
      const collFilterItemsDesk = document.querySelector('.collection__filter-items--desktop');
      const collFilterBtnMob = document.querySelector('.collection__filter-bar-button');
      if (collFilterItemsDesk) {
        collFilterItemsDesk.style.display = 'none';
        collFilterItemsDesk.setAttribute('aria-hidden', 'true');
      }

      if (collFilterBtnMob) {
        collFilterBtnMob.style.display = 'none';
        collFilterBtnMob.setAttribute('aria-hidden', 'true');
      }
    }



    const articleGrid = articleDoc.querySelector('#collection__main-grid-articles');
    if (articleGrid && currentType === 'product') {
      const target = document.querySelector('#collection__main-grid-articles');
      if (target) target.innerHTML = articleGrid.innerHTML;
    }

    const totalProductsTarget = document.querySelector('.main-search__total-products-num');
    let totalProductsEl;

    if (currentPage > 1 && document.querySelector('.active-filters__item')) {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      params.set('page', '1');
      url.search = params.toString();

      const productUrl = url.toString();
      const productHtmlForTotal = await fetch(productUrl).then((res) => res.text());
      const productHtmlForTotalDoc = new DOMParser().parseFromString(productHtmlForTotal, 'text/html');

      totalProductsEl = productHtmlForTotalDoc.querySelector('.main-search__total-products-num');
      if (totalProductsEl) {
        totalProductsTarget.innerHTML = totalProductsEl.innerHTML;
      }
    } else {

      totalProductsEl = productDoc.querySelector('.main-search__total-products-num');
      if (totalProductsEl) {
        totalProductsTarget.innerHTML = totalProductsEl.innerHTML;
      }
    }

    const totalArticlesEl = articleDoc.querySelector('.main-search__total-articles-num');

    const totalArticlesTarget = document.querySelector('.main-search__total-articles-num');

    if (totalArticlesEl && totalArticlesTarget) {
      totalArticlesTarget.innerHTML = totalArticlesEl.innerHTML;
    }

    if (totalProductsTarget.textContent == 0)
      document.querySelector('.main-search__product-button').style.display = 'none';
    else if (totalArticlesTarget.textContent == 0)
      document.querySelector('.main-search__article-button').style.display = 'none';

    if (currentType === 'article') this.handleSortForArticles();

    this.cachedTotals = {
      product: totalProductsEl ? totalProductsEl.innerHTML : null,
      article: totalArticlesEl ? totalArticlesEl.innerHTML : null,
    };
  }

  setInitialGridVisibility() {
    const url = new URL(window.location.href);
    const type = url.searchParams.get('type') || 'product';

    const productGrid = this.element.querySelector('#collection__main-grid-products');
    const articleGrid = this.element.querySelector('#collection__main-grid-articles');

    if (type === 'article') {
      if (productGrid) productGrid.setAttribute('aria-hidden', 'true');
      if (articleGrid) articleGrid.setAttribute('aria-hidden', 'false');
    } else {
      if (productGrid) productGrid.setAttribute('aria-hidden', 'false');
      if (articleGrid) articleGrid.setAttribute('aria-hidden', 'true');
    }

    if (this.filterMobileButton) {
      this.filterMobileButton.style.display = type === 'article' ? 'none' : '';
      this.filterMobileButton.setAttribute('aria-hidden', type === 'article');
    }

    const filtersWrapperDesk = this.element.querySelector('.collection__filter-items--desktop');
    const activeFilters = this.element.querySelector('.active-filters');

    if (filtersWrapperDesk) {
      filtersWrapperDesk.style.display = type === 'article' ? 'none' : '';
      filtersWrapperDesk.setAttribute('aria-hidden', type === 'article');
    }

    if (activeFilters) {
      activeFilters.style.display = type === 'article' ? 'none' : '';
      activeFilters.setAttribute('aria-hidden', type === 'article');
    }

  }

  updateSearchTotals() {
    if (!this.cachedTotals) return;
    const { product, article } = this.cachedTotals;

    if (product) {
      const el = document.querySelector('.main-search__total-products-num');
      if (el) el.innerHTML = product;
    }

    if (article) {
      const el = document.querySelector('.main-search__total-articles-num');
      if (el) el.innerHTML = article;
    }
  }

  toggleGridByType(type) {
    const gridsToHide = this.element.querySelectorAll('.collection__grid--inner');
    gridsToHide.forEach((g) => g.setAttribute('aria-hidden', 'true'));

    const gridToShow = this.element.querySelector(
      type === 'product' ? '#collection__main-grid-products' : '#collection__main-grid-articles'
    );
    if (gridToShow) gridToShow.setAttribute('aria-hidden', 'false');

    if (this.filterMobileButton) {
      this.filterMobileButton.style.display = type === 'article' ? 'none' : '';
      this.filterMobileButton.setAttribute('aria-hidden', type === 'article');
    }

    const filtersWrapperDesk = this.element.querySelector('.collection__filter-items--desktop');

    if (filtersWrapperDesk) {
      filtersWrapperDesk.style.display = type === 'article' ? 'none' : '';
      filtersWrapperDesk.setAttribute('aria-hidden', type === 'article');
    }

    const collectionFilterBarButtonMob = this.element.querySelector('.collection__filter-bar-button');

    if (collectionFilterBarButtonMob) {
      collectionFilterBarButtonMob.style.display = type === 'article' ? 'none' : '';
      collectionFilterBarButtonMob.setAttribute('aria-hidden', type === 'article');
    }

    const activeFilters = this.element.querySelector('.block-filters-bar .active-filters');

    if (activeFilters) {
      activeFilters.style.display = type === 'article' ? 'none' : '';
      activeFilters.setAttribute('aria-hidden', type === 'article');
    }


    if (this.toggleProductsBtn && this.toggleArticlesBtn) {
      if (type === 'product') {
        this.toggleProductsBtn.classList.add('active');
        this.toggleArticlesBtn.classList.remove('active');
      } else {
        this.toggleProductsBtn.classList.remove('active');
        this.toggleArticlesBtn.classList.add('active');

        document.querySelector('filters-custom').closeAllDrawers();
      }
    }

    if (type === 'article') this.handleSortForArticles();
  }

  handleSortForArticles() {
    const url = new URL(window.location.href);
    if (url.searchParams.has('sort_by')) {
      url.searchParams.delete('sort_by');
      history.replaceState({}, '', url.toString());
    }

    const checked = document.querySelector('.collection__sort-element--price input[name="sort_by"]:checked');
    if (!checked) return;

    const firstOptionTextEl =
      this.element.querySelector('.collection__sort-text');

    const labelText = firstOptionTextEl.textContent.trim();

    document.querySelectorAll('.collection__filter-current-sort-option').forEach(el => {
      el.textContent = labelText;
    });

    document.querySelector('#collection__sort-drawer--desktop [name=sort_by]').checked = true;
    document.querySelector('.collection__sort-items.Drawer--Content [name=sort_by]').checked = true;
  }

  checkGridHeigth() {
    const resultsGrid = this.element.querySelector('#collection__main-grid');
    if (!resultsGrid) return;

    const gridHeight = resultsGrid.offsetHeight;
    const viewportHeight = window.innerHeight;

    if (gridHeight < viewportHeight && this.filterMobileButton) {
      this.filterMobileButton.classList.add('visible');
    }
  }

  onScroll() {
    if (this.filtersEnabled === 'true') this.handleFilterMobileButton();
    if (this.filtersEnabled === 'true' || this.sortEnabled === 'true') this.handleFilterBarShrink();
  }

  handleFilterBarShrink() {
    const filtersIconsEl = document.querySelector('.filters-bar__products-info');
    if (!filtersIconsEl || !responsive.matchesBreakpoint('lap_and_up')) return;

    const rect = this.element.getBoundingClientRect();
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height-fixed').trim(),
      10
    );

    if (rect.top <= headerHeight) filtersIconsEl.classList.add('shrink');
    else filtersIconsEl.classList.remove('shrink');
  }

  handleFilterMobileButton() {
    if (!this.filterMobileButton) return;

    const rect = this.element.getBoundingClientRect();
    const containerRect = document
      .querySelector('#collection__grid-wrapper[aria-hidden="false"]')
      ?.getBoundingClientRect();
    if (!containerRect) return;
 
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height-fixed').trim(),
      10
    );

    const filterButtonRect = this.filterMobileButton.getBoundingClientRect();
    const hasReachedBottom = filterButtonRect.bottom >= containerRect.bottom;

    if (rect.top <= headerHeight + 30 && !hasReachedBottom) {
      this.filterMobileButton.classList.add('visible');
    } else {
      this.filterMobileButton.classList.remove('visible');
    }
  }

  removeScrollListener() {
    if (this.onScrollListener) {
      window.removeEventListener('scroll', this.onScrollListener);
      this.scrollBound = false;
    }
  }

  toggleGrid(e) {
    const target = e.target.closest('[data-action="toggle-collection"]');
    const id = target.getAttribute('aria-controls');
    const gridsToHide = this.element.querySelectorAll('.collection__grid[aria-hidden="false"]');
    const gridToShow = this.element.querySelector(`#${id}`);

    gridsToHide.forEach((grid) => grid.setAttribute('aria-hidden', 'true'));
    if (gridToShow) gridToShow.setAttribute('aria-hidden', 'false');

    if (this.filterMobileButton) {
      this.filterMobileButton.style.display = id === 'collection-article' ? 'none' : '';
    }
  }

  toggleGridBasedOnUrl() {
    const url = new URL(window.location.href);
    const type = url.searchParams.get('type') || 'product';
    this.toggleGridByType(type);
  }

  showArticles(e) {
    e.preventDefault();
    this.toggleGridByType('article');
    const url = this.getFilteredSearchUrl('article');
    history.pushState({}, '', url);
  }

  showProducts(e) {
    e.preventDefault();
    this.toggleGridByType('product');
    const url = this.getFilteredSearchUrl('product');
    history.pushState({}, '', url);
  }
}

customElements.define('search-component', MainSearch);

// PDP Upsell Section
class PDPUpsellSection extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define('pdp-upsell-section', PDPUpsellSection);

